{
  "languages": {
    "en-US": {
      "general_conversations": "Conversations",
      "general_privacy": "Privacy",
      "general_report": "Report",
      "general_terms": "Terms",
      "general_loading": "Loading...",
      "general_contacts": "Contacts",
      "general_featured_groups": "Featured Groups",
      "general_edit": "Edit",
      "general_discard_btn": "Discard",
      "general_save_btn": "Save",
      "general_ok": "Ok",
      "general_submit_btn": "Submit",
      "general_cancel_btn": "Cancel",
      "general_bio": "Bio",
      "general_join_with_google": "Join with Google",
      "general_processing": "Processing",
      "general_uploading": "Uploading",
      "general_upload": "Upload",
      "general_confirm": "Confirm",
      "general_remove": "Remove",
      "general_delete": "Delete",
      "general_update": "Update",
      "general_continue": "Continue",
      "general_female_gender": "Female",
      "general_male_gender": "Male",
      "general_prefer_not_to_say_gender": "Prefer not to say",
      "general_birthday": "Birthday",
      "general_done": "Done",
      "general_home": "Home",
      "general_profile": "Profile",
      "general_user_profile": "User Profile",
      "general_account": "Account",
      "general_legal": "Legal",
      "general_logout": "Logout",
      "general_back": "Back",
      "general_private_conversation": "Private Conversations",
      "general_inbox": "Inbox",
      "general_delete_account": "Delete Account",
      "general_send_post": "Post",
      "general_add": "Add",
      "general_insert": "Insert",
      "general_all_btn": "All",
      "general_curated_btn": "SELECT",
      "general_none_btn": "None",
      "general_sending_post": "Sending post",
      "general_cancel_sending_post": "Cancel sending post",
      "general_sending_comment": "Sending comment",
      "general_cancel_sending_comment": "Cancel sending comment",
      "general_erase": "Erase",
      "general_retry": "Retry",
      "general_confirmation_modal_sr_label": "Confirmation Modal",
      "general_search_placeholder": "Search...",
      "get_app": "Get Mobile App",
      "auth_modal_powered_by": "Powered by SELECT",
      "auth_modal_close_aria_label": "Close",
      "auth_modal_desc": "SELECT is better on the app",
      "auth_modal_download_app": "Download Select",
      "auth_modal_continue_app": "Continue with app",
      "auth_modal_continue_web": "Continue with web",
      "auth_modal_inapp_title_android": "Open in the native browser for the full experience",
      "auth_modal_inapp_title_ios": "Open in Safari for the full experience",
      "auth_modal_inapp_desc_android": "This in-app browser can block sign-in. Switch to the native browser in two taps.",
      "auth_modal_inapp_desc_ios": "This in-app browser can block sign-in and payments. Switch to Safari in two taps.",
      "auth_modal_inapp_step_1": "Tap the %1$s in the top right corner",
      "auth_modal_inapp_step_1_highlight": " menu",
      "auth_modal_inapp_step_2": "Choose %1$s",
      "auth_modal_inapp_step_2_highlight_android": "Open in the native browser",
      "auth_modal_inapp_step_2_highlight_ios": "Open in Safari for the full experience",
      "auth_modal_inapp_copy_link": "Copy link instead",
      "auth_modal_inapp_copy_link_success_toast": "Link copied",
      "auth_modal_inapp_copy_link_fail_toast": "Unable to copy link",
      "auth_modal_inapp_continue": "Continue in this browser",
      "login_heading": "Login to your account",
      "login_google_title": "Connect with Google",
      "login_btn": "Continue",
      "login_phone_invalid": "Invalid phone number",
      "login_phone_placeholder": "Enter phone number",
      "login_separator": "or",
      "login_otp_heading": "Verify OTP sent to your mobile at",
      "login_otp_btn": "Verify",
      "login_otp_resend_label": "Resend Code",
      "login_otp_sent": "OTP Sent Successfully",
      "login_otp_not_received_label": "Didn’t receive code?",
      "login_otp_resend_after": "Resend code after",
      "login_phone_no_not_registered_toast": "This Phone number is not registered. Please Sign-Up",
      "lp_login_email_code_label": "Verification code",
      "lp_login_email_code_placeholder": "6 digit code",
      "lp_about": "About",
      "email_hint_collapsed_ms": "Don't see it? Check your Junk folder.",
      "email_hint_collapsed_yahoo": "Don't see it? Check your Spam folder.",
      "email_hint_collapsed_gmail": "Don't see it? Check your Updates tab.",
      "email_hint_collapsed_zoho": "Don't see it? Check your Notifications tab.",
      "email_hint_collapsed_apple": "Don't see it? Check your Junk folder.",
      "email_hint_collapsed_other": "Don't see it? Check spam or junk.",
      "email_hint_ms_title": "Check your Junk folder",
      "email_hint_ms_body": "Outlook sometimes filters new senders. Find the email in Junk and click '**Not junk**' so future codes reach your inbox.",
      "email_hint_yahoo_title": "Check your Spam folder",
      "email_hint_yahoo_body": "Yahoo and AOL sometimes filter new senders. Find the email in Spam and click '**Not spam**' so future codes reach your inbox.",
      "email_hint_gmail_title": "Check your Updates tab",
      "email_hint_gmail_body": "Gmail may sort verification codes into Updates. **Drag this email to your Primary tab** to receive future codes there.",
      "email_hint_zoho_title": "Check your Notifications tab",
      "email_hint_zoho_body": "Zoho may sort verification codes into Notifications. Move this email to your inbox to receive future codes there.",
      "email_hint_apple_title": "Check your Junk folder",
      "email_hint_apple_body": "iCloud may filter new senders. Find the email in Junk and mark it as '**Not Junk**'.",
      "email_hint_other_title": "Don't see the email?",
      "email_hint_other_body": "Check your spam, junk, or promotions folder. Mark the email as '**not spam**' so future codes reach your inbox.",
      "connection_lost_title": "Connection Lost",
      "connection_lost_description": "We're unable to reach the server. Please check your network connection and try again.",
      "connection_lost_reassurance": "Your content is saved, anything you were sending will go out automatically as soon as you're back online. Nothing is lost",
      "connection_lost_reconnect_btn": "Reconnect",
      "post_detail_embed_link": "Embed post to a webpage",
      "post_detail_embed_link_copied": "Code Copied",
      "post_detail_comment_delete_sure_1": "Are you sure?",
      "post_detail_comment_delete_sure_2": "This comment will be erased for you and this recipient",
      "post_detail_comment_media_restore_fail_toast": "Couldn't restore the media. Please try again.",
      "post_detail_one_liner_receive_private_image_post": "shared a media post with you",
      "post_detail_one_liner_receive_and_send_group_image_post": "shared a media post in group %1$s",
      "post_detail_meta_description_type_image_post": "shared a media post in",
      "post_detail_one_liner_send_private_image_post_singular": "shared a media post with 1 contact",
      "post_detail_one_liner_send_private_image_post_plural": "shared a media post with %1$s contacts",
      "post_detail_one_liner_receive_private_link_post": "shared a link post with you",
      "post_detail_one_liner_receive_and_send_group_link_post": "shared a link post in group %1$s",
      "post_detail_meta_description_type_link_post": "shared a link post in",
      "post_detail_one_liner_send_private_link_post_singular": "shared a link post with 1 contact",
      "post_detail_one_liner_send_private_link_post_plural": "shared a link post with %1$s contacts",
      "post_detail_one_liner_receive_private_poll_post": "shared a poll post with you",
      "post_detail_one_liner_receive_and_send_group_poll_post": "shared a poll post in group %1$s",
      "post_detail_meta_description_type_poll_post": "shared a poll post in",
      "post_detail_one_liner_send_private_link_poll_singular": "shared a poll post with 1 contact",
      "post_detail_one_liner_send_private_link_poll_plural": "shared a poll post with %1$s contacts",
      "post_detail_one_liner_receive_private_text_message_post": "shared a text message post with you",
      "post_detail_one_liner_receive_and_send_group_text_message_post": "shared a text message post in group %1$s",
      "post_detail_one_liner_send_private_text_message_post_singular": "shared a text message post with 1 contact",
      "post_detail_one_liner_send_private_text_message_post_plural": "shared a text message post with %1$s contacts",
      "post_detail_one_liner_receive_private_voice_message_post": "shared a voice message post with you",
      "post_detail_one_liner_receive_and_send_group_voice_message_post": "shared a voice message post in group %1$s",
      "post_detail_one_liner_send_private_voice_message_post_singular": "shared a voice message post with 1 contact",
      "post_detail_one_liner_send_private_voice_message_post_plural": "shared a voice message with %1$s contacts",
      "post_detail_one_liner_receive_private_gif_message_post": "shared a gif message post with you",
      "post_detail_one_liner_receive_and_send_group_gif_message_post": "shared a gif message post in group %1$s",
      "post_detail_one_liner_send_private_gif_message_post_singular": "shared a gif message post with 1 contact",
      "post_detail_one_liner_send_private_gif_message_post_plural": "shared a gif message post with %1$s contacts",
      "post_detail_one_liner_send_thread_post": "shared a thread via",
      "select-threader": "select-threader",
      "post_detail_reaction_sending_toast": "Sending reaction...",
      "post_detail_reaction_sending_and_adding_friend_toast": "A contact request was sent. When approved your reaction will be visible",
      "post_detail_section_relationship_not_accepted": "You and %1$s are not connected yet. Any comment you send will become visible only if %2$s accepts your contact request.",
      "post_detail_reaction_sent_toast": "Reaction sent",
      "post_detail_reaction_fail_sender_is_not_contact_description": "In SELECT everything is private including reactions. Add the sender to start a conversation.",
      "post_detail_load_more_button": "Load More Comments",
      "post_detail_new_activity_button": "New Activity",
      "post_delete_sure_1": "Are you Sure?",
      "post_delete_sure_2": "This post will be erased for you and all recipients.",
      "post_detail_comment_screenshot_event": "%1$s took a screenshot of the discussion",
      "post_detail_post_screenshot_event": "%1$s took a screenshot of this post",
      "post_detail_post_and_comment_screenshot_event": "%1$s took a screenshot of this post and discussion",
      "post_detail_instant_gif_cross_mention_not_supported": "Cross-posting is not supported when sending a quick gif comment",
      "post_detail_quick_gif_fail_toast": "Couldn't send the GIF. Please try again",
      "post_detail_quick_gif_generating": "Text → GIF…",
      "post_detail_remove_link_preview_title": "Remove link preview?",
      "post_detail_remove_link_preview_description": "This removes the link preview from your comment. The text stays",
      "post_detail_remove_media_title": "Remove this media?",
      "post_detail_remove_media_description": "This removes it from your comment. The text stays",
      "post_detail_quote_jump_not_found": "Couldn't find that message",
      "cross_mention_title": "Cross-post to groups you #mention",
      "cross_mention_exposure_off_toast": "Cross-posting is turned off for %1$s, so it wasn't shared there",
      "cross_mention_over_limit_toast": "Cross-posting is limited to the first 3 groups — %1$s more weren't shared",
      "cross_mention_limit_hint": "Only the first 3 groups you #mention are cross-posted",
      "reply_comment_placeholder_text": "[Text]",
      "reply_comment_placeholder_gif": "[GIF]",
      "reply_comment_placeholder_voice": "[Voice]",
      "reply_comment_placeholder_image": "[Image]",
      "reply_comment_placeholder_media": "[Media]",
      "post_uploading_status_remaining": "Uploading %1$s more",
      "post_uploading_status_done": "Upload finished",
      "post_detail_content_unavailable": "This content is no longer available",
      "post_detail_comment_blocked_content_unavailable_fail_toast": "This content is no longer available. Your comment was not sent.",
      "post_detail_deletion_no_permission_fail_toast": "This post couldn't be removed — you no longer have permission.",
      "post_actions_menu_aria_label": "Post actions",
      "lp_heading": "The Social Community for",
      "lp_recent_popular_community_highlights": "✨ Community Highlights",
      "lp_recent_popular_community_highlights_description": "See what the community is talking about",
      "lp_recent_popular": "Recent Popular Posts",
      "lp_google_title": "Sign up with Google",
      "lp_join_community": "Join the Community",
      "lp_invited": "You are invited to join",
      "lp_embed_code_copied": "Code Copied",
      "lp_footer_text": "This is user-created content and does not represent the views or opinions of SELECT.",
      "lp_join_now": "Join now:",
      "lp_join_email": "Check %1$s's inbox!",
      "lp_community_mail": "A link to the community was sent from %1$s via SELECT",
      "lp_invite_user": "A group of likeminded people in %1$s are talking about this.",
      "lp_check_join_email": "Check %1$s on your mail!",
      "lp_community_join_int": "Tap the link in the email to join. If you don’t see the email in a few minutes, please check your spam folders",
      "lp_login_email_sent_toast": "Email Sent Successfully",
      "lp_group_invitation": "Invites you to join",
      "lp_signup_need_community": "Please use your https://[community].the.select link to sign-up",
      "lp_signing_in": "Signing you in...",
      "lp_click_if_not_redirected": "Click here if not redirected",
      "lp_login_signup": "Sign Up / Log in",
      "lp_not_found": "The community you are visiting hasn't set up a public homepage yet. If you are interested to join this community, please contact the community owner to invite you.",
      "lp_applications_closed": "Applications closed",
      "lp_link_expired": "Link expired",
      "lp_invitation_description": "You're invited to the exclusive social app & community for %1$s! Follow this temporary link to join its invite-only home!",
      "lp_community_meta_description": "You're invited to the social app & community for %1$s! Join its home now!",
      "lp_login_signup_email_continue": "Continue",
      "lp_login_signup_privacy": "SELECT will never post anything without your permission.",
      "lp_login_email_placeholder": "Your email",
      "lp_login_signup_header": "Sign up or login:",
      "lp_login_signup_or": "OR",
      "lp_login_signup_fallback_title": "Not just Anybody",
      "lp_login_signup_email_check_inbox": "Check your inbox",
      "lp_login_signup_login_with": "Login with %1$s",
      "lp_login_signup_continue_with": "Continue with %1$s",
      "lp_login_signup_verification_code": "We sent a 6-digit code to",
      "lp_login_signup_verification_link": "Click the link we sent to %1$s to complete your account set-up.",
      "lp_login_phone_verification_title": "Phone Verification Required",
      "lp_login_phone_verification_description": "For security reasons, please verify your phone number to complete registration.",
      "lp_login_phone_placeholder": "Enter phone number",
      "lp_login_phone_send_code": "Send Verification Code",
      "lp_login_phone_code_placeholder": "Enter 6-digit code",
      "lp_login_phone_verify_code": "Verify Code",
      "lp_login_phone_verification_sent": "Verification code sent successfully!",
      "lp_login_phone_verification_error": "Verification failed. Please try again.",
      "lp_login_phone_code_invalid": "Please enter a valid 6-digit code.",
      "lp_login_phone_verification_sent_to": "Code sent to",
      "lp_login_phone_china_info": "For users in China, phone verification is required to comply with local regulations.",
      "lp_login_birthday_title": "Verify Your Age",
      "lp_login_birthday_description": "For security and legal compliance, please provide your date of birth.",
      "lp_login_birthday_required": "Please enter your date of birth",
      "lp_login_birthday_age_restriction": "You must be at least 16 years old to use this service",
      "lp_login_birthday_privacy_note": "Your date of birth will be used solely for age verification purposes",
      "lp_preview_banner_text": "This page isn't live yet. You're viewing a preview of how your community will look once it's published.",
      "lp_guest_view_banner_text": "You're viewing this community's guest experience.",
      "lp_guest_view_banner_link": "Go to Community Feed",
      "lp_login_otp_error_invalid_code": "Incorrect verification code. Please try again.",
      "lp_login_otp_error_too_many_attempts": "Too many attempts. Please try again later.",
      "lp_login_otp_backoff_notice": "Too many attempts. Please try again in %1$s seconds.",
      "lp_login_otp_error_rate_limited": "Too many requests. Please try again later.",
      "lp_login_otp_error_generic": "Something went wrong. Please try again.",
      "lp_login_otp_resend_success_toast": "A new verification code has been sent.",
      "lp_login_birthday_update_fail_toast": "Your signup session has expired. Please sign up again.",
      "message_post_creation_panel_title": "Chat Session",
      "message_post_creation_panel_one_liner": "Creating a chat session",
      "message_post_creation_panel_add_message_hint": "Start typing a message...",
      "message_post_creation_panel_send_post_hint": "Create a chat session",
      "message_post_creation_panel_attention_prompt_description": "Are you sure? If you discard without sending, this post will be lost.",
      "post_detail_comment_discard_title": "Discard comment?",
      "post_detail_comment_discard_description": "This action cannot be undone",
      "post_detail_comment_resend_aria_label": "Resend comment",
      "post_detail_comment_discard_aria_label": "Discard comment",
      "post_detail_comment_quote_nav_aria_label": "Go to quoted comment",
      "post_detail_remove_media_aria_label": "Remove media",
      "post_detail_one_liner_receive_message_post": "shared a chat session with you",
      "post_detail_one_liner_send_message_post_singular": "shared a chat session with 1 contact",
      "post_detail_one_liner_send_message_post_plural": "shared a chat session with %1$s contacts",
      "post_detail_one_liner_receive_and_send_group_message_post": "shared a chat session in group %1$s",
      "post_detail_meta_description_type_message_post": "shared a chat session in",
      "post_detail_one_liner_receive_and_send_group_thread_post": "shared a thread session in group %1$s",
      "chat_page_group_member_addition_rights": "Member addition rights",
      "chat_page_non_member_join_prompt_toast": "Join this group to see the conversation.",
      "chat_settings_page_group_member_addition_rights_description": "Control who can add new members to the group",
      "chat_settings_page_group_share_to_public_alert_message": "Are you sure? You cannot change this setting after turning it on.",
      "chat_settings_page_group_show_history_alert_message": "Are you sure? You cannot change this setting after turning it on.",
      "chat_settings_page_group_identity_warning_title": "Update community identity?",
      "chat_settings_page_group_identity_warning_desc": "This updates your public landing page and all invite links for this community.",
      "chat_settings_page_group_identity_warning_confirm": "Update",
      "error_general_alert_message": "Something went wrong. Please try again.",
      "general_error_title": "Oops",
      "general_permission_required_title": "Permission Required",
      "general_permission_required_photo_library": "Please allow access to your photo library in Settings.",
      "general_permission_required_microphone": "Please allow access to your microphone in Settings.",
      "general_unknown_user": "Someone",
      "general_unknown_group": "the group",
      "me_accept_contact_fail_toast": "Something went wrong. Try again later.",
      "me_add_contact_fail_toast": "Something went wrong. Try again later.",
      "me_bio_update_fail_toast": "Unable to update bio. Please try again later",
      "me_bio_update_success_toast": "Bio updated successfully",
      "me_decline_contact_fail_toast": "Something went wrong. Try again later.",
      "me_detail_update_fail_toast": "Unable to update details. Please try again later",
      "me_detail_update_success_toast": "Details updated successfully",
      "me_profile_fetch_fail_toast": "Unable to fetch user profile. Please try again later",
      "me_relationship_failed_toast": "Failed to get Relationship. Please try again later",
      "me_edit_profile_page_username_helper": "This is your unique handle. Others can find you with this.",
      "me_edit_profile_page_display_name_helper": "This is the name others will see in conversations and posts",
      "post_creation_error": "Post could not be created",
      "post_creation_successful": "Post created successfully",
      "post_deletion_error": "Post could not be deleted",
      "post_deletion_successful": "Post deleted successfully",
      "scraper_add_rss_feed_page_input_bar_error": "Invalid RSS feed URL",
      "chat_page_nav_subtitle_network_unavailable": "Network Unavailable",
      "chat_page_nav_subtitle_connecting": "Connecting...",
      "chat_page_nav_subtitle_connected": "Connected",
      "chat_page_nav_subtitle_connect_failed": "Connection Lost.  Please Click to Reload",
      "chat_page_text_more_option_erase_from_receiver": "Erase from this recipient",
      "chat_page_text_more_option_erase_from_all_receivers": "Erase from all recipients",
      "chat_page_text_more_option_erase_from_group": "Erase from group",
      "chat_page_text_more_option_erase_from_conversation": "Erase from conversation",
      "chat_page_text_more_option_removed_from_conversation": "Remove from conversation",
      "chat_page_text_more_option_removed_from_group": "Remove from group",
      "chat_page_text_more_option_set_as_first_post_group": "Set as first post",
      "chat_page_text_more_option_featured_post_group": "Feature post",
      "chat_page_text_more_option_un_featured_post_group": "Unfeature post",
      "chat_page_text_more_option_erase_from_group_alert_message": "Are you sure you want to erase this post?",
      "chat_page_text_more_option_removed_from_group_alert_message": "Remove this post from the group?",
      "chat_page_text_more_option_removed_from_conversation_alert_message": "Remove this post from the conversation?",
      "chat_page_text_more_option_featured_post_group_alert_message": "Feature this post?",
      "chat_page_text_more_option_un_featured_post_group_alert_message": "Remove from featured posts?",
      "chat_page_text_more_option_set_as_first_post_group_alert_message": "Set as the top featured post?",
      "chat_page_text_more_option_hide_alert_message": "This post will be hidden for you, but other recipients will still have access.",
      "comment_creation_error": "Failed to send comment",
      "chat_page_group_featured_posts_load_fail_toast": "Failed to load featured posts",
      "chat_page_group_featured_posts_remove_fail_toast": "Failed to remove featured post",
      "chat_page_group_featured_posts_pin_fail_toast": "Failed to pin featured post",
      "chat_page_group_featured_posts_feature_fail_toast": "Failed to feature post",
      "featured_posts_page_empty_state": "No featured posts yet",
      "featured_posts_page_actions_dialog_title": "Post Actions",
      "featured_posts_page_remove_dialog_title": "Remove from Featured?",
      "featured_posts_page_remove_dialog_desc": "This post will be removed from featured posts.",
      "chat_page_text_more_option_copy_message": "Copy this message",
      "chat_page_media_post_preview_default_text_image_singular": "%1$s shared an image.",
      "chat_page_media_post_preview_default_text_image_plural": "%1$s shared %2$s images.",
      "chat_page_media_post_preview_default_text_video_singular": "%1$s shared a video.",
      "chat_page_media_post_preview_default_text_video_plural": "%1$s shared %2$s videos.",
      "chat_page_media_post_preview_default_text_files_plural": "%1$s shared %2$s media.",
      "chat_page_link_post_preview_default_text": "%1$s shared a link.",
      "chat_page_poll_post_preview_default_text": "%1$s sent a poll.",
      "chat_page_input_bar_voice_toast_title_hint": "Long press to record a message",
      "chat_page_input_bar_voice_toast_title_recording": "Recording...",
      "chat_page_input_bar_guggy_toast_title_generating": "Generating GIF...",
      "chat_page_input_bar_guggy_toast_title_failed_generate_gif": "Failed to generate the GIF. Please try again Later.",
      "chat_page_input_bar_voice_and_guggy_toast_description_slide_up": "Slide Up to Cancel",
      "chat_page_input_bar_voice_and_guggy_cancel_toast_title": "Release",
      "chat_page_input_bar_voice_and_guggy_cancel_toast_description": "Cancel Sending",
      "chat_page_event_post_disable_group": "Posts are disabled in %1$s",
      "chat_page_event_featured_by_user": "The group was featured by %1$s on their user profile",
      "chat_page_event_featured_in_group": "The group was featured by %1$s in %2$s",
      "chat_page_event_featured_in_group_no_mention": "The group was featured by %1$s in another group",
      "chat_page_event_featured_group": " has featured group",
      "chat_page_event_join_private_conversation_general": "You joined the conversation",
      "chat_page_event_join_group_general": "You joined the group",
      "chat_page_event_add_group_admin": "%1$s promoted %2$s to admin",
      "chat_page_event_remove_group_admin": "%1$s demoted %2$s to member",
      "chat_page_event_add_group_admin_for_new_admin": "%1$s promoted you to admin",
      "chat_page_event_remove_group_admin_for_new_admin": "%1$s demoted you to member",
      "chat_page_event_add_group_admin_for_owner": "You promoted %1$s to admin",
      "chat_page_event_remove_group_admin_for_owner": "You demoted %1$s to member",
      "chat_page_event_add_group_member_for_invitee": "%1$s invited you to a group with %2$s and %3$s members",
      "chat_page_event_add_group_member_for_invitee_friends_only": "%1$s invited you to a group with %2$s and %3$s",
      "chat_page_event_add_group_member_for_invitee_single_friend_only": "%1$s invited you to a group with %2$s",
      "chat_page_event_add_group_member_for_invitee_single": "%1$s invited you to a group",
      "chat_page_event_add_group_member_for_invitee_single_with_others": "%1$s invited you to a group with %2$s members",
      "chat_page_event_add_group_member_for_inviter": "You invited %1$s and %2$s to the group",
      "chat_page_event_add_group_member_for_inviter_single": "You invited %1$s to the group",
      "chat_page_event_add_group_member_for_owner_only": "You created a group",
      "chat_page_event_add_group_member_for_no_inviter": "%1$s and %2$s joined the group",
      "chat_page_event_add_group_member_for_no_inviter_single": "%1$s joined the group",
      "chat_page_event_add_group_member_for_not_inviter_or_invitee": "%1$s invited %2$s and %3$s to the group",
      "chat_page_event_add_group_member_for_not_inviter_or_invitee_single": "%1$s invited %2$s to the group",
      "chat_page_event_remove_group_member_for_action_taker": "You removed %1$s and %2$s from the group",
      "chat_page_event_remove_group_member_for_action_taker_single": "You removed %1$s from the group",
      "chat_page_event_remove_group_member_for_action_receiver": "You were removed from the group",
      "chat_page_event_remove_group_member_for_group_member": "%1$s and %3$s were removed from the group by %2$s",
      "chat_page_event_remove_group_member_for_group_member_single": "%1$s was removed from the group by %2$s",
      "chat_page_event_update_group_name_for_action_taker": "You changed the group name to %1$s",
      "chat_page_event_update_group_name_for_action_receiver": "%1$s changed the group name to %2$s",
      "chat_page_event_update_group_description_for_action_taker": "You changed the group description",
      "chat_page_event_update_group_description_for_action_receiver": "%1$s changed the group description",
      "chat_page_event_update_group_background_for_action_taker": "You changed the group cover photo",
      "chat_page_event_update_group_background_for_action_receiver": "%1$s changed the group cover photo",
      "chat_page_event_update_group_id_for_action_taker": "You changed the Group ID to %1$s",
      "chat_page_event_update_group_id_for_action_receiver": "%1$s changed the Group ID to %2$s",
      "chat_page_event_update_group_avatar_for_action_taker": "You changed the group avatar",
      "chat_page_event_update_group_avatar_for_action_receiver": "%1$s changed the group avatar",
      "chat_page_event_update_group_owner_for_action_taker": "You appointed %1$s as the new group owner",
      "chat_page_event_update_group_owner_for_action_receiver": "%1$s appointed you as the new group owner",
      "chat_page_event_update_group_owner_for_action_passive": "%1$s appointed %2$s as the new group owner",
      "chat_page_event_update_group_default_deeplink_for_action_taker": "You updated the %1$s community page.",
      "chat_page_event_update_group_default_deeplink_for_action_receiver": "%1$s updated the %2$s community page.",
      "chat_page_event_update_group_show_history": "%1$s has set \"Keep History\" setting on. When a new member joins the group, they will be able to view all content sent from this point forward.",
      "chat_page_event_update_group_share_to_public": "%1$s has set \"Share To Public\" setting on. From this point forward, members can share new group posts outside the group.",
      "chat_page_event_screenshot_notice": " took a screenshot",
      "chat_page_event_new_contact_greeting": "You've added %1$s as a contact. Now start sharing!",
      "chat_page_event_not_a_contact": "Add this user as a contact to begin sharing.",
      "chat_page_event_content_erased_post_sender": "Your post was removed by %1$s",
      "chat_page_event_content_erased_message_sender": "Your message was erased",
      "chat_page_event_content_erased_comment_sender": "Your comment was removed by %1$s",
      "chat_page_event_content_erased_post_owner": "You removed this post",
      "chat_page_event_content_erased_message_owner": "The message was successfully erased",
      "chat_page_event_content_erased_comment_owner": "You removed this comment",
      "chat_page_event_content_erased_post_member": "This post was removed by %1$s",
      "chat_page_event_content_erased_message_member": "The message was removed",
      "chat_page_event_content_erased_comment_member": "This comment was removed by %1$s",
      "chat_page_event_new_member_invitation": "%1$s and %2$s will be added to the group pending owner approval",
      "chat_page_event_new_member_invitation_single": "%1$s will be added to the group pending owner approval",
      "chat_page_event_user_is_banned": "%1$s was banned by %2$s",
      "chat_page_event_user_is_unbanned": "%1$s was unbanned by %2$s",
      "chat_page_event_user_is_appointed_admin": "%1$s is an admin now",
      "chat_page_event_admin_is_discharged": "%1$s is not an admin anymore",
      "chat_page_group_featured_post_creator_title": "Featured Posts",
      "chat_page_group_featured_post_empty_notice": "Featured posts are visible to all group members, including newly joined ones. It's a great way to introduce your group, welcome new members and share the best posts. Create as many featured posts as you like or feature existing posts and don't worry, you can always change them later.",
      "chat_page_group_greeting_creator_title": "Group Greeting Post",
      "chat_page_group_greeting_creator_empty_notice": "Greeting posts are visible to all group members, including newly joined ones. It's a great way to introduce your group and welcome new members. Create as many greeting posts as you like and don't worry, you can always change them later.",
      "chat_page_group_greeting_creator_prompt_description": "Only one greeting post is permitted per group. Setting a new one will replace the old.",
      "chat_page_group_greeting_disable_prompt_disable_btn": "Disable this greeting post",
      "chat_page_group_greeting_disable_prompt_erase_btn": "Erase post",
      "chat_page_group_greeting_warning_popup_content": "Every new member will have access to this post.",
      "chat_page_group_greeting_warning_popup_warning": "Do not show this warning again",
      "chat_page_group_greeting_warning_popup_title": "Send a comment on a greeting post?",
      "chat_page_group_greeting_label": "Greeting",
      "chat_page_keep_group_history_warning_popup_post_title": "Send post?",
      "chat_page_keep_group_history_warning_popup_post_content": "New members will have access to this post",
      "chat_page_keep_group_history_warning_popup_comment_title": "Send comment?",
      "chat_page_keep_group_history_warning_popup_comment_content": "New members will have access to this post and will be able to read your comment",
      "chat_page_keep_group_history_warning_popup_warning": "Do not show this warning again",
      "chat_page_group_publishing_rules": "Posts are disabled for members",
      "chat_page_group_publishing_rules_desc": "Only the owner and admins of the group can post",
      "chat_page_group_publishing_rules_enable": "Posts are enabled for members",
      "chat_page_group_publishing_rules_messages": "Messages are disabled for members",
      "chat_page_group_limited_publishing_rules_messages_pop_up_description": "Oops... The group owner has disabled member messages. Join or start a discussion using comments instead!",
      "chat_page_group_show_history_rules": "Keep history",
      "chat_page_group_show_history_rules_desc": "New members will be able to access content that was sent before they joined the group",
      "chat_page_group_show_history_rules_on_toast": "You cannot change this setting after turning it on.",
      "chat_page_group_show_history_rules_enable": "All group content will be visible for new members",
      "chat_page_group_show_history_rules_disabled": "New members will never see old comments\nNew members will see old posts that have new comments",
      "chat_page_group_share_to_public_rules": "Share to public",
      "chat_page_group_share_to_public_rules_desc": "Members will be able to share group posts outside the group",
      "chat_page_group_share_to_public_rules_on_toast": "You cannot change this setting after turning it on.",
      "chat_page_group_share_to_public_rules_enable": "Members can share posts outside the group",
      "chat_page_group_share_to_public_rules_disabled": "Members cannot share posts outside the group",
      "chat_page_group_cross_exposure_rules": "Disable auto-promotion in other groups",
      "chat_page_group_cross_exposure_rules_desc": "App won't show #Group in system generated events",
      "chat_page_group_cross_exposure_rules_enable": "App won't show #Group in system generated events",
      "chat_page_group_cross_exposure_rules_disabled": "App will show #Group in system generated events",
      "chat_page_group_adding_members_rules": "Group requires approval to join",
      "chat_page_group_adding_members_rules_desc": "New members must request access before joining the group.",
      "chat_page_group_adding_members_rules_enable": "Group does not require approval to join",
      "chat_page_group_permissions_section": "Permissions",
      "chat_page_group_admin_management": "Admin management",
      "chat_page_group_group_management": "Group Management ",
      "chat_page_group_admin_management_owner_lable": "Group Owner",
      "chat_page_group_admin_management_admin_lable": "Group Admins",
      "chat_page_group_admin_management_add_admin_confirmation_title": "Are you sure you want to grant admin privileges?",
      "chat_page_group_admin_management_remove_admin_confirmation_title": "Are you sure you want to remove admin privileges?",
      "chat_page_group_limited_publishing_rules_pop_up_description": "Oops... The group owner has disabled member posts. Join or start a discussion using comments!",
      "chat_page_group_featured_post_creator_empty_tooltip": "Create a featured post here!",
      "chat_page_group_greeting_creator_empty_tooltip": "Create a greeting post here!",
      "chat_page_group_feature_unavailable": "Set a Group ID to unlock this feature.",
      "chat_page_message_input_bar_hint": "Send a message...",
      "chat_page_group_ban_management_page_cell_description": "was banned by %1$s",
      "chat_page_unread_messages": "Unread Comments",
      "chat_page_new_comments": "New Comments",
      "chat_page_load_previous_comments": "Load Previous Comments",
      "chat_page_comment_copy": "Comment Copied",
      "chat_page_posting_disabled_fail_toast": "Posting has been turned off by the community owner. Your draft has been saved.",
      "chat_page_posting_disabled_draft_reason": "Posting is turned off in this group",
      "content_type_unsupported_preview": "unknown",
      "people_page_chat_list_cell_preview_content_type_link": "Link",
      "please_wait_for_uploads": "Please wait for uploads to complete",
      "people_page_chat_list_cell_preview_content_type_image": "Media",
      "people_page_chat_list_cell_preview_content_type_poll": "Poll",
      "people_page_chat_list_cell_preview_content_type_gif": "GIF",
      "people_page_chat_list_cell_preview_content_type_voice": "Voice",
      "people_page_chat_list_cell_preview_content_type_thread": "Thread",
      "people_page_filter_result_title_noresult": "No Results",
      "post_detail_comment_page_nav_title": "Comment",
      "post_detail_comment_page_request_to_join_to_comment_hint": "Request to join this community to comment.",
      "post_detail_comment_page_more_options_erase_from_all_receivers": "Erase from all recipients",
      "post_detail_comment_page_more_options_erase_comment": "Erase comment",
      "post_detail_comment_page_more_options_report": "Report",
      "post_detail_comment_page_more_options_hide": "Report and hide",
      "post_detail_comment_page_more_options_copy": "Copy",
      "post_detail_comment_page_more_options_reply": "Reply",
      "post_detail_comment_page_more_options_download": "Download",
      "post_detail_comment_page_more_options_change_random_gif": "Change GIF",
      "post_detail_comment_page_more_options_change_search_gif": "Search GIF",
      "post_detail_comment_page_more_options_erase_comment_alert_message": "Are you sure you want to erase this comment?",
      "post_detail_comment_page_more_options_remove_comment_alert_message": "Remove this comment from the group?",
      "post_detail_comment_page_more_options_hide_alert_message": "This comment will be hidden for you, but other recipients will still have access.",
      "post_detail_comment_page_mute_group_notification_banner": "Discussion notifications are turned off.",
      "post_detail_comment_page_settings_options_mute_group_notification_toggle": "Mute Discussion Notification",
      "post_detail_comment_page_settings_options_leave_group_discussion_btn": "Leave Discussion",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_title": "If you leave the discussion, you will no longer be able to participate or see others on this post except for the sender.",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_leave_btn": "Leave",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_stay_btn": "Stay",
      "post_detail_comment_page_comment_empty_group_discussion": "Comment here to discuss with all recipients or tap a user's profile image to discuss privately.",
      "post_detail_comment_page_comment_empty_private_conversation": "No comments yet. Write something to start the conversation.",
      "post_detail_comment_page_comment_empty_private_comment_contacts": "This conversation is private between you and %1$s.",
      "post_detail_comment_page_comment_empty_private_comment_non_contacts": "You and %1$s are not connected yet. Any comment you send will become visible only if %2$s accepts your contact request.",
      "post_detail_comment_page_comment_empty_private_comment_pending": "%1$s sent you a contact request. Tap the accept button or send private comment to view any sent comments.",
      "post_detail_comment_page_comment_empty_one_to_many_private_comment": "Comments will be received as if they were sent to each recipient individually.",
      "post_detail_comment_page_comment_input_bar_hint_group_discussion": "Send a group comment...",
      "post_detail_comment_page_comment_input_bar_hint_private_comment_to_all": "Send a comment to all...",
      "post_detail_comment_page_comment_input_bar_hint_private_comment_to_user": "Send a private comment...",
      "post_detail_comment_page_comment_status_sending": "Sending comment...",
      "post_detail_comment_page_comment_status_fail_to_send": "Comment failed to send",
      "post_detail_comment_page_comment_text_pull_to_post_detail": "Pull to show post detail",
      "post_detail_comment_page_comment_text_release_to_post_detail": "Release to show post detail",
      "post_detail_poll_post_seo_description_above_five_comments": "Join this lively poll discussion in %1$s community with %2$s activities. Participate by casting your vote and share your thoughts now!",
      "post_detail_poll_post_seo_description_for_fewer_comments": "Participate in this engaging poll in %1$s community. Cast your vote and share your thoughts now!",
      "post_detail_default_seo_description_above_five_comments": "Join this lively conversation in %1$s community with %2$s comments. Share your thoughts now!",
      "post_detail_default_seo_description_for_fewer_comments": "Explore this lively topic in %1$s community. Share your thoughts now!",
      "inbox_tab_select": "SELECT",
      "inbox_tab_new": "New",
      "inbox_tab_history": "History",
      "inbox_action_reaction_toast": "Reaction sent",
      "inbox_action_snooze_toast": "Post is Snoozed for 30mins",
      "inbox_action_unsnooze_toast": "Post is no longer snoozed",
      "inbox_action_cancel_toast": "Post dismissed",
      "inbox_action_card_friend_request_title": "Friend Request",
      "inbox_action_contact_request_badge": "Contact request",
      "inbox_page_zero_view_heading_1": "You are all caught up, and SELECT will help you keep it that way.",
      "inbox_page_zero_view_body_text_top_1": "On average, people spend 135 minutes on social media per day.",
      "inbox_page_zero_view_body_text_bottom_1": "SELECT delivers what matters in less than 10 minutes a day. Stop scrolling. Start engaging.",
      "inbox_page_zero_view_heading_2": "Enjoy deep conversations without the noise and urgency.",
      "inbox_page_zero_view_body_text_top_2": "Group chats lose their value when everyone yells into one room.",
      "inbox_page_zero_view_body_text_bottom_2": "SELECT groups support meaningful communication - no matter how many members.",
      "inbox_page_zero_view_heading_3": "Congratulations! You've reached Inbox Zero.",
      "inbox_page_zero_view_body_text_top_3": "This is NOT an endless feed, public record, popularity contest or ad platform.",
      "inbox_page_zero_view_body_text_bottom_3": "SELECT is a healthy alternative to social media. You are the customer, NOT the product.",
      "inbox_recall_snoozed_tooltip": "Double-tap to bring back snoozed posts",
      "post_detail_download_process_send_request_pop_up_send_button": "Send request",
      "post_detail_download_process_downloading_toast": "Downloading",
      "post_detail_download_process_downloading_toast_progress": "%1$s of %2$s",
      "post_detail_download_process_downloaded_successfully_toast": "Downloaded",
      "post_detail_download_process_download_failed_toast": "Download Failed",
      "post_detail_download_process_download_cancelled_toast": "Cancelled",
      "post_detail_event_user_requested_download": "%1$s requested to download image",
      "post_detail_event_owner_allowed_download": "%1$s allowed you to download images ",
      "post_detail_event_user_downloaded_successfully_single": "%1$s downloaded an image",
      "post_detail_event_user_downloaded_image_comment_successfully_single": "%1$s downloaded an image sent by %2$s",
      "post_detail_event_user_downloaded_video_successfully_single": "%1$s downloaded a video",
      "post_detail_event_user_downloaded_video_comment_successfully_single": "%1$s downloaded a video sent by %2$s",
      "post_detail_event_user_downloaded_video_successfully": "%1$s downloaded videos",
      "post_detail_event_user_downloaded_video_comment_successfully": "%1$s downloaded videos sent by %2$s",
      "post_detail_event_user_downloaded_files_successfully": "%1$s downloaded media",
      "post_detail_event_user_downloaded_files_comment_successfully": "%1$s downloaded media sent by %2$s",
      "post_detail_event_user_downloaded_successfully": "%1$s downloaded images",
      "post_detail_event_user_downloaded_image_comment_successfully": "%1$s downloaded images sent by %2$s",
      "change_vote": "Change vote",
      "post_detail_event_user_vote_event": "%1$s cast a vote",
      "post_detail_event_user_change_vote_event": "%1$s changed their vote",
      "post_detail_event_owner_featured_post": "%1$s featured this post",
      "post_detail_proactively_allow_download_pop_up_description": "Allow recipients to download these images",
      "post_detail_proactively_allow_download_pop_up_allow_btn": "Enable download",
      "post_detail_download_already_enabled_pop_up_description": "Image downloads are already enabled for recipients of this post",
      "post_seen_all": "Yay! You have seen it all",
      "post_no_feed": "No Feeds Available",
      "profile_filter_btn_default": "Everyone",
      "profile_filter_popup_gender_selector_btn_all": "All",
      "profile_filter_popup_gender_selector_btn_female": "Female",
      "profile_filter_popup_gender_selector_btn_male": "Male",
      "profile_filter_popup_age_selector_text_all_age": "All ages",
      "profile_filter_popup_age_selector_text_age_range": "%1$s - %2$s years old",
      "profile_bio_not_set": "Bio has not been set",
      "profile_cover_photo": "Cover Photo",
      "group_profile_no_group_available": "Group owner has not added any Featured Groups.",
      "group_profile_copy_link": "Copy Link",
      "group_profile_copy_link_success_toast": "Copied to clipboard",
      "group_profile_copy_link_fail_toast": "Unable to copy link",
      "user_profile_no_group_available": "This user has not added any Featured Groups.",
      "profile_seen_all_contacts": "You have seen all",
      "profile_no_contacts": "No Contacts available",
      "profile_gender_not_set": "Gender not set",
      "profile_delete_account_hint": "Your account will be deleted within 30 days. You won't be able to use your account, and account deletion is irreversible. Are you sure you want to delete your account?",
      "me_edit_profile_page_nav_title": "Edit Profile",
      "me_edit_profile_page_update_profile_picture_title": "Update Avatar",
      "me_edit_profile_page_display_name_title": "Name",
      "me_edit_profile_page_gender_title": "Gender",
      "me_edit_profile_page_about_me_placeholder": "Bio has not been set",
      "me_edit_profile_page_about_me_title": "Bio",
      "me_edit_profile_page_id_title": "Username",
      "me_edit_profile_page_binded_account_title": "Binded Account",
      "me_edit_profile_page_birthdate_title": "Birthdate",
      "me_edit_profile_page_email_title": "Email",
      "me_edit_profile_page_email_not_available": "No email provided",
      "me_edit_profile_page_gender_options_female": "Female",
      "me_edit_profile_page_gender_options_male": "Male",
      "me_edit_profile_page_private_title": "The following are private and can't be seen by anyone but you",
      "me_edit_profile_page_username_invalid_id": "Username can only contain alphanumeric characters (letters A-Z, numbers 0-9), underscores '_', and cannot be longer than 15 characters.",
      "me_edit_profile_page_username_not_available": "Username not available, please change new one",
      "me_edit_set_your_bio_title": "Set your Bio",
      "universal_search_search_bar_hint_people": "Search People",
      "universal_search_search_bar_hint_groups": "Search Groups",
      "universal_search_search_bar_hint_content": "Search Content",
      "universal_search_result_contact_title": "Contacts",
      "universal_search_result_more_result_title": "More Results",
      "universal_search_result_more_result_search_for": "Search for: ",
      "universal_search_section_other_groups_title": "From Other Groups",
      "universal_search_result_groups_title": "Groups",
      "universal_search_result_more_result_search_for_no_result_alert": "Nothing found. Please check your spelling and try again.",
      "universal_search_empty_current_group": "No results found in this group",
      "universal_search_result_more_result_search_for_no_network": "Search failed. Please check your connection.",
      "universal_search_result_messages_title": "Messages",
      "universal_search_result_posts_title": "Posts",
      "universal_search_result_comments_title": "Comments",
      "universal_search_type_selector_people": "People",
      "universal_search_search_bar_hint_all_types": "Search Content/ People/ Groups",
      "universal_search_type_selector_all": "All",
      "universal_search_type_selector_content": "Content",
      "universal_search_type_selector_groups": "Groups",
      "universal_search_result_user_id_match": "Username match",
      "universal_search_result_group_id_match": "Group ID match",
      "group_forbidden_toast": "You can't join the group because you were removed.",
      "group_profile_page_nav_title": "Group Profile",
      "group_profile_members": "Members",
      "group_profile_friends": "Contacts",
      "group_profile_members_count": "Members in this group",
      "group_profile_friends_count": "Contacts in this group",
      "group_profile_join": "Join this group",
      "group_profile_request_join": "Request to join",
      "group_profile_friends_sent": "Request sent",
      "group_profile_community_title": "View Community Page",
      "group_profile_deliver_inbox_title": "See in Inbox SELECT?",
      "group_profile_deliver_inbox_desc": "What activity from %1$s would you like to see in your Inbox SELECT ?",
      "group_profile_deliver_inbox_desc_all": "All activity, including from non-contacts, in this group will go to Inbox SELECT",
      "group_profile_deliver_inbox_desc_select": "Only activity from contacts or posts you've interacted with in this group will go to Inbox SELECT",
      "group_profile_deliver_inbox_desc_none": "No activity from this group will go to Inbox SELECT",
      "group_profile_deliver_option_all": "All",
      "group_profile_deliver_option_curated": "SELECT",
      "group_profile_deliver_option_none": "None",
      "group_profile_start_conversation": "Start Conversation",
      "group_profile_members_and_contacts": "%1$s Members, %2$s Contacts",
      "user_profile_page_toast_user_id_copied": "Username Copied",
      "group_join_request_sent": "Your request to join has been sent",
      "group_join_request_pending": "Request Pending",
      "group_join_request_to_join": "Request to Join",
      "group_join_request_approved": "Request approved",
      "group_join_request_declined": "Request declined",
      "group_join_request_wants_to_join": "wants to join",
      "group_join_request_empty": "No pending group join requests",
      "group_join_requests_title": "Group Requests",
      "group_join_request_accepted_description": "You've been accepted!",
      "group_join_request_accepted_toast": "You've been accepted into %1$s",
      "group_joining_confirmation": "You have successfully joined this conversation",
      "group_permission_updated": "You have successfully joined this group conversation",
      "remove_contact": "Delete Contact",
      "remove_contact_sure_1": "Are you sure?",
      "remove_contact_sure_2": "You will no longer be able to share with this contact and all history will be lost.",
      "remove": "Delete",
      "pending_requests_title": "Pending Requests",
      "sent_requests_title": "Sent Requests",
      "add_contact_title": "Add Contacts",
      "contact_request_wants_to_add_subtitle": "wants to add you as a contact",
      "contacts_view_tab_requests": "Requests",
      "contacts_view_empty": "No pending requests",
      "me_add_contact_rate_limit_toast": "You've sent too many contact requests to this person recently. Please try again later.",
      "erase_post": "Erase from group",
      "erase_comment": "Erase comment",
      "private_conversation_title": "SELECT does not store private content. 🔒 These conversations are private to YOU.",
      "private_conversation_footer": "Download the SELECT app to view",
      "private_conversation_no_posts": "No new private posts",
      "private_conversation_box_singular": "Shared %1$s post with you",
      "private_conversation_sidebar_singular": "%1$s shared %2$s post with you",
      "private_conversation_box_plural": "Shared %1$s posts with you",
      "private_conversation_sidebar_plural": "%1$s shared %2$s posts with you",
      "invitation_qr_title": "Scan to get the app",
      "not_found_error_title": "This content isn't available right now",
      "not_found_error_desc": "When this happens, it's usually because the owner only shared it with a small group of people, changed who can\nsee it or it's been deleted.",
      "not_found_error_go_home": "Go to Inbox",
      "not_found_error_go_back": "Go back",
      "not_found_no_public_landing_page_title": "The community you are visiting hasn't set up a public homepage yet.",
      "not_found_no_public_landing_page_desc": "If you'd like to join, please contact the community owner to invite you.",
      "not_found_no_access_title": "This content isn't available to you.",
      "not_found_no_access_desc": "The owner shared it with a small group of people, or you're not a member of this community.",
      "not_found_cta_back_to_inbox": "Back to Inbox",
      "not_found_cta_go_home": "Go to home page",
      "cancel": "Cancel",
      "post_builder_tab_post_title": "Post",
      "post_builder_tab_blog_title": "Blog",
      "post_builder_tab_poll_title": "Poll",
      "post_builder_formatting_tooltip_align_left": "Align Left",
      "post_builder_formatting_tooltip_align_center": "Align Center",
      "post_builder_formatting_tooltip_align_right": "Align Right",
      "post_builder_formatting_tooltip_undo": "Undo",
      "post_builder_formatting_tooltip_redo": "Redo",
      "post_builder_formatting_tooltip_heading_options": "Heading Options",
      "post_builder_formatting_tooltip_paragraph": "Paragraph",
      "post_builder_formatting_tooltip_heading_one": "Heading 1",
      "post_builder_formatting_tooltip_heading_two": "Heading 2",
      "post_builder_formatting_tooltip_heading_three": "Heading 3",
      "post_builder_formatting_tooltip_bold": "Bold",
      "post_builder_formatting_tooltip_italic": "Italic",
      "post_builder_formatting_tooltip_strikethrough": "Strikethrough",
      "post_builder_formatting_tooltip_list_bullet": "Bullet List",
      "post_builder_formatting_tooltip_list_ordered": "Ordered List",
      "post_builder_formatting_tooltip_blockquote": "BlockQuote",
      "post_builder_formatting_tooltip_code": "Code",
      "post_builder_formatting_tooltip_codeblock": "Codeblock",
      "post_builder_formatting_tooltip_more_options": "More formatting options",
      "post_builder_tooltip_insert_image": "Insert Image",
      "post_builder_tooltip_insert_video": "Insert Video",
      "post_builder_tooltip_insert_audio": "Insert Audio",
      "post_builder_tooltip_search_gif_or_image": "Search Gif/Images Online",
      "post_builder_media_search_modal_title": "Search Media",
      "post_builder_media_search_tab_gif_title": "GIF Search",
      "post_builder_media_search_tab_image_title": "Image Search",
      "post_builder_media_search_input_gif_placeholder": "Search GIFs...",
      "post_builder_media_search_input_image_placeholder": "Search Images...",
      "post_builder_tooltip_link_add": "Add link with preview",
      "post_builder_tooltip_link_edit": "Edit Link",
      "post_builder_tooltip_link_visit": "Visit Link",
      "post_builder_tooltip_link_unset": "Unset Link",
      "post_builder_link_input_label": "Link URL",
      "post_builder_link_text_input_label": "Text to display",
      "post_builder_link_input_invalid": "Please enter a valid URL",
      "post_builder_link_insert_modal_title": "Insert Link",
      "post_builder_link_update_modal_title": "Update Link",
      "post_builder_tooltip_link_remove_preview": "Remove Link Preview",
      "post_builder_link_loading_metadata_placeholder": "Fetching Link Metadata...",
      "post_builder_poll_question_input_placeholder": "Which one would you select?",
      "post_builder_poll_add_text_option_input_label": "Add text option",
      "post_builder_poll_add_text_option_input_placeholder": "Enter a text option...",
      "post_builder_poll_add_text_option_input_command": "Press Enter to add",
      "cookie_banner_title": "We hate cookies too.",
      "cookie_banner_description": "We only use Google Analytics — to see how people find Select and what to build next. No ad tracking, nothing sold.",
      "cookie_accept_all": "Accept all",
      "cookie_essential_only": "Essential only",
      "cookie_manage_preferences": "Manage settings",
      "cookie_save_preferences": "Save preferences",
      "cookie_preferences_title": "Cookie Preferences",
      "cookie_usage_title": "Cookie Usage",
      "cookie_usage_description": "We use cookies to ensure the basic functionality of the website and to enhance your experience.",
      "cookie_necessary_title": "Strictly Necessary Cookies",
      "cookie_necessary_description": "These cookies are essential for the website to function properly, including authentication, error monitoring, and crash reporting to maintain service reliability. They cannot be disabled.",
      "cookie_analytics_title": "Analytics Cookies",
      "cookie_analytics_description": "These cookies help us understand how visitors interact with the website, helping us improve our services.",
      "cookie_preferences_link": "Cookie Preferences",
      "cookie_privacy_policy": "Privacy Policy",
      "general_cookies": "Cookies",
      "drafts_panel_title": "Drafts",
      "drafts_panel_tab_failed": "Failed",
      "drafts_panel_tab_unfinished": "Unfinished",
      "drafts_panel_empty_state": "No drafts",
      "drafts_panel_failed_empty": "No failed drafts",
      "drafts_panel_unfinished_empty": "No unfinished drafts",
      "drafts_panel_type_comment": "Comment",
      "drafts_panel_type_poll": "Poll",
      "drafts_panel_embed_generic": "Embed",
      "drafts_panel_media_label": "media",
      "drafts_panel_poll_choice": "choice",
      "drafts_panel_poll_choices": "choices",
      "drafts_panel_empty_draft_preview": "Empty draft",
      "draft_missing_attachment": "Missing attachment",
      "drafts_panel_refresh_aria_label": "Refresh drafts",
      "drafts_panel_close_aria_label": "Close drafts panel",
      "drafts_panel_erase_post_aria_label": "Erase Post",
      "drafts_panel_unknown_group": "Unknown group",
      "drafts_panel_discard_sure_1": "Discard draft?",
      "drafts_panel_discard_sure_2": "This action cannot be undone.",
      "drafts_panel_resend_all": "Resend All",
      "drafts_panel_resend_all_toast": "Resending failed items…",
      "group_creation_title": "Create a group",
      "group_creation_name_placeholder": "Group name (optional)",
      "group_creation_avatar_upload_label": "Upload group photo",
      "group_creation_selected_count": "Selected (%1$s)",
      "group_creation_empty_selection_hint": "Pick people to add them",
      "group_creation_search_placeholder": "Search contacts",
      "group_creation_create_button": "Create",
      "group_creation_cancel_button": "Cancel",
      "group_creation_min_members_hint": "Pick at least 2 people",
      "group_creation_avatar_uploading_hint": "Uploading photo...",
      "group_creation_empty_contacts_title": "Add contacts first to start a group",
      "group_creation_empty_contacts_cta": "Add contact",
      "group_creation_error_generic": "Couldn't create group. Try again.",
      "group_creation_avatar_upload_failed": "Couldn't upload photo. Try again.",
      "group_creation_success_toast": "Group created",
      "group_creation_start_conversation_button": "Start conversation",
      "group_creation_start_conversation_fail_toast": "Couldn't open the conversation",
      "sidebar_create_group_tooltip": "Create group",
      "chat_settings_page_group_promote_admin_title": "Promote members to admins",
      "chat_settings_page_group_promote_admin_desc": "Admins can moderate the group but cannot change the group's settings",
      "chat_settings_page_group_demote_admin_title": "Demote admins to members",
      "chat_settings_page_group_demote_admin_desc": "Members cannot moderate the group and change the group's settings",
      "chat_settings_page_group_appoint_owner_btn": "Transfer group ownership",
      "chat_settings_page_group_appoint_owner_desc": "Transfer the group's ownership to someone else. This action cannot be reverted.",
      "chat_settings_page_group_promote_alert_title": "Promote member to admin?",
      "chat_settings_page_group_promote_alert_desc": "Admin can moderate the group by removing posts, comments, and members, etc.",
      "chat_settings_page_group_demote_alert_title": "Demote admin to member?",
      "chat_settings_page_group_demote_alert_desc": "Demoted admins will not be able to moderate the group anymore",
      "chat_settings_page_group_update_failed_toast": "Group management update failed. Please try again",
      "chat_settings_page_group_remove_member_alert_title": "Remove member?",
      "chat_settings_page_group_promote_member_confirm_label": "Promote %1$s",
      "chat_settings_page_group_demote_member_confirm_label": "Demote %1$s",
      "chat_settings_page_group_transfer_owner_confirm_label": "Transfer to %1$s",
      "chat_settings_add_group_member_error": "Failed to add members. Please try again.",
      "chat_settings_page_group_leave_group_btn": "Leave Group",
      "chat_settings_page_group_leave_group_alert_message": "Are you sure you want to leave this group?",
      "chat_settings_page_group_leave_group_alert_confirm_btn": "Leave",
      "chat_settings_add_group_member_nav_title": "Add Members",
      "chat_settings_page_group_remove_member_alert_message": "Remove %1$s from the group?",
      "chat_settings_page_group_members_empty": "No members found.",
      "chat_settings_add_group_member_no_contacts": "No contacts to add.",
      "chat_settings_add_group_member_confirm_btn": "Add %1$s member(s)",
      "chat_settings_page_group_owner_transfer_first_title": "Transfer ownership first",
      "chat_settings_page_group_owner_transfer_first_desc": "As the group owner, you must transfer ownership to another member before leaving. Go to Group Management to pick a new owner.",
      "chat_settings_page_group_go_to_management_btn": "Go to Group Management",
      "chat_settings_page_group_cover_photo_title": "Cover Photo",
      "chat_settings_page_featured_posts_btn": "Featured Posts",
      "chat_settings_page_group_name_update_success_toast": "Group name updated",
      "chat_settings_page_group_name_update_fail_toast": "Failed to update group name",
      "chat_settings_page_group_id_update_success_toast": "Group ID updated",
      "chat_settings_page_group_id_taken_toast": "That Group ID is already taken",
      "chat_settings_page_group_id_update_fail_toast": "Failed to update Group ID",
      "chat_settings_page_group_avatar_update_success_toast": "Group avatar updated",
      "chat_settings_page_group_avatar_update_fail_toast": "Failed to update avatar",
      "chat_settings_page_group_bio_update_success_toast": "Bio updated",
      "chat_settings_page_group_bio_update_fail_toast": "Failed to update bio",
      "chat_settings_page_group_cover_photo_update_success_toast": "Cover photo updated",
      "chat_settings_page_group_cover_photo_update_fail_toast": "Failed to update cover photo",
      "chat_settings_page_group_edit_name_dialog_title": "Edit Group Name",
      "chat_settings_page_group_edit_id_dialog_title": "Edit Group ID",
      "chat_settings_page_group_id_helper": "Only lowercase letters, numbers, and hyphens.",
      "chat_settings_page_group_members_load_fail_toast": "Failed to load members. Please try again.",
      "chat_settings_page_group_no_admins_to_demote": "There are no admins to demote.",
      "chat_settings_page_role_changed_fail_toast": "Your role in this group has changed — you no longer have permission to do this.",
      "chat_settings_page_promote_not_member_fail_toast": "This person is no longer a member of this group",
      "chat_settings_page_demote_already_left_toast": "This person has already left the group — no change was needed.",
      "chat_settings_page_transfer_not_member_fail_toast": "Ownership can't be transferred — this person is no longer a member of this group.",
      "chat_settings_page_remove_member_fail_toast": "Failed to remove member",
      "chat_settings_page_leave_group_fail_toast": "Failed to leave group",
      "group_settings": "Group settings",
      "profile_add_featured_group_title": "Add Featured Group",
      "profile_search_groups_placeholder": "Search groups...",
      "profile_no_groups_found": "No groups found.",
      "profile_view_group_profile": "View Group Profile",
      "profile_remove_from_featured": "Remove from Featured",
      "profile_remove_featured_group_title": "Remove featured group?",
      "profile_remove_featured_group_desc": "%1$s will be removed from your featured groups.",
      "profile_no_featured_groups_own": "You haven't added any Featured Groups yet.",
      "profile_contacts_search_placeholder": "Search contacts",
      "profile_contacts_search_clear_aria_label": "Clear search",
      "profile_contacts_empty_title": "Your contacts list is empty",
      "profile_contacts_empty_desc": "Contacts are added by sending or accepting requests.",
      "profile_contacts_no_search_results": "No matches for \"%1$s\".",
      "profile_image_picker_title": "Choose a photo",
      "profile_image_picker_upload_tab": "Upload",
      "profile_image_picker_image_tab": "Image",
      "profile_image_picker_gif_tab": "GIF",
      "profile_image_picker_search_image_placeholder": "Search images...",
      "profile_image_picker_search_gif_placeholder": "Search GIFs...",
      "profile_image_picker_drop_here": "Drop a photo here, or click to browse",
      "profile_image_picker_drop_hint": "JPG, PNG, or GIF",
      "profile_image_picker_no_results": "No items found",
      "profile_start_conversation": "Start Conversation",
      "profile_start_conversation_fail_toast": "Couldn't start this conversation.",
      "profile_add_to_group_action": "Add to Group",
      "profile_cancel_request": "Cancel Request",
      "profile_accept_request": "Accept Contact",
      "profile_add_contact": "Add Contact",
      "profile_image_picker_upload_fail_toast": "Couldn't upload that photo. Try another.",
      "scraper_source_list_title": "Active Feeds",
      "feed_type_selector_rss": "RSS",
      "feed_type_selector_email": "Email",
      "scraper_source_list_empty_description": "There are no active feeds in this group. Tap on the creation button to add a new subscription",
      "scraper_source_list_limit_exceeded_popup_title": "You can add up to 5 feeds to each group. Remove some of the active feeds to add a new one.",
      "scraper_source_list_rss_copied_toast": "Subscription copied",
      "scraper_source_list_unsubscribe_popup_title": "Unsubscribe from %1$s?",
      "scraper_source_list_unsubscribe_popup_unsubscribe_btn": "Unsubscribe",
      "scraper_group_member_perspective_pop_up_title": "There are %1$s RSS feeds in this group",
      "scraper_group_member_perspective_pop_up_description": "Only group owner has the ability to add new subscriptions. You can create a new group and add any subscriptions there.",
      "scraper_add_rss_feed_page_title": "Create RSS Feed",
      "scraper_add_rss_feed_page_tip": "Submit your RSS to add it to %1$s's feed",
      "scraper_add_rss_feed_page_input_bar_hint": "Input your RSS",
      "scraper_add_rss_feed_page_validation_failed_alert": "Oops! This link is not an RSS feed",
      "scraper_add_email_feed_page_title": "Create Email Subscription",
      "scraper_add_email_feed_page_input_bar_hint": "Input your Email Address",
      "scraper_add_email_error": "Not a valid email",
      "scraper_add_email_at_error": "Email can only have one (@) character",
      "scraper_add_email_star_error": "Email can only have one (*) character",
      "scraper_source_list_rss_copy_failed_toast": "Failed to copy",
      "scraper_add_feed_clear_input_aria_label": "Clear input",
      "scraper_source_list_action_failed_toast": "Something went wrong",
      "inapp_browser_prompt_title": "Open this in your browser",
      "inapp_browser_prompt_desc": "For the best experience, open this page in your device's browser.",
      "inapp_browser_prompt_desc_ios": "Tap the ⋯ or Share icon, then choose \"Open in Safari\".",
      "inapp_browser_prompt_desc_android": "Tap ⋮ in the top corner, then choose \"Open in Chrome\".",
      "inapp_browser_prompt_open_button": "Open in Chrome",
      "inapp_browser_prompt_dismiss_aria_label": "Dismiss",
      "settings_page_title": "Settings",
      "settings_page_about_section": "About",
      "settings_page_email_row": "Email",
      "settings_page_email_not_linked": "Not linked",
      "settings_page_email_link_action": "Link",
      "settings_page_email_change_action": "Change",
      "settings_page_email_resend_action": "Resend",
      "settings_page_email_pending_hint": "Sent to %1$s — check your inbox",
      "settings_page_phone_row": "Phone",
      "settings_page_phone_not_linked": "Not linked",
      "settings_page_twitter_row": "X (Twitter)",
      "settings_page_twitter_connect_action": "Connect",
      "settings_page_version_label": "Version",
      "settings_page_email_modal_title": "Link your email",
      "settings_page_email_modal_desc": "We'll send a verification link. Clicking it makes this your account email.",
      "settings_page_email_modal_change_warning": "Verifying a new address will replace your current account email.",
      "settings_page_email_modal_placeholder": "Enter email address",
      "settings_page_email_modal_send_button": "Send verification",
      "settings_page_email_invalid_error": "Please enter a valid email address.",
      "settings_page_email_taken_error": "This email is already in use by another account.",
      "settings_page_email_send_fail_toast": "Failed to send verification email",
      "settings_page_twitter_link_success_toast": "X account connected",
      "settings_page_twitter_link_fail_toast": "Failed to connect X account",
      "settings_page_delete_request_success_toast": "Deletion request received",
      "settings_page_delete_request_fail_toast": "Failed to send deletion request",
      "settings_page_preferences_section": "Preferences",
      "settings_page_time_well_spent_row": "Time well spent",
      "settings_page_time_well_spent_desc": "Remind me to take a break after a period of continuous use",
      "settings_page_time_well_spent_minutes": "%1$s min",
      "settings_page_phone_link_action": "Link",
      "settings_page_phone_modal_title": "Link your phone",
      "settings_page_phone_modal_desc": "We'll text you a 6-digit verification code.",
      "settings_page_phone_modal_placeholder": "Enter phone number",
      "settings_page_phone_modal_send_button": "Send code",
      "settings_page_phone_modal_code_desc": "Enter the code we sent to",
      "settings_page_phone_modal_code_placeholder": "6-digit code",
      "settings_page_phone_modal_verify_button": "Verify",
      "settings_page_phone_invalid_error": "Please enter a valid phone number.",
      "settings_page_phone_taken_error": "This phone number is already in use by another account.",
      "settings_page_phone_code_invalid_error": "Please enter the 6-digit code.",
      "settings_page_phone_link_success_toast": "Phone number linked",
      "settings_page_phone_link_fail_toast": "Failed to link phone number",
      "time_well_spent_modal_title": "Time well spent",
      "time_well_spent_modal_body": "You've been browsing for %1$s minutes. Time for a break?",
      "time_well_spent_modal_dismiss_button": "Keep browsing",
      "add_contact_page_invite_friend_channel_other": "Share Link via Other Apps",
      "add_contact_search_page_no_result_alert_title": "No results found. Please check your spelling and try again.",
      "add_contact_search_page_search_bar_hint_phone_and_id": "Search Phone Number / Username",
      "add_featured_group_success": "%1$s successfully added",
      "alert_add_private_group_member_message": "They will be able to see this group. This action cannot be undone.",
      "alert_add_private_group_member_title": "Add members to this private group?",
      "alert_comment_remove_gif": "Erase the GIF and keep the text comment.",
      "alert_decline_contact_request_title": "Decline this contact request?",
      "alert_erase_voice_note_title": "Erase this voice note?",
      "alert_leave_group": "If you leave this group, you will no longer be able to participate and all history will be lost.",
      "alert_logout": "If you log out, you will need to login with the same e-mail to access your account.",
      "alert_post_erase_group": "This post will be erased for you and all group members.",
      "alert_post_featured_group": "This post will be highlighted for all group members, and will deliver to a new group member's Inbox when they join.",
      "alert_post_remove_group": "This post will be removed for you and all group members. And an event will generate in the group.",
      "alert_post_set_as_first_group": "This will be the first post delivered to a new group member’s Inbox when they join.",
      "alert_post_un_featured_group": "This post will no longer be highlighted, and will not deliver to a new member's Inbox.",
      "alert_refuse_join_group_request_title": "Refuse this request to join?",
      "alert_remove_featured_group": "If you remove %1$s, the group will no longer be featured on your group profile.",
      "alert_remove_group_member": "If you remove group members, they will lose access to the group and all group activity.",
      "app_level_prompt_to_promote_offline_activity_description": "SELECT is ad-free and therefore not engineered to addict you. Want to take a break from your phone?",
      "app_level_prompt_to_promote_offline_activity_leave_app_btn": "Leave now",
      "app_level_prompt_to_promote_offline_activity_snooze_btn": "Stay for %1$s mins",
      "chat_settings_page_group_cover_photo_remove_title": "Remove Cover Photo",
      "chat_settings_page_group_cover_photo_update_title": "Update Cover Photo",
      "chat_settings_page_group_id_already_exits_alert_title": "Oops, this Group ID is already taken. Please try another.",
      "chat_settings_page_group_id_invalid_alert_title": "Invalid Group ID",
      "chat_settings_page_group_id_picker_page_selector_error": "Your Group ID may only consist of letters, numbers and underscores, between 3 to 15 characters long.",
      "chat_settings_page_group_invalid_users_alert": "Cannot select this user",
      "chat_settings_page_group_leave_group_alert_title": "Are you sure you want to leave the group?",
      "chat_settings_page_group_nav_title": "Group Settings",
      "chat_settings_page_private_nav_title": "Create a Group",
      "chat_settings_remove_group_admin_nav_title": "Remove Admin",
      "connections_count": "Connections",
      "contacts_empty_subtitle": "Add contacts to see them here.",
      "contacts_section_contact_requests": "Contact requests",
      "contacts_section_group_requests": "Group requests",
      "conversation_page_nav_title": "Conversation",
      "choose_conversation": "Choose Conversation",
      "create_image_post_page_text_input_hint": "What's on your mind?",
      "create_image_post_page_title": "Image Post",
      "create_link_post_page_fetch_button": "Show Link Preview",
      "create_link_post_page_link_description_input_hint": "Enter a description (optional)",
      "create_link_post_page_link_input_hint": "Enter a link or a keyword to search",
      "create_link_post_page_link_input_title": "Link or Search Keyword",
      "create_link_post_page_search_button": "Web Search",
      "create_link_post_page_search_in_clipboard": "Paste link from clipboard",
      "create_message_post_page_nav_title": "New Post",
      "create_poll_post_page_add_poll_option_title": "Add a poll option",
      "create_poll_post_page_description_input_title": "Ask a question here",
      "create_poll_post_page_poll_limit_reached_alert": "You've reached the limit of %1$s options per poll. Please remove an option in order to add another one",
      "create_poll_post_page_poll_option_section_title": "Add options below",
      "create_post_posting_turned_off_toast": "Posting has been turned off",
      "cross_mention_hint": "via",
      "drafts_panel_on_post": "On post",
      "empty_featured_group": "What are Featured Groups? As group owner, you can recommend other relevant groups to your members, and display them here. Tap the plus icon above, then choose a group.",
      "featured_group_create_alert_title": "Feature this Group?",
      "featured_group_input_placeholder": "Type group name here",
      "featured_group_open_alert_remove_option": "Remove Featured Group",
      "general_accept_btn": "Accept",
      "general_decline_btn": "Decline",
      "general_minute_plural": "mins",
      "general_next_btn": "Next",
      "general_no_result": "No results",
      "general_ok_btn": "OK",
      "general_or_label": "Or",
      "general_search_btn": "Search",
      "general_sent_btn": "Sent",
      "general_skip_btn": "Skip",
      "general_share_btn": "Share",
      "http_cancel_error": "Request has been canceled.",
      "http_client_error": "Oops. Something went wrong. Please try again.",
      "http_connection_error": "Oops. Please ensure your internet connection is stable.",
      "http_network_error": "Oops. Please check your internet connection.",
      "http_server_error": "The server is not responding. Please try again later.",
      "http_timeout_error": "The network connection is slow. Please check and try again.",
      "http_unknown_error": "Oops. Something went wrong. Please try again.",
      "image_picker_albums_btn": "Albums",
      "image_picker_alert_upload_media_size_too_big": "This media exceeds the size limit. Please select another.",
      "image_picker_camera_btn": "Camera",
      "image_picker_web_search_btn": "Web Search",
      "image_upload_file_size_too_big": "Image file size is too big. Please upload a smaller image",
      "inbox_page_group_request_activity_one_liner": "wants to join %1$s",
      "inbox_page_post_sending_status_bar_failed_text": "Failed to send this post. Try again?",
      "inbox_page_zero_view_image_1": "https://cloudfront-stg.selectdc1.com/b3dee462-703a-11eb-b546-1ec2622942d4.png",
      "inbox_page_zero_view_image_2": "https://cloudfront.selectdc1.com/2ac4afbe-7276-11eb-8749-2e8dd739c3d8.png",
      "inbox_page_zero_view_image_3": "https://cloudfront.selectdc1.com/db001af8-7276-11eb-8749-2e8dd739c3d8.png",
      "inbox_unsnooze_all_toast": "Snoozed posts are back in your Inbox",
      "increment_swipe_bottom_toast": "Post snoozed for 30 minutes",
      "increment_swipe_left_toast": "Post moved to History",
      "invalid_jwt_token": "Session expired. Please log in again.",
      "invitation_group_invite_selector_title": "Group Invite Bundle",
      "join_group_requests_empty": "No join group requests",
      "landing_page_contact_invitation": "Invites you to join SELECT!",
      "landing_page_group_invitation": "Invites you to join the group!",
      "landing_page_title": "Not Just Anybody",
      "me_about_delete_account_confirm": "Delete",
      "me_about_page_nav_title": "About Us",
      "me_account_settings_page_about_email_us": "SELECT serves you, not ads.  Minimal personal data is stored for your benefit.  To see, remove or modify yours, please email",
      "me_account_settings_page_about_title": "About Us",
      "me_account_settings_page_log_out_btn": "Log Out",
      "me_account_settings_page_time_well_spent_prompt_title": "Screen Time Reminder",
      "me_edit_profile_page_display_name_input_hint": "Enter display name",
      "me_edit_profile_page_id_input_hint": "Enter your Username",
      "me_push_notification_settings_page_nav_title": "Notifications",
      "me_push_notification_settings_page_open_system_desc": "Open System Notification Settings",
      "me_push_notification_settings_page_open_system_warning_desc": "Notifications are turned off in system settings.",
      "me_push_notification_settings_page_option_always": "All",
      "me_push_notification_settings_page_option_everytime": "As soon as arrive",
      "me_push_notification_settings_page_option_everytime_desc": "Receive all notifications immediately",
      "me_push_notification_settings_page_option_high_level_desc": "Only important activity and direct messages",
      "me_push_notification_settings_page_option_never": "None",
      "me_push_notification_settings_page_option_never_desc": "Disable all push notifications",
      "me_push_notification_settings_page_option_once_per_hour": "Once per hour",
      "me_push_notification_settings_page_option_once_per_hour_desc": "Bundled notification digest every hour",
      "me_push_notification_settings_page_option_twice_per_day": "Only at 10 am & 8 pm",
      "me_push_notification_settings_page_option_twice_per_day_desc": "Bundled notification digest twice daily",
      "mfs_friend_selector_page_search_contact_input_hint": "Search Name",
      "mfs_friend_selector_page_suggestion_list_title": "Consider selecting",
      "missing_field": "Seems like one of the required fields is missing!",
      "no_permission_for_this_action": "No permission for this action",
      "onboarding_address_book_permission_priming_btn_not_now": "No, not now",
      "onboarding_address_book_permission_priming_btn_yes": "Yes, do it",
      "onboarding_address_book_permission_priming_description": "Finding your friends on SELECT is simple if you use your address book. Don't worry, it won't be used for anything else.",
      "onboarding_address_book_permission_priming_nav_title": "Who's here?",
      "onboarding_address_book_permission_priming_title": "Find your friends!",
      "onboarding_notification_settings_priming_description": "Only from the people and posts you care about.",
      "onboarding_notification_settings_priming_option_btn_high_signal_subtitle": "(Only contacts and posts I interact with)",
      "onboarding_notification_settings_priming_option_btn_high_signal_title": "Personal",
      "onboarding_notification_settings_priming_option_btn_never": "None",
      "onboarding_notification_settings_priming_option_btn_once_per_hour": "Once per hour",
      "onboarding_notification_settings_priming_option_btn_twice_per_day": "Only at 10 am & 8 pm",
      "onboarding_notification_settings_priming_title": "Enjoy fewer notifications",
      "people_page_suggestion_hint_description_afternoon": "You may want to share with",
      "people_page_suggestion_hint_title_afternoon": "Good afternoon, %1$s.",
      "people_page_suggestion_hint_title_evening": "Good evening, %1$s.",
      "people_page_suggestion_hint_title_morning": "Good morning, %1$s.",
      "post_detail_load_newer_comments_button": "Load newer comments",
      "relationship_not_pending": "Invalid contact request",
      "remove_contact_fail_toast": "Failed to remove contact",
      "remove_contact_success_toast": "Contact removed",
      "remove_featured_group_success": "%1$s successfully removed",
      "select_inbox_group_request_text": "wants to join the group",
      "sent_empty": "No sent requests",
      "share_content_page_nav_title": "Share Content",
      "share_content_url_copy_to_clipboard_toast_alert": "Content Link copied to clipboard",
      "sign_up_add_name_and_photo_page_name_input_description": "This name will be shown to your contacts in SELECT.",
      "sign_up_add_name_and_photo_page_name_input_hint": "Your Name",
      "sign_up_add_name_and_photo_page_nav_title": "Add your name and photo",
      "sign_up_create_email_page_error_email_existed": "This email is already used",
      "sign_up_create_select_id_page_error_id_existed": "Sorry, this ID is already taken. ",
      "sign_up_create_select_id_page_input_description_why_select_id": "Set your unique username so friends can find you via search.",
      "sign_up_create_select_id_page_input_hint": "Your Username",
      "sign_up_create_select_id_page_nav_title": "Create Username",
      "sign_up_enter_gender_page_nav_title": "Your gender",
      "sign_up_enter_gender_page_options_description": "This may be changed later in user profile settings.",
      "sign_up_enter_phone_number_page_error_invalid_phone_number": "Please make sure the phone number and country are correct.",
      "sign_up_enter_phone_number_page_input_description_link_terms": "Terms of Service",
      "sign_up_enter_phone_number_page_input_error": "SELECT values your privacy.  To proceed, please first check the box above.  ",
      "sign_up_invitation_expired": "Invitation expired. Please contact the person who invited you to follow up.",
      "sign_up_invitation_under_review": "Invitation is under review. Please contact the person who invited you to follow up.",
      "sign_up_invitation_was_reported": "Invitation was reported. Please contact the person who invited you to follow up.",
      "sign_up_invite_gate_checking_title": "Checking invitation",
      "sign_up_invite_gate_checking_body": "Looking for a link before showing anything else.",
      "sign_up_invite_gate_ask_title": "Do you have an invitation link?",
      "sign_up_invite_gate_ask_yes": "Yes, I have one",
      "sign_up_invite_gate_ask_yes_caption": "I'll open it now",
      "sign_up_invite_gate_ask_no": "No, not yet",
      "sign_up_invite_gate_ask_no_caption": "I don't have a link",
      "sign_up_invite_gate_find_title": "Find your invitation",
      "sign_up_invite_gate_find_body": "Tap the invitation link",
      "sign_up_invite_gate_find_body_detail": "It opens this app, and we check it before showing anything else.",
      "sign_up_invite_gate_find_email": "Open your email or text",
      "sign_up_invite_gate_find_email_detail": "Find the invitation link there.",
      "sign_up_invite_gate_find_paste": "Paste the link",
      "sign_up_invite_gate_find_paste_detail": "Copy it into the field below.",
      "sign_up_invite_gate_find_placeholder": "Paste your invitation link",
      "sign_up_invite_gate_find_invalid": "That doesn't look like an invitation link.",
      "sign_up_invite_gate_find_none": "I don't have one after all",
      "sign_up_invite_gate_need_title": "You'll need an invitation to join",
      "sign_up_invite_gate_need_body": "This community is invite-only. Ask whoever invited you to send a link.",
      "sign_up_invite_gate_need_member_note": "Already a member? Log in with your existing account instead.",
      "sign_up_invite_gate_load_failed_title": "Couldn't load this invitation",
      "sign_up_invite_gate_load_failed_body": "We have the link but couldn't load this community. Retry from here.",
      "sign_up_invite_gate_not_carried_title": "We couldn't use an invitation",
      "sign_up_invite_gate_not_carried_invited": "If you were invited, open the email on this phone and use your default browser, not an in-app one.",
      "sign_up_invite_gate_not_carried_uninvited": "If you weren't invited, you'll need an invitation from a member. Log in if you already have an account.",
      "sign_up_invite_gate_expired_title": "Invitation expired",
      "sign_up_invite_gate_expired_body": "Ask whoever invited you to send a new link.",
      "sign_up_invite_gate_expired_member_note": "Already have an account? Log in with the account that was invited.",
      "sign_up_landing_screen_no_invitation_join_waitlist_option": "Join Waitlist",
      "sign_up_landing_screen_no_invitation_login_option": "Member Login",
      "sign_up_landing_screen_no_invitation_other_title": "Otherwise",
      "sign_up_landing_screen_no_invitation_title": "Welcome",
      "sign_up_landing_screen_no_invitation_title_2": " - You found this, so you're not just anybody!",
      "sign_up_landing_screen_no_invitation_title_3": "One last thing to join your exclusive community",
      "sign_up_landing_screen_no_invitation_title_4": "Open your email and tap the Launch & Join button",
      "sign_up_set_pwd_page_input_description_pwd_error": "The password has to be 6 to 16 characters long, contain only latin letters, numbers or \"@#$%^&*\" symbols",
      "sign_up_too_many_attempt_to_validate_phone_number": "The code is incorrect. Please try again in 30 seconds",
      "swipeable_inbox_tooltip_text_snooze": "Double tap to view snoozed posts",
      "update_forced_pop_up_title": "Update is required!",
      "update_notice_pop_up_dismiss_btn": "Remind me in 3 days",
      "update_notice_pop_up_title": "New update is available!",
      "update_pop_up_btn": "Update Now",
      "update_profile_picture_dialog_title": "Set Group Avatar",
      "update_profile_picture_image_source_option_album": "Choose from Album",
      "user_profile_page_accept_request_btn": "Accept Request",
      "user_profile_page_toast_group_id_copied": "Group ID Copied",
      "user_profile_page_toast_group_url_copied": "Community Page Link Copied",
      "user_profile_settings_delete_contact_alert_title": "Are you sure you want to delete this contact?",
      "web_image_search_page_image_type_tab_gif": "GIFs",
      "web_image_search_page_image_type_tab_image": "Images",
      "web_image_search_page_search_bar_hint": "Web Search",
      "auth_email_link_expired_title": "This link can't be used",
      "auth_email_link_expired_body": "This Launch and Join link has expired or was already used. Enter the verification code from the email to continue.",
      "auth_email_link_unavailable_title": "Couldn't verify your email",
      "auth_email_link_unavailable_body": "The verification link didn't finish. Check your connection and try again, or enter the code from the email.",
      "auth_email_link_enter_code": "Enter verification code",
      "auth_email_link_back": "Back to sign in",
      "product_website_brand_wordmark": "SELECT",
      "product_website_skip_to_content": "Skip to content",
      "product_website_nav_communities": "Communities",
      "product_website_cta_start_community": "Start a community",
      "product_website_cta_browse_communities": "Browse communities",
      "product_website_hero_title": "Your people are %1$s.",
      "product_website_hero_title_accent": "here",
      "product_website_hero_sub": "SELECT is where your group chat grows up — real communities for your real people, away from the feed.",
      "product_website_hero_mock_aria": "Three phones showing communities living on SELECT",
      "product_website_build_kicker": "Watch one get built",
      "product_website_build_title": "Say it in a sentence. Get a whole home.",
      "product_website_build_chip_no_templates": "no templates",
      "product_website_build_chip_no_wizard": "no setup wizard",
      "product_website_build_chip_60_seconds": "~60 seconds",
      "product_website_build_you_type": "You type",
      "product_website_build_select_builds": "SELECT builds",
      "product_website_build_caption": "Example output — illustrative",
      "product_website_build_aria": "Illustrative mock — a one-sentence prompt generating a branded community",
      "product_website_build_preset_1_prompt": "an intellectual hangout for curious minds",
      "product_website_build_preset_1_name": "Manila Night Runners",
      "product_website_build_preset_1_tagline": "Run the city after dark",
      "product_website_build_preset_2_prompt": "a community for people who want better sleep",
      "product_website_build_preset_2_name": "The Finishers",
      "product_website_build_preset_2_tagline": "One book at a time, actually finished",
      "product_website_build_preset_3_prompt": "a movie and TV club that talks about more than movies",
      "product_website_build_preset_3_name": "Solder & Sine",
      "product_website_build_preset_3_tagline": "Old synths, new life",
      "product_website_build_preset_4_prompt": "a fan community for everyone who follows SpaceX launches",
      "product_website_build_preset_4_name": "Studio Signal",
      "product_website_build_preset_4_tagline": "Our design team's private room",
      "product_website_spine_kicker": "What you get",
      "product_website_spine_title": "A place that behaves like a place.",
      "product_website_spine_sub": "Not a feed you fall into. A community you walk into, leave, and come back to.",
      "product_website_spine_station_1_title": "The thread keeps its shape",
      "product_website_spine_station_1_body": "Replies stay attached to what they answer, so a month-old conversation still reads top to bottom.",
      "product_website_spine_station_2_title": "You can say it to one person",
      "product_website_spine_station_2_body": "A private reply lands inside the conversation, visible only to who it's for.",
      "product_website_spine_station_3_title": "It carries your name everywhere",
      "product_website_spine_station_3_body": "The same branded community on web, iOS and Android — never flattened into someone else's timeline.",
      "product_website_spine_thread_author": "Dee L.",
      "product_website_spine_thread_when": "5 weeks ago",
      "product_website_spine_thread_post": "Patched the drone rack — three oscillators, one patient neighbour.",
      "product_website_spine_thread_reply": "Found this today and followed every word.",
      "product_website_spine_private_label": "Private reply · only %1$s sees this",
      "product_website_spine_private_to": "Maya",
      "product_website_spine_private_text": "Bring the harbour piece on Friday. It's the best thing you've made and you keep hiding it.",
      "product_website_spine_chip_1": "Switchback",
      "product_website_spine_chip_2": "Ronin",
      "product_website_spine_chip_3": "Analog Drift",
      "product_website_communities_kicker": "Open right now",
      "product_website_communities_title": "Communities are already talking.",
      "product_website_communities_browse_all": "Browse all",
      "product_website_common_members": "%1$s members",
      "product_website_community_card_aria": "%1$s — community on SELECT",
      "product_website_seo_title": "SELECT — Your people are here",
      "product_website_seo_description": "SELECT is where your group chat grows up — real communities for your real people, away from the feed. Free to start, about a minute to build, no ads ever.",
      "product_website_go_to_app": "Open SELECT",
      "product_website_store_app_store": "App Store",
      "product_website_store_google_play": "Google Play",
      "product_website_get_app_kicker": "Take it with you",
      "product_website_get_app_title": "Your communities, in your pocket.",
      "product_website_get_app_sub": "The same branded community on web, iOS and Android — free, and no advertising.",
      "product_website_store_download_on": "Download on the",
      "product_website_store_get_it_on": "Get it on",
      "product_website_cta_title": "Describe yours in one sentence.",
      "product_website_cta_sub": "Free to start. About a minute to build. No ads, ever.",
      "product_website_footer_terms": "Terms of Service",
      "product_website_footer_legal_line": "© %1$s SELECT. All rights reserved."
    },
    "zh-CN": {
      "general_conversations": "对话",
      "general_privacy": "隐私",
      "general_report": "举报",
      "general_terms": "条款",
      "general_loading": "加载中...",
      "general_contacts": "联系人",
      "general_featured_groups": "精选群组",
      "general_edit": "编辑",
      "general_discard_btn": "放弃",
      "general_save_btn": "保存",
      "general_ok": "确定",
      "general_submit_btn": "提交",
      "general_cancel_btn": "取消",
      "general_bio": "介绍",
      "general_join_with_google": "通过Google加入",
      "general_processing": "处理中",
      "general_uploading": "上传中",
      "general_upload": "上传",
      "general_confirm": "确认",
      "general_remove": "删除",
      "general_delete": "删除",
      "general_update": "更新",
      "general_continue": "继续",
      "general_female_gender": "女",
      "general_male_gender": "男",
      "general_prefer_not_to_say_gender": "不说性别",
      "general_birthday": "生日",
      "general_done": "完成",
      "general_home": "主页",
      "general_profile": "个人信息",
      "general_user_profile": "个人信息",
      "general_account": "账号",
      "general_legal": "法律",
      "general_logout": "登出",
      "general_back": "后退",
      "general_private_conversation": "私人聊天",
      "general_inbox": "信箱",
      "general_delete_account": "删除账号",
      "general_send_post": "发送",
      "general_add": "添加",
      "general_insert": "插入",
      "general_all_btn": "全部",
      "general_curated_btn": "SELECT",
      "general_none_btn": "无",
      "general_sending_post": "发送内容",
      "general_cancel_sending_post": "取消发送内容",
      "general_sending_comment": "发送评论",
      "general_cancel_sending_comment": "取消发送评论",
      "general_erase": "消除",
      "general_retry": "重试",
      "general_confirmation_modal_sr_label": "确认对话框",
      "general_search_placeholder": "搜索...",
      "get_app": "获取app",
      "auth_modal_powered_by": "由 SELECT 提供支持",
      "auth_modal_close_aria_label": "关闭",
      "auth_modal_desc": "SELECT 在 App 上体验更好",
      "auth_modal_download_app": "下载Select",
      "auth_modal_continue_app": "使用 App 继续",
      "auth_modal_continue_web": "使用网页继续",
      "auth_modal_inapp_title_android": "在系统浏览器中打开，获得完整体验",
      "auth_modal_inapp_title_ios": "在 Safari 中打开，获得完整体验",
      "auth_modal_inapp_desc_android": "应用内浏览器可能会阻止登录和支付。只需两步即可切换到系统浏览器。",
      "auth_modal_inapp_desc_ios": "应用内浏览器可能会阻止登录和支付。只需两步即可切换到 Safari。",
      "auth_modal_inapp_step_1": "点击右上角的%1$s",
      "auth_modal_inapp_step_1_highlight": "··· 菜单",
      "auth_modal_inapp_step_2": "选择%1$s",
      "auth_modal_inapp_step_2_highlight_android": "在系统浏览器中打开",
      "auth_modal_inapp_step_2_highlight_ios": "在 Safari 中打开",
      "auth_modal_inapp_copy_link": "改为复制链接",
      "auth_modal_inapp_copy_link_success_toast": "链接已复制",
      "auth_modal_inapp_copy_link_fail_toast": "无法复制链接",
      "auth_modal_inapp_continue": "继续使用此浏览器",
      "login_heading": "登录你的账户",
      "login_google_title": "使用 Google 连接",
      "login_btn": "继续",
      "login_phone_invalid": "手机号码无效",
      "login_phone_placeholder": "输入手机号码",
      "login_separator": "或",
      "login_otp_heading": "验证码已发送至你的手机",
      "login_otp_btn": "验证",
      "login_otp_resend_label": "重新发送验证码",
      "login_otp_sent": "验证码发送成功",
      "login_otp_not_received_label": "没有收到验证码？",
      "login_otp_resend_after": "之后重新发送验证码",
      "login_phone_no_not_registered_toast": "该手机号码尚未注册，请先注册",
      "lp_login_email_code_label": "验证码",
      "lp_login_email_code_placeholder": "6 位验证码",
      "lp_about": "关于",
      "email_hint_collapsed_ms": "没看到邮件？请检查垃圾邮件文件夹。",
      "email_hint_collapsed_yahoo": "没看到邮件？请检查垃圾邮件文件夹。",
      "email_hint_collapsed_gmail": "没看到邮件？请检查更新标签页。",
      "email_hint_collapsed_zoho": "没看到邮件？请检查通知标签页。",
      "email_hint_collapsed_apple": "没看到邮件？请检查垃圾邮件文件夹。",
      "email_hint_collapsed_other": "没看到邮件？请检查垃圾邮件或废件文件夹。",
      "email_hint_ms_title": "检查垃圾邮件文件夹",
      "email_hint_ms_body": "Outlook有时会过滤来自新发件人的邮件。请在垃圾邮件文件夹中找到该邮件，点击'**非垃圾邮件**'，以确保日后的验证码能发送到您的收件箱。",
      "email_hint_yahoo_title": "检查垃圾邮件文件夹",
      "email_hint_yahoo_body": "Yahoo和AOL有时会过滤来自新发件人的邮件。请在垃圾邮件文件夹中找到该邮件，点击'**非垃圾邮件**'，以确保日后的验证码能发送到您的收件箱。",
      "email_hint_gmail_title": "检查更新标签页",
      "email_hint_gmail_body": "Gmail可能会将验证码邮件归类到更新标签页。**将此邮件拖至主要标签页**，以便日后的验证码直接发送到那里。",
      "email_hint_zoho_title": "检查通知标签页",
      "email_hint_zoho_body": "Zoho可能会将验证码邮件归类到通知标签页。请将此邮件移至收件箱，以便日后的验证码直接发送到那里。",
      "email_hint_apple_title": "检查垃圾邮件文件夹",
      "email_hint_apple_body": "iCloud可能会过滤来自新发件人的邮件。请在垃圾邮件文件夹中找到该邮件，并将其标记为'**非垃圾邮件**'。",
      "email_hint_other_title": "没看到邮件？",
      "email_hint_other_body": "请检查垃圾邮件、废件或促销邮件文件夹。将邮件标记为'**非垃圾邮件**'，以确保日后的验证码能发送到您的收件箱。",
      "connection_lost_title": "连接已断开",
      "connection_lost_description": "无法连接到服务器。请检查网络连接后重试。",
      "connection_lost_reassurance": "您的消息已保存——您正在发送的内容会在重新联网后自动发出，不会丢失",
      "connection_lost_reconnect_btn": "重新连接",
      "post_detail_embed_link": "将帖子嵌入网页",
      "post_detail_embed_link_copied": "代码已复制",
      "post_detail_comment_delete_sure_1": "确定吗？",
      "post_detail_comment_delete_sure_2": "此评论将对你和该收件人永久删除",
      "post_detail_comment_media_restore_fail_toast": "无法恢复媒体，请重试。",
      "post_detail_one_liner_receive_private_image_post": "分享了一条媒体给你",
      "post_detail_one_liner_receive_and_send_group_image_post": "分享了一条媒体到群 %1$s",
      "post_detail_meta_description_type_image_post": "在以下社区分享了一条媒体帖子：",
      "post_detail_one_liner_send_private_image_post_singular": "分享了一条媒体给 1 个联系人",
      "post_detail_one_liner_send_private_image_post_plural": "分享了一条媒体给 %1$s 个联系人",
      "post_detail_one_liner_receive_private_link_post": "分享了一个链接给你",
      "post_detail_one_liner_receive_and_send_group_link_post": "分享了一个链接到群 %1$s",
      "post_detail_meta_description_type_link_post": "在以下社区分享了一条链接帖子：",
      "post_detail_one_liner_send_private_link_post_singular": "分享了一个链接给 1 个联系人",
      "post_detail_one_liner_send_private_link_post_plural": "分享了一个链接给 %1$s 个联系人",
      "post_detail_one_liner_receive_private_poll_post": "向你发起了投票",
      "post_detail_one_liner_receive_and_send_group_poll_post": "发起了投票到群 %1$s ",
      "post_detail_meta_description_type_poll_post": "在以下社区分享了一条投票帖子：",
      "post_detail_one_liner_send_private_link_poll_singular": "向1个联系人发起了投票",
      "post_detail_one_liner_send_private_link_poll_plural": "向 %1$s 个联系人发起了投票",
      "post_detail_one_liner_receive_private_text_message_post": "分享了文字消息给你",
      "post_detail_one_liner_receive_and_send_group_text_message_post": "分享了文字消息到群 %1$s",
      "post_detail_one_liner_send_private_text_message_post_singular": "分享了文字消息给 1 个联系人",
      "post_detail_one_liner_send_private_text_message_post_plural": "分享了文字消息给 %1$s 个联系人",
      "post_detail_one_liner_receive_private_voice_message_post": "分享了语音消息给你",
      "post_detail_one_liner_receive_and_send_group_voice_message_post": "分享了语音消息到群 %1$s",
      "post_detail_one_liner_send_private_voice_message_post_singular": "分享了语音消息给 1 个联系人",
      "post_detail_one_liner_send_private_voice_message_post_plural": "分享了语音消息给 %1$s 个联系人",
      "post_detail_one_liner_receive_private_gif_message_post": "分享了GIF动图消息给你",
      "post_detail_one_liner_receive_and_send_group_gif_message_post": "分享了GIF动图消息到群 %1$s",
      "post_detail_one_liner_send_private_gif_message_post_singular": "分享了GIF动图消息给 1 个联系人",
      "post_detail_one_liner_send_private_gif_message_post_plural": "分享了GIF动图消息给 %1$s 个联系人",
      "post_detail_one_liner_send_thread_post": "分享了一个链式贴子 via",
      "select-threader": "select-threader",
      "post_detail_reaction_sending_toast": "正在发送表情回复...",
      "post_detail_reaction_sending_and_adding_friend_toast": "已发送联系人请求。对方通过后，你的回应才会可见",
      "post_detail_section_relationship_not_accepted": "你和 %1$s 尚未建立联系。只有在 %2$s 接受你的联系人请求后，你发送的评论才会可见。",
      "post_detail_reaction_sent_toast": "表情回复已发送",
      "post_detail_reaction_fail_sender_is_not_contact_description": "在SELECT里，所有内容都是默认不对他人可见的，表情回复也一样。添加此内容的发送者开启你们之间的互动吧！",
      "post_detail_load_more_button": "加载更多评论",
      "post_detail_new_activity_button": "新动态",
      "post_delete_sure_1": "确定吗？",
      "post_delete_sure_2": "此帖子将对你和所有收件人永久删除。",
      "post_detail_comment_screenshot_event": "%1$s 将此讨论截屏",
      "post_detail_post_screenshot_event": "%1$s 将这个内容截屏",
      "post_detail_post_and_comment_screenshot_event": "%1$s 将这个内容和讨论截屏",
      "post_detail_instant_gif_cross_mention_not_supported": "发送快速GIF动图评论时，不支持交叉发布",
      "post_detail_quick_gif_fail_toast": "无法发送 GIF，请重试",
      "post_detail_quick_gif_generating": "文字 → GIF…",
      "post_detail_remove_link_preview_title": "移除链接预览？",
      "post_detail_remove_link_preview_description": "这将从你的评论中移除链接预览，评论文字会保留",
      "post_detail_remove_media_title": "移除该媒体？",
      "post_detail_remove_media_description": "这将从你的评论中移除，评论文字会保留",
      "post_detail_quote_jump_not_found": "找不到该消息",
      "cross_mention_title": "交叉发布到你 #点名 的群组",
      "cross_mention_exposure_off_toast": "%1$s 已关闭交叉发布，因此未在该群组分享",
      "cross_mention_over_limit_toast": "交叉发布最多支持前 3 个群组，另有 %1$s 个未分享",
      "cross_mention_limit_hint": "只有你 #点名 的前 3 个群组会被交叉发布",
      "reply_comment_placeholder_text": "[文字]",
      "reply_comment_placeholder_gif": "[GIF动图]",
      "reply_comment_placeholder_voice": "[语音]",
      "reply_comment_placeholder_image": "[图片]",
      "reply_comment_placeholder_media": "[媒体]",
      "post_uploading_status_remaining": "还有 %1$s 张图片在上传",
      "post_uploading_status_done": "上传完成",
      "post_detail_content_unavailable": "该内容已不可用",
      "post_detail_comment_blocked_content_unavailable_fail_toast": "该内容已不可用，您的评论未发送。",
      "post_detail_deletion_no_permission_fail_toast": "无法移除该内容——您不再拥有权限。",
      "post_actions_menu_aria_label": "内容操作",
      "lp_heading": "社交社区，为",
      "lp_recent_popular_community_highlights": "✨ 社区精选",
      "lp_recent_popular_community_highlights_description": "看看社区在讨论什么",
      "lp_recent_popular": "近期热门帖子",
      "lp_google_title": "使用 Google 注册",
      "lp_join_community": "加入社区",
      "lp_invited": "你受邀加入",
      "lp_embed_code_copied": "代码已复制",
      "lp_footer_text": "这是用户创建的内容，不代表 SELECT 的观点或立场。",
      "lp_join_now": "立即加入：",
      "lp_join_email": "请查看 %1$s 的收件箱！",
      "lp_community_mail": "社区链接已由 %1$s 通过 SELECT 发送",
      "lp_invite_user": "%1$s 中一群志同道合的人正在讨论这个话题。",
      "lp_check_join_email": "请在邮箱中查看 %1$s！",
      "lp_community_join_int": "点击邮件中的链接即可加入。如果几分钟内没有收到邮件，请检查垃圾邮件文件夹。",
      "lp_login_email_sent_toast": "邮件发送成功",
      "lp_group_invitation": "邀请你加入",
      "lp_signup_need_community": "请使用你的 https://[community].the.select 链接进行注册",
      "lp_signing_in": "正在为你登录...",
      "lp_click_if_not_redirected": "若未自动跳转，请点击这里",
      "lp_login_signup": "注册 / 登录",
      "lp_not_found": "你访问的社区尚未设置公开主页。如果你有兴趣加入该社区，请联系社区所有者邀请你。",
      "lp_applications_closed": "申请已关闭",
      "lp_link_expired": "链接已过期",
      "lp_invitation_description": "你受邀加入 %1$s 的专属社交应用与社区！请通过此临时链接加入其仅限邀请的主页！",
      "lp_community_meta_description": "你受邀加入 %1$s 的社交应用与社区！立即加入主页！",
      "lp_login_signup_email_continue": "继续",
      "lp_login_signup_privacy": "SELECT绝不会在未经您许可的情况下发布任何内容。",
      "lp_login_email_placeholder": "您的邮箱",
      "lp_login_signup_header": "注册或登录:",
      "lp_login_signup_or": "或",
      "lp_login_signup_fallback_title": "不仅仅是任何人都可以",
      "lp_login_signup_email_check_inbox": "检查您的收件箱",
      "lp_login_signup_login_with": "用 %1$s 登录",
      "lp_login_signup_continue_with": "用 %1$s 继续",
      "lp_login_signup_verification_code": "我们发送了一个6位数的代码",
      "lp_login_signup_verification_link": "点击我们发送到 %1$s 的链接以完成账户设置。",
      "lp_login_phone_verification_title": "需要手机验证",
      "lp_login_phone_verification_description": "出于安全原因，请验证您的手机号码以完成注册。",
      "lp_login_phone_placeholder": "输入手机号码",
      "lp_login_phone_send_code": "发送验证码",
      "lp_login_phone_code_placeholder": "输入6位验证码",
      "lp_login_phone_verify_code": "验证代码",
      "lp_login_phone_verification_sent": "验证码发送成功！",
      "lp_login_phone_verification_error": "验证失败，请重试。",
      "lp_login_phone_code_invalid": "请输入有效的6位验证码。",
      "lp_login_phone_verification_sent_to": "验证码已发送至",
      "lp_login_phone_china_info": "根据中国法规要求，中国用户需要进行手机验证。",
      "lp_login_birthday_title": "验证你的年龄",
      "lp_login_birthday_description": "出于安全和合规要求，请提供你的出生日期。",
      "lp_login_birthday_required": "请输入你的出生日期",
      "lp_login_birthday_age_restriction": "你必须年满 16 岁才能使用本服务",
      "lp_login_birthday_privacy_note": "你的出生日期仅用于年龄验证",
      "lp_preview_banner_text": "此页面尚未上线。你正在预览社区发布后的效果。",
      "lp_guest_view_banner_text": "你正在以访客身份浏览该社区。",
      "lp_guest_view_banner_link": "前往社区动态",
      "lp_login_otp_error_invalid_code": "验证码错误，请重试。",
      "lp_login_otp_error_too_many_attempts": "尝试次数过多，请稍后重试。",
      "lp_login_otp_backoff_notice": "尝试次数过多，请在 %1$s 秒后重试。",
      "lp_login_otp_error_rate_limited": "请求过于频繁，请稍后重试。",
      "lp_login_otp_error_generic": "出错了，请重试。",
      "lp_login_otp_resend_success_toast": "新的验证码已发送。",
      "lp_login_birthday_update_fail_toast": "注册会话已过期，请重新注册。",
      "message_post_creation_panel_title": "临时会话",
      "message_post_creation_panel_one_liner": "创建临时会话",
      "message_post_creation_panel_add_message_hint": "说说你的想法...",
      "message_post_creation_panel_send_post_hint": "开启临时会话",
      "message_post_creation_panel_attention_prompt_description": "确定要放弃编辑吗？这个内容将丢失",
      "post_detail_comment_discard_title": "放弃这条评论？",
      "post_detail_comment_discard_description": "此操作无法撤销",
      "post_detail_comment_resend_aria_label": "重新发送评论",
      "post_detail_comment_discard_aria_label": "放弃评论",
      "post_detail_comment_quote_nav_aria_label": "跳转到被引用的评论",
      "post_detail_remove_media_aria_label": "移除媒体",
      "post_detail_one_liner_receive_message_post": "分享了临时会话给你",
      "post_detail_one_liner_send_message_post_singular": "分享了临时会话给 1 个联系人",
      "post_detail_one_liner_send_message_post_plural": "分享了临时会话给 %1$s 个联系人",
      "post_detail_one_liner_receive_and_send_group_message_post": "分享了临时会话到群 %1$s",
      "post_detail_meta_description_type_message_post": "在以下社区分享了一场聊天：",
      "post_detail_one_liner_receive_and_send_group_thread_post": "分享了组合会话到群 %1$s",
      "chat_page_group_member_addition_rights": "成员添加权限",
      "chat_page_non_member_join_prompt_toast": "加入该群组以查看会话",
      "chat_settings_page_group_member_addition_rights_description": "控制谁可以向群组添加新成员",
      "chat_settings_page_group_share_to_public_alert_message": "确定吗？开启后将无法更改此设置。",
      "chat_settings_page_group_show_history_alert_message": "确定吗？开启后将无法更改此设置。",
      "chat_settings_page_group_identity_warning_title": "更新社区主页信息？",
      "chat_settings_page_group_identity_warning_desc": "此更改将同时更新您的公开主页和该社区的所有邀请链接。",
      "chat_settings_page_group_identity_warning_confirm": "更新",
      "error_general_alert_message": "出了点问题，请重试。",
      "general_error_title": "哎呀",
      "general_permission_required_title": "需要权限",
      "general_permission_required_photo_library": "请在设置中允许访问您的相册。",
      "general_permission_required_microphone": "请在设置中允许访问您的麦克风。",
      "general_unknown_user": "某人",
      "general_unknown_group": "该群组",
      "me_accept_contact_fail_toast": "出了点问题，请稍后重试。",
      "me_add_contact_fail_toast": "出了点问题，请稍后重试。",
      "me_bio_update_fail_toast": "无法更新简介，请稍后重试",
      "me_bio_update_success_toast": "简介更新成功",
      "me_decline_contact_fail_toast": "出了点问题，请稍后重试。",
      "me_detail_update_fail_toast": "无法更新资料，请稍后重试",
      "me_detail_update_success_toast": "资料更新成功",
      "me_profile_fetch_fail_toast": "无法获取用户资料，请稍后重试",
      "me_relationship_failed_toast": "获取关系失败，请稍后重试",
      "me_edit_profile_page_username_helper": "这是您的专属用户名。其他人可以通过这个用户名找到您。",
      "me_edit_profile_page_display_name_helper": "这是其他人会在对话和帖子中看到的名字。",
      "post_creation_error": "帖子创建失败",
      "post_creation_successful": "帖子创建成功",
      "post_deletion_error": "帖子删除失败",
      "post_deletion_successful": "帖子删除成功",
      "scraper_add_rss_feed_page_input_bar_error": "无效的RSS链接",
      "chat_page_nav_subtitle_network_unavailable": "当前网络不可用",
      "chat_page_nav_subtitle_connecting": "连接中...",
      "chat_page_nav_subtitle_connected": "已连接",
      "chat_page_nav_subtitle_connect_failed": "链接失败，点击刷新页面",
      "chat_page_text_more_option_erase_from_receiver": "从当前聊天记录中消除",
      "chat_page_text_more_option_erase_from_all_receivers": "从所有人的聊天记录中消除",
      "chat_page_text_more_option_erase_from_group": "从群组中消除",
      "chat_page_text_more_option_erase_from_conversation": "从会话中删除",
      "chat_page_text_more_option_removed_from_conversation": "从会话中移除",
      "chat_page_text_more_option_removed_from_group": "从群组中移除",
      "chat_page_text_more_option_set_as_first_post_group": "设置为第一个内容",
      "chat_page_text_more_option_featured_post_group": "设置为推荐内容",
      "chat_page_text_more_option_un_featured_post_group": "取消推荐内容",
      "chat_page_text_more_option_erase_from_group_alert_message": "确定要消除此内容吗？",
      "chat_page_text_more_option_removed_from_group_alert_message": "将此内容从群组中移除？",
      "chat_page_text_more_option_removed_from_conversation_alert_message": "将此内容从会话中移除？",
      "chat_page_text_more_option_featured_post_group_alert_message": "确定要将此内容设为推荐内容吗？",
      "chat_page_text_more_option_un_featured_post_group_alert_message": "确定要取消推荐此内容吗？",
      "chat_page_text_more_option_set_as_first_post_group_alert_message": "确定要将此内容设为第一个推荐内容吗？",
      "chat_page_text_more_option_hide_alert_message": "这个内容将被对你隐藏，但其他接收人仍然可以访问。",
      "comment_creation_error": "评论发送失败",
      "chat_page_group_featured_posts_load_fail_toast": "加载推荐内容失败",
      "chat_page_group_featured_posts_remove_fail_toast": "取消推荐内容失败",
      "chat_page_group_featured_posts_pin_fail_toast": "置顶推荐内容失败",
      "chat_page_group_featured_posts_feature_fail_toast": "推荐内容失败",
      "featured_posts_page_empty_state": "暂无推荐内容",
      "featured_posts_page_actions_dialog_title": "内容操作",
      "featured_posts_page_remove_dialog_title": "取消推荐？",
      "featured_posts_page_remove_dialog_desc": "此内容将从推荐内容中移除。",
      "chat_page_text_more_option_copy_message": "复制文字",
      "chat_page_media_post_preview_default_text_image_singular": "%1$s 分享了一张图片",
      "chat_page_media_post_preview_default_text_image_plural": "%1$s 分享了 %2$s 张图片",
      "chat_page_media_post_preview_default_text_video_singular": "%1$s 分享了一条视频",
      "chat_page_media_post_preview_default_text_video_plural": "%1$s 分享了 %2$s 条视频",
      "chat_page_media_post_preview_default_text_files_plural": "%1$s 分享了 %2$s 条媒体",
      "chat_page_link_post_preview_default_text": "%1$s 分享了一个链接",
      "chat_page_poll_post_preview_default_text": "%1$s 发起了一个投票",
      "chat_page_input_bar_voice_toast_title_hint": "长按进行录制声音",
      "chat_page_input_bar_voice_toast_title_recording": "录音中...",
      "chat_page_input_bar_guggy_toast_title_generating": "正在生成GIF...",
      "chat_page_input_bar_guggy_toast_title_failed_generate_gif": "生成GIF失败，请稍后重试",
      "chat_page_input_bar_voice_and_guggy_toast_description_slide_up": "向上滑动取消发送",
      "chat_page_input_bar_voice_and_guggy_cancel_toast_title": "松开手指",
      "chat_page_input_bar_voice_and_guggy_cancel_toast_description": "取消发送",
      "chat_page_event_post_disable_group": "群组 %1$s 不允许成员发送内容",
      "chat_page_event_featured_by_user": "此群组被 %1$s 关联到了用户简介",
      "chat_page_event_featured_in_group": "此群组被 %1$s 关联到了群组 %2$s",
      "chat_page_event_featured_in_group_no_mention": "此群组被 %1$s 关联到了其他群组",
      "chat_page_event_featured_group": " 关联了群组",
      "chat_page_event_join_private_conversation_general": "你加入了会话",
      "chat_page_event_join_group_general": "你加入群组",
      "chat_page_event_add_group_admin": "%1$s 将 %2$s 提升为管理员",
      "chat_page_event_remove_group_admin": "%1$s 将 %2$s 更改为群成员",
      "chat_page_event_add_group_admin_for_new_admin": "%1$s 将你提升为管理员",
      "chat_page_event_remove_group_admin_for_new_admin": "%1$s 将你更改为群成员",
      "chat_page_event_add_group_admin_for_owner": "你将 %1$s 提升为管理员",
      "chat_page_event_remove_group_admin_for_owner": "你将 %1$s 更改为群成员",
      "chat_page_event_add_group_member_for_invitee": "%1$s 邀请你加入群组，群里有 %2$s 和 %3$s 个成员",
      "chat_page_event_add_group_member_for_invitee_friends_only": "%1$s 邀请你加入群组，群里有 %2$s, %3$s",
      "chat_page_event_add_group_member_for_invitee_single_friend_only": "%1$s 邀请你加入群组，群里有 %2$s",
      "chat_page_event_add_group_member_for_invitee_single": "%1$s 邀请你加入群组",
      "chat_page_event_add_group_member_for_invitee_single_with_others": "%1$s 邀请你加入群组，群里有 %2$s 个成员",
      "chat_page_event_add_group_member_for_inviter": "你将 %1$s, %2$s 邀请至群组",
      "chat_page_event_add_group_member_for_inviter_single": "你将 %1$s 邀请至群组",
      "chat_page_event_add_group_member_for_owner_only": "你创建了一个群组",
      "chat_page_event_add_group_member_for_no_inviter": "%1$s 和 %2$s 加入群组",
      "chat_page_event_add_group_member_for_no_inviter_single": "%1$s 加入群组",
      "chat_page_event_add_group_member_for_not_inviter_or_invitee": "%1$s 将 %2$s, %3$s 邀请至群组",
      "chat_page_event_add_group_member_for_not_inviter_or_invitee_single": "%1$s 将 %2$s 邀请至群组",
      "chat_page_event_remove_group_member_for_action_taker": "你将 %1$s, %2$s 移除出了群组",
      "chat_page_event_remove_group_member_for_action_taker_single": "你将 %1$s 移除出了群组",
      "chat_page_event_remove_group_member_for_action_receiver": "你已被移除出群组",
      "chat_page_event_remove_group_member_for_group_member": "%1$s 和 %3$s 被 %2$s 移除出了群组",
      "chat_page_event_remove_group_member_for_group_member_single": "%1$s 被 %2$s 移除出了群组",
      "chat_page_event_update_group_name_for_action_taker": "你将群名称更改成了 %1$s",
      "chat_page_event_update_group_name_for_action_receiver": "%1$s 将群名称更改成了 %2$s",
      "chat_page_event_update_group_description_for_action_taker": "你将群介绍更改成了",
      "chat_page_event_update_group_description_for_action_receiver": "%1$s 将群介绍更改成了",
      "chat_page_event_update_group_background_for_action_taker": "你将群背景更改成了",
      "chat_page_event_update_group_background_for_action_receiver": "%1$s 将群背景更改成了",
      "chat_page_event_update_group_id_for_action_taker": "你群ID更改成了 %1$s",
      "chat_page_event_update_group_id_for_action_receiver": "%1$s 将群ID更改成了 %2$s",
      "chat_page_event_update_group_avatar_for_action_taker": "你将群组头像更改了",
      "chat_page_event_update_group_avatar_for_action_receiver": "%1$s 将群组头像更改了",
      "chat_page_event_update_group_owner_for_action_taker": "你已把群主身份转让给 %1$s",
      "chat_page_event_update_group_owner_for_action_receiver": "%1$s 把群主身份转让给你",
      "chat_page_event_update_group_owner_for_action_passive": "%1$s 把群主身份转让给 %2$s",
      "chat_page_event_update_group_default_deeplink_for_action_taker": "你将 %1$s 社区网页更新了",
      "chat_page_event_update_group_default_deeplink_for_action_receiver": "%1$s 将 %2$s 社区网页更新了",
      "chat_page_event_update_group_show_history": "%1$s 开启了 \"保留历史记录\" 设置。 新成员加入群时，将会看到今后发送的内容",
      "chat_page_event_update_group_share_to_public": "%1$s 开启了 \"公众分享\" 设置。群成员可以将今后发送的内容分享到群外",
      "chat_page_event_screenshot_notice": " 截屏",
      "chat_page_event_new_contact_greeting": "你已经添加 %1$s 为联系人。开始分享吧！",
      "chat_page_event_not_a_contact": "请添加此用户为联系人后再发送内容",
      "chat_page_event_content_erased_post_sender": "你的内容已被 %1$s 移除了",
      "chat_page_event_content_erased_message_sender": "你发送的消息已被消除",
      "chat_page_event_content_erased_comment_sender": "你的评论已被 %1$s 移除了",
      "chat_page_event_content_erased_post_owner": "你移除了这个内容",
      "chat_page_event_content_erased_message_owner": "你消除了一条消息",
      "chat_page_event_content_erased_comment_owner": "你移除了这个评论",
      "chat_page_event_content_erased_post_member": "这个内容已被 %1$s 移除了",
      "chat_page_event_content_erased_message_member": "消息已被移除",
      "chat_page_event_content_erased_comment_member": "这个评论已被 %1$s 移除了",
      "chat_page_event_new_member_invitation": "群主同意后 %1$s, %2$s 即可入群",
      "chat_page_event_new_member_invitation_single": "群主同意后 %1$s 即可入群",
      "chat_page_event_user_is_banned": "%1$s 已被 %2$s 封禁",
      "chat_page_event_user_is_unbanned": "%1$s 已被 %2$s 解除封禁",
      "chat_page_event_user_is_appointed_admin": "%1$s 现为管理员",
      "chat_page_event_admin_is_discharged": "%1$s 不再是管理员",
      "chat_page_group_featured_post_creator_title": "推荐内容",
      "chat_page_group_featured_post_empty_notice": "所有群成员都能看到推荐内容，包括新加入的群成员。推荐内容是介绍你的群组并欢迎新成员的方式。你可以随意创建多个推荐内容！放心，可以随时更改。",
      "chat_page_group_greeting_creator_title": "群组迎接内容",
      "chat_page_group_greeting_creator_empty_notice": "所有群成员都能看到迎接内容，包括新加入的群成员。迎接内容是介绍你的群组并欢迎新成员的方式。你可以随意创建多个迎接内容！放心，可以随时更改。",
      "chat_page_group_greeting_creator_prompt_description": "每个群组仅允许一条问候帖。设置新的问候帖将替换旧的。",
      "chat_page_group_greeting_disable_prompt_disable_btn": "停用此迎接内容",
      "chat_page_group_greeting_disable_prompt_erase_btn": "消除内容",
      "chat_page_group_greeting_warning_popup_content": "群组内的每位新成员都将可以访问这个内容。",
      "chat_page_group_greeting_warning_popup_warning": "不再提示",
      "chat_page_group_greeting_warning_popup_title": "是否发送一条评论到迎接内容？",
      "chat_page_group_greeting_label": "迎接内容",
      "chat_page_keep_group_history_warning_popup_post_title": "发送内容",
      "chat_page_keep_group_history_warning_popup_post_content": "新成员将会看到这个内容",
      "chat_page_keep_group_history_warning_popup_comment_title": "发送评论？",
      "chat_page_keep_group_history_warning_popup_comment_content": "新成员将会进入到这个内容并可以看到你的评论",
      "chat_page_keep_group_history_warning_popup_warning": "不再提示",
      "chat_page_group_publishing_rules": "不允许群成员发布内容",
      "chat_page_group_publishing_rules_desc": "只有群主和管理员可以发布内容",
      "chat_page_group_publishing_rules_enable": "允许群成员发布内容",
      "chat_page_group_publishing_rules_messages": "不允许群成员发送消息",
      "chat_page_group_limited_publishing_rules_messages_pop_up_description": "哎呀... 群主不允许群成员发送消息。要加入或开始一条对话，试试发送一条评论",
      "chat_page_group_show_history_rules": "保留历史记录",
      "chat_page_group_show_history_rules_desc": "新成员可以看到加入群组前的历史记录",
      "chat_page_group_show_history_rules_on_toast": "当设置为开启后将无法再次改变",
      "chat_page_group_show_history_rules_enable": "新成员可以看到加入群组前的历史记录",
      "chat_page_group_show_history_rules_disabled": "新成员将不会看到历史评论\n新成员将会看到有新评论的历史内容",
      "chat_page_group_share_to_public_rules": "公众分享",
      "chat_page_group_share_to_public_rules_desc": "群成员将有能力将群内容分享到群外",
      "chat_page_group_share_to_public_rules_on_toast": "当设置为开启后将无法再次改变",
      "chat_page_group_share_to_public_rules_enable": "群成员可以将内容分享到群外",
      "chat_page_group_share_to_public_rules_disabled": "群成员不可以将内容分享到群外",
      "chat_page_group_cross_exposure_rules": "禁用群外自动推广",
      "chat_page_group_cross_exposure_rules_desc": "应用不会显示 #群 在系统生成的事件",
      "chat_page_group_cross_exposure_rules_enable": "应用不会显示 #群 在系统生成的事件",
      "chat_page_group_cross_exposure_rules_disabled": "应用会显示 #群 在系统生成的事件",
      "chat_page_group_adding_members_rules": "新增群成员需要审核",
      "chat_page_group_adding_members_rules_desc": "新成员需要通过审核后才能加入群组。",
      "chat_page_group_adding_members_rules_enable": "新增群成员无需审核",
      "chat_page_group_permissions_section": "权限",
      "chat_page_group_admin_management": "管理员管理",
      "chat_page_group_group_management": "管理群组",
      "chat_page_group_admin_management_owner_lable": "群主",
      "chat_page_group_admin_management_admin_lable": "群管理员",
      "chat_page_group_admin_management_add_admin_confirmation_title": "确定要授予管理员权限吗？",
      "chat_page_group_admin_management_remove_admin_confirmation_title": "确定要移除管理员权限吗？",
      "chat_page_group_limited_publishing_rules_pop_up_description": "啊哦，本群只有群主能发布内容。群成员可以发表评论和消息。",
      "chat_page_group_featured_post_creator_empty_tooltip": "在此创建推荐内容！",
      "chat_page_group_greeting_creator_empty_tooltip": "在此创建迎接内容！",
      "chat_page_group_feature_unavailable": "设置一个群ID即可开启此功能！",
      "chat_page_message_input_bar_hint": "发送消息...",
      "chat_page_group_ban_management_page_cell_description": "已被 %1$s 封禁",
      "chat_page_unread_messages": "未读评论",
      "chat_page_new_comments": "新评论",
      "chat_page_load_previous_comments": "显示以前的评论",
      "chat_page_comment_copy": "评论已复制",
      "chat_page_posting_disabled_fail_toast": "社区所有者已关闭发布功能，您的草稿已保存。",
      "chat_page_posting_disabled_draft_reason": "该群组已关闭发布功能",
      "content_type_unsupported_preview": "未知消息",
      "people_page_chat_list_cell_preview_content_type_link": "链接",
      "please_wait_for_uploads": "请等待上传完成",
      "people_page_chat_list_cell_preview_content_type_image": "内容",
      "people_page_chat_list_cell_preview_content_type_poll": "投票",
      "people_page_chat_list_cell_preview_content_type_gif": "GIF动图",
      "people_page_chat_list_cell_preview_content_type_voice": "语音",
      "people_page_chat_list_cell_preview_content_type_thread": "组合消息",
      "people_page_filter_result_title_noresult": "没有符合条件的联系人",
      "post_detail_comment_page_nav_title": "评论",
      "post_detail_comment_page_request_to_join_to_comment_hint": "请求加入该社区后即可评论。",
      "post_detail_comment_page_more_options_erase_from_all_receivers": "从所有人的聊天记录中消除",
      "post_detail_comment_page_more_options_erase_comment": "消除评论",
      "post_detail_comment_page_more_options_report": "举报",
      "post_detail_comment_page_more_options_hide": "举报并隐藏",
      "post_detail_comment_page_more_options_copy": "复制",
      "post_detail_comment_page_more_options_reply": "回复",
      "post_detail_comment_page_more_options_download": "下载",
      "post_detail_comment_page_more_options_change_random_gif": "更换GIF动图",
      "post_detail_comment_page_more_options_change_search_gif": "搜索GIF动图",
      "post_detail_comment_page_more_options_erase_comment_alert_message": "确定要消除此评论吗？",
      "post_detail_comment_page_more_options_remove_comment_alert_message": "将此评论从群组中移除？",
      "post_detail_comment_page_more_options_hide_alert_message": "这个评论将被对你隐藏，但其他接收人仍然可以访问。",
      "post_detail_comment_page_mute_group_notification_banner": "讨论消息提醒已关闭",
      "post_detail_comment_page_settings_options_mute_group_notification_toggle": "不再接收讨论消息提醒",
      "post_detail_comment_page_settings_options_leave_group_discussion_btn": "退出讨论",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_title": "退出讨论后，你将无法收到或发送任何内容，并且无法看到除发起人以外的所有其他用户。",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_leave_btn": "退出",
      "post_detail_comment_page_settings_options_leave_group_discussion_altert_stay_btn": "留下",
      "post_detail_comment_page_comment_empty_group_discussion": "在这里进行群组讨论，或点击用户头像进行一对一讨论",
      "post_detail_comment_page_comment_empty_private_conversation": "还没有评论。说点什么来开始会话吧。",
      "post_detail_comment_page_comment_empty_private_comment_contacts": "本对话只对你和 %1$s 可见",
      "post_detail_comment_page_comment_empty_private_comment_non_contacts": "你和 %1$s 尚未建立联系。只有在 %2$s 接受你的联系人请求后，你发送的评论才会可见。",
      "post_detail_comment_page_comment_empty_private_comment_pending": "%1$s 向你发送了联系人请求。点击接受，或发送私密评论以查看已发送的评论。",
      "post_detail_comment_page_comment_empty_one_to_many_private_comment": "在这里的留言将作为一对一对话单独发送给每一个接收人",
      "post_detail_comment_page_comment_input_bar_hint_group_discussion": "参与群组讨论...",
      "post_detail_comment_page_comment_input_bar_hint_private_comment_to_all": "给所有人发送评论...",
      "post_detail_comment_page_comment_input_bar_hint_private_comment_to_user": "发送评论...",
      "post_detail_comment_page_comment_status_sending": "发送评论...",
      "post_detail_comment_page_comment_status_fail_to_send": "评论发送失败",
      "post_detail_comment_page_comment_text_pull_to_post_detail": "下拉查看内容详情",
      "post_detail_comment_page_comment_text_release_to_post_detail": "松开手指查看内容详情",
      "post_detail_poll_post_seo_description_above_five_comments": "加入 %1$s 社区这场热烈的投票讨论，已有 %2$s 条互动。快来投票并参与讨论！",
      "post_detail_poll_post_seo_description_for_fewer_comments": "参与 %1$s 社区这场有趣的投票。立即投票并分享你的想法！",
      "post_detail_default_seo_description_above_five_comments": "加入 %1$s 社区这场热烈的讨论，已有 %2$s 条评论。快来分享你的想法！",
      "post_detail_default_seo_description_for_fewer_comments": "探索 %1$s 社区这个热门话题。快来分享你的想法！",
      "inbox_tab_select": "SELECT",
      "inbox_tab_new": "新动态",
      "inbox_tab_history": "历史",
      "inbox_action_reaction_toast": "表情回复已发送",
      "inbox_action_snooze_toast": "内容暂缓30分钟后查看",
      "inbox_action_unsnooze_toast": "内容已取消暂缓",
      "inbox_action_cancel_toast": "内容从信箱移除",
      "inbox_action_card_friend_request_title": "好友请求",
      "inbox_action_contact_request_badge": "联系人请求",
      "inbox_page_zero_view_heading_1": "你已经看过所有最新动态啦",
      "inbox_page_zero_view_body_text_top_1": "数据显示，平均每人每天在社交媒体应用上花的时间为135分钟",
      "inbox_page_zero_view_body_text_bottom_1": "SELECT用户每天花10分钟就能获得有质量的社交体验",
      "inbox_page_zero_view_heading_2": "这里没有广告杂音，话题不会过时，在SELECT尽享深度交流的乐趣吧。",
      "inbox_page_zero_view_body_text_top_2": "当群消息累积过多，群组便失去其时效性、便捷性，你也逐渐失去参与的兴趣。",
      "inbox_page_zero_view_body_text_bottom_2": "无论群里有多少成员，SELECT都能帮助你在群内精准、直接、有效地交流讨论。",
      "inbox_page_zero_view_heading_3": "恭喜！你已经浏览了你本人或好友参与过帖子的最新动态，收件箱清空啦！",
      "inbox_page_zero_view_body_text_top_3": "这里没有无止境的动态消息，不是人气比拼和广告平台，互动消息也不会留有公共记录。",
      "inbox_page_zero_view_body_text_bottom_3": "你是顾客，更是我们的伙伴。",
      "inbox_recall_snoozed_tooltip": "双击可恢复已暂停的内容",
      "post_detail_download_process_send_request_pop_up_send_button": "发送请求",
      "post_detail_download_process_downloading_toast": "下载中",
      "post_detail_download_process_downloading_toast_progress": "%1$s/%2$s 下载完成",
      "post_detail_download_process_downloaded_successfully_toast": "下载已完成",
      "post_detail_download_process_download_failed_toast": "下载失败",
      "post_detail_download_process_download_cancelled_toast": "取消下载",
      "post_detail_event_user_requested_download": "%1$s 请求下载图片",
      "post_detail_event_owner_allowed_download": "%1$s 已允许你下载图片",
      "post_detail_event_user_downloaded_successfully_single": "%1$s 将图片下载了",
      "post_detail_event_user_downloaded_image_comment_successfully_single": "%1$s 下载了 %2$s 的图片",
      "post_detail_event_user_downloaded_video_successfully_single": "%1$s 将视频下载了",
      "post_detail_event_user_downloaded_video_comment_successfully_single": "%1$s 下载了 %2$s 的视频",
      "post_detail_event_user_downloaded_video_successfully": "%1$s 将视频下载了",
      "post_detail_event_user_downloaded_video_comment_successfully": "%1$s 下载了 %2$s 的视频",
      "post_detail_event_user_downloaded_files_successfully": "%1$s 将媒体下载了",
      "post_detail_event_user_downloaded_files_comment_successfully": "%1$s 下载了 %2$s 的媒体",
      "post_detail_event_user_downloaded_successfully": "%1$s 将图片下载了",
      "post_detail_event_user_downloaded_image_comment_successfully": "%1$s 下载了 %2$s 的图片",
      "change_vote": "改变投票",
      "post_detail_event_user_vote_event": "%1$s 投了票",
      "post_detail_event_user_change_vote_event": "%1$s 改变了投票",
      "post_detail_event_owner_featured_post": "%1$s 推荐了内容",
      "post_detail_proactively_allow_download_pop_up_description": "允许收件人下载这些图片",
      "post_detail_proactively_allow_download_pop_up_allow_btn": "启用下载",
      "post_detail_download_already_enabled_pop_up_description": "此帖子的收件人已可下载图片",
      "post_seen_all": "太棒了！你已经看完全部内容",
      "post_no_feed": "暂无动态",
      "profile_filter_btn_default": "所有人",
      "profile_filter_popup_gender_selector_btn_all": "所有人",
      "profile_filter_popup_gender_selector_btn_female": "女",
      "profile_filter_popup_gender_selector_btn_male": "男",
      "profile_filter_popup_age_selector_text_all_age": "所有年龄",
      "profile_filter_popup_age_selector_text_age_range": "%1$s - %2$s 岁",
      "profile_bio_not_set": "尚未设置简介",
      "profile_cover_photo": "封面照片",
      "group_profile_no_group_available": "群主尚未添加任何精选群组。",
      "group_profile_copy_link": "复制链接",
      "group_profile_copy_link_success_toast": "已复制到剪贴板",
      "group_profile_copy_link_fail_toast": "无法复制链接",
      "user_profile_no_group_available": "该用户尚未添加任何精选群组。",
      "profile_seen_all_contacts": "你已看完全部",
      "profile_no_contacts": "暂无联系人",
      "profile_gender_not_set": "未设置性别",
      "profile_delete_account_hint": "您的帐户将在 30 天内被删除。 您将无法使用您的帐户，您确定要删除您的帐户吗？",
      "me_edit_profile_page_nav_title": "编辑资料",
      "me_edit_profile_page_update_profile_picture_title": "更新头像",
      "me_edit_profile_page_display_name_title": "名字",
      "me_edit_profile_page_gender_title": "性别",
      "me_edit_profile_page_about_me_placeholder": "尚未设置简介",
      "me_edit_profile_page_about_me_title": "简介",
      "me_edit_profile_page_id_title": "用户名",
      "me_edit_profile_page_binded_account_title": "关联账号",
      "me_edit_profile_page_birthdate_title": "出生日期",
      "me_edit_profile_page_email_title": "邮箱",
      "me_edit_profile_page_email_not_available": "未提供电子邮箱",
      "me_edit_profile_page_gender_options_female": "女",
      "me_edit_profile_page_gender_options_male": "男",
      "me_edit_profile_page_private_title": "下面的信息只有自己可见",
      "me_edit_profile_page_username_invalid_id": "用户名只能使用字母（A-Z）、数字（0-9）和下划线（_），且不超过15个字符",
      "me_edit_profile_page_username_not_available": "用户名不可用，请重新输入",
      "me_edit_set_your_bio_title": "设置你的简介",
      "universal_search_search_bar_hint_people": "搜索用户",
      "universal_search_search_bar_hint_groups": "搜索群",
      "universal_search_search_bar_hint_content": "搜索内容",
      "universal_search_result_contact_title": "联系人",
      "universal_search_result_more_result_title": "更多搜索结果",
      "universal_search_result_more_result_search_for": "搜索：",
      "universal_search_section_other_groups_title": "来自其他群组",
      "universal_search_result_groups_title": "群",
      "universal_search_result_more_result_search_for_no_result_alert": "没有找到，请检查您的输入是否正确，再次重试",
      "universal_search_empty_current_group": "在此群组中未找到结果",
      "universal_search_result_more_result_search_for_no_network": "搜索失败，请检查你的网络连接",
      "universal_search_result_messages_title": "消息",
      "universal_search_result_posts_title": "分享",
      "universal_search_result_comments_title": "评论",
      "universal_search_type_selector_people": "用户",
      "universal_search_search_bar_hint_all_types": "搜索联系人和群组",
      "universal_search_type_selector_all": "全部",
      "universal_search_type_selector_content": "内容",
      "universal_search_type_selector_groups": "群",
      "universal_search_result_user_id_match": "用户名匹配",
      "universal_search_result_group_id_match": "群ID匹配",
      "group_forbidden_toast": "你不能加入群组，因为你已经被移除。",
      "group_profile_page_nav_title": "群组简介",
      "group_profile_members": "群成员",
      "group_profile_friends": "联系人",
      "group_profile_members_count": "群成员",
      "group_profile_friends_count": "个 SELECT 联系人",
      "group_profile_join": "加入群组",
      "group_profile_request_join": "请求加入群组",
      "group_profile_friends_sent": "请求已发送",
      "group_profile_community_title": "查看社区网页",
      "group_profile_deliver_inbox_title": "在 SELECT 收件箱看?",
      "group_profile_deliver_inbox_desc": "你想要 %1$s 群的哪一些动态，在你的 SELECT 收件箱可看到?",
      "group_profile_deliver_inbox_desc_all": "所有动态，包括群中的非联系人发的，都会到 SELECT 收件箱去",
      "group_profile_deliver_inbox_desc_select": "只有你联系人发的动态，或者你进行过交互的动态，才会到 SELECT 收件箱去",
      "group_profile_deliver_inbox_desc_none": "这群中的动态，都不会到 SELECT 收件箱去",
      "group_profile_deliver_option_all": "全部",
      "group_profile_deliver_option_curated": "SELECT",
      "group_profile_deliver_option_none": "没有",
      "group_profile_start_conversation": "开始对话",
      "group_profile_members_and_contacts": "%1$s 群成员, %2$s 联系人",
      "user_profile_page_toast_user_id_copied": "用户名已复制",
      "group_join_request_sent": "您的加入请求已发送",
      "group_join_request_pending": "请求待处理",
      "group_join_request_to_join": "申请加入",
      "group_join_request_approved": "请求已批准",
      "group_join_request_declined": "请求已拒绝",
      "group_join_request_wants_to_join": "想要加入",
      "group_join_request_empty": "没有待处理的群组加入请求",
      "group_join_requests_title": "群组请求",
      "group_join_request_accepted_description": "您已被接受！",
      "group_join_request_accepted_toast": "您已被接受加入 %1$s",
      "group_joining_confirmation": "你已成功加入此对话",
      "group_permission_updated": "你已成功加入此群组对话",
      "remove_contact": "删除联系人",
      "remove_contact_sure_1": "确定吗？",
      "remove_contact_sure_2": "你将无法再与该联系人分享内容，且所有历史记录都将丢失。",
      "remove": "删除",
      "pending_requests_title": "待处理请求",
      "sent_requests_title": "已发送请求",
      "add_contact_title": "添加联系人",
      "contact_request_wants_to_add_subtitle": "想将您添加为联系人",
      "contacts_view_tab_requests": "请求",
      "contacts_view_empty": "没有待处理的请求",
      "me_add_contact_rate_limit_toast": "您最近向此用户发送的联系请求过多，请稍后再试。  ",
      "erase_post": "从群组中清除",
      "erase_comment": "清除评论",
      "private_conversation_title": "SELECT 不存储私密内容。🔒 这些对话仅对你可见。",
      "private_conversation_footer": "下载 SELECT 应用以查看",
      "private_conversation_no_posts": "暂无新的私密帖子",
      "private_conversation_box_singular": "与你分享了 %1$s 条帖子",
      "private_conversation_sidebar_singular": "%1$s 与你分享了 %2$s 条帖子",
      "private_conversation_box_plural": "与你分享了 %1$s 条帖子",
      "private_conversation_sidebar_plural": "%1$s 与你分享了 %2$s 条帖子",
      "invitation_qr_title": "扫码获取应用",
      "not_found_error_title": "此内容目前不可用",
      "not_found_error_desc": "出现这种情况，通常是因为所有者仅与少数人分享了内容、更改了可见范围，或内容已被删除。",
      "not_found_error_go_home": "前往收件箱",
      "not_found_error_go_back": "返回",
      "not_found_no_public_landing_page_title": "你访问的社区尚未设置公开主页",
      "not_found_no_public_landing_page_desc": "如果你想加入，请联系社区所有者邀请你",
      "not_found_no_access_title": "你无法查看该内容",
      "not_found_no_access_desc": "所有者只与少数人分享了该内容，或者你不是该社区的成员",
      "not_found_cta_back_to_inbox": "返回收件箱",
      "not_found_cta_go_home": "前往首页",
      "cancel": "取消",
      "post_builder_tab_post_title": "帖子",
      "post_builder_tab_blog_title": "博客",
      "post_builder_tab_poll_title": "投票",
      "post_builder_formatting_tooltip_align_left": "左对齐",
      "post_builder_formatting_tooltip_align_center": "居中对齐",
      "post_builder_formatting_tooltip_align_right": "右对齐",
      "post_builder_formatting_tooltip_undo": "撤销",
      "post_builder_formatting_tooltip_redo": "重做",
      "post_builder_formatting_tooltip_heading_options": "标题选项",
      "post_builder_formatting_tooltip_paragraph": "段落",
      "post_builder_formatting_tooltip_heading_one": "标题 1",
      "post_builder_formatting_tooltip_heading_two": "标题 2",
      "post_builder_formatting_tooltip_heading_three": "标题 3",
      "post_builder_formatting_tooltip_bold": "粗体",
      "post_builder_formatting_tooltip_italic": "斜体",
      "post_builder_formatting_tooltip_strikethrough": "删除线",
      "post_builder_formatting_tooltip_list_bullet": "无序列表",
      "post_builder_formatting_tooltip_list_ordered": "有序列表",
      "post_builder_formatting_tooltip_blockquote": "引用",
      "post_builder_formatting_tooltip_code": "代码",
      "post_builder_formatting_tooltip_codeblock": "代码块",
      "post_builder_formatting_tooltip_more_options": "更多格式选项",
      "post_builder_tooltip_insert_image": "插入图片",
      "post_builder_tooltip_insert_video": "插入视频",
      "post_builder_tooltip_insert_audio": "插入音频",
      "post_builder_tooltip_search_gif_or_image": "在线搜索 GIF/图片",
      "post_builder_media_search_modal_title": "搜索媒体",
      "post_builder_media_search_tab_gif_title": "GIF 搜索",
      "post_builder_media_search_tab_image_title": "图片搜索",
      "post_builder_media_search_input_gif_placeholder": "搜索 GIF...",
      "post_builder_media_search_input_image_placeholder": "搜索图片...",
      "post_builder_tooltip_link_add": "添加带预览的链接",
      "post_builder_tooltip_link_edit": "编辑链接",
      "post_builder_tooltip_link_visit": "访问链接",
      "post_builder_tooltip_link_unset": "取消链接",
      "post_builder_link_input_label": "链接网址",
      "post_builder_link_text_input_label": "显示文字",
      "post_builder_link_input_invalid": "请输入有效的网址",
      "post_builder_link_insert_modal_title": "插入链接",
      "post_builder_link_update_modal_title": "更新链接",
      "post_builder_tooltip_link_remove_preview": "移除链接预览",
      "post_builder_link_loading_metadata_placeholder": "正在获取链接信息...",
      "post_builder_poll_question_input_placeholder": "你选哪一个？",
      "post_builder_poll_add_text_option_input_label": "添加文字选项",
      "post_builder_poll_add_text_option_input_placeholder": "输入文字选项...",
      "post_builder_poll_add_text_option_input_command": "按 Enter 添加",
      "cookie_banner_title": "我们也讨厌 Cookie。",
      "cookie_banner_description": "我们只使用 Google Analytics — 了解人们如何发现 Select 以及接下来该做什么。没有广告追踪，不出售任何数据。",
      "cookie_accept_all": "全部接受",
      "cookie_essential_only": "仅必要项",
      "cookie_manage_preferences": "管理设置",
      "cookie_save_preferences": "保存偏好设置",
      "cookie_preferences_title": "Cookie 偏好设置",
      "cookie_usage_title": "Cookie 使用情况",
      "cookie_usage_description": "我们使用 Cookie 以确保网站的基本功能并提升您的体验。",
      "cookie_necessary_title": "严格必要的 Cookie",
      "cookie_necessary_description": "这些 Cookie 对网站正常运行至关重要, 包括身份验证, 错误监控和崩溃报告, 以保持服务的可靠性。它们无法被禁用。",
      "cookie_analytics_title": "分析类 Cookie",
      "cookie_analytics_description": "这些 Cookie 帮助我们了解访客如何与网站互动, 从而改进我们的服务。",
      "cookie_preferences_link": "Cookie 偏好设置",
      "cookie_privacy_policy": "隐私政策",
      "general_cookies": "Cookie",
      "drafts_panel_title": "草稿",
      "drafts_panel_tab_failed": "失败",
      "drafts_panel_tab_unfinished": "未完成",
      "drafts_panel_empty_state": "没有草稿",
      "drafts_panel_failed_empty": "没有失败的草稿",
      "drafts_panel_unfinished_empty": "没有未完成的草稿",
      "drafts_panel_type_comment": "评论",
      "drafts_panel_type_poll": "投票",
      "drafts_panel_embed_generic": "嵌入",
      "drafts_panel_media_label": "媒体",
      "drafts_panel_poll_choice": "选项",
      "drafts_panel_poll_choices": "选项",
      "drafts_panel_empty_draft_preview": "空草稿",
      "draft_missing_attachment": "缺少附件",
      "drafts_panel_refresh_aria_label": "刷新草稿",
      "drafts_panel_close_aria_label": "关闭草稿面板",
      "drafts_panel_erase_post_aria_label": "消除内容",
      "drafts_panel_unknown_group": "未知群组",
      "drafts_panel_discard_sure_1": "放弃草稿？",
      "drafts_panel_discard_sure_2": "此操作无法撤销。",
      "drafts_panel_resend_all": "全部重新发送",
      "drafts_panel_resend_all_toast": "正在重新发送失败的内容…",
      "group_creation_title": "新建群组",
      "group_creation_name_placeholder": "群组名称（可选）",
      "group_creation_avatar_upload_label": "上传群组头像",
      "group_creation_selected_count": "已选择 (%1$s)",
      "group_creation_empty_selection_hint": "选择要添加的成员",
      "group_creation_search_placeholder": "搜索联系人",
      "group_creation_create_button": "创建",
      "group_creation_cancel_button": "取消",
      "group_creation_min_members_hint": "请至少选择 2 位成员",
      "group_creation_avatar_uploading_hint": "正在上传头像...",
      "group_creation_empty_contacts_title": "请先添加联系人再创建群组",
      "group_creation_empty_contacts_cta": "添加联系人",
      "group_creation_error_generic": "无法创建群组，请重试。",
      "group_creation_avatar_upload_failed": "无法上传头像，请重试。",
      "group_creation_success_toast": "群组已创建",
      "group_creation_start_conversation_button": "发起对话",
      "group_creation_start_conversation_fail_toast": "无法打开对话",
      "sidebar_create_group_tooltip": "创建群组",
      "chat_settings_page_group_promote_admin_title": "将群成员提升为管理员",
      "chat_settings_page_group_promote_admin_desc": "管理员可以管理群组，但无法更改群组设置",
      "chat_settings_page_group_demote_admin_title": "将管理员更改为群成员",
      "chat_settings_page_group_demote_admin_desc": "群成员无法管理群组或更改群组设置",
      "chat_settings_page_group_appoint_owner_btn": "转让群主身份",
      "chat_settings_page_group_appoint_owner_desc": "将群主身份转让给他人，此操作无法撤销。",
      "chat_settings_page_group_promote_alert_title": "将群成员提升为管理员？",
      "chat_settings_page_group_promote_alert_desc": "管理员可以管理群组，包括删除内容、评论和群成员等。",
      "chat_settings_page_group_demote_alert_title": "将管理员更改为群成员？",
      "chat_settings_page_group_demote_alert_desc": "被更改的管理员将无法再管理群组",
      "chat_settings_page_group_update_failed_toast": "群组管理更新失败，请重试",
      "chat_settings_page_group_remove_member_alert_title": "移除群成员？",
      "chat_settings_page_group_promote_member_confirm_label": "提升 %1$s",
      "chat_settings_page_group_demote_member_confirm_label": "更改 %1$s",
      "chat_settings_page_group_transfer_owner_confirm_label": "转让给 %1$s",
      "chat_settings_add_group_member_error": "添加成员失败，请重试。",
      "chat_settings_page_group_leave_group_btn": "退出群组",
      "chat_settings_page_group_leave_group_alert_message": "确定要退出此群组吗？",
      "chat_settings_page_group_leave_group_alert_confirm_btn": "退出",
      "chat_settings_add_group_member_nav_title": "添加成员",
      "chat_settings_page_group_remove_member_alert_message": "将 %1$s 从群组中移除？",
      "chat_settings_page_group_members_empty": "没有找到群成员。",
      "chat_settings_add_group_member_no_contacts": "没有可添加的联系人。",
      "chat_settings_add_group_member_confirm_btn": "添加 %1$s 位成员",
      "chat_settings_page_group_owner_transfer_first_title": "请先转让群主身份",
      "chat_settings_page_group_owner_transfer_first_desc": "作为群主，你必须先将群主身份转让给其他成员才能退出。前往群组管理选择新的群主。",
      "chat_settings_page_group_go_to_management_btn": "前往群组管理",
      "chat_settings_page_group_cover_photo_title": "封面图片",
      "chat_settings_page_featured_posts_btn": "推荐内容",
      "chat_settings_page_group_name_update_success_toast": "群名称已更新",
      "chat_settings_page_group_name_update_fail_toast": "更新群名称失败",
      "chat_settings_page_group_id_update_success_toast": "群 ID 已更新",
      "chat_settings_page_group_id_taken_toast": "该群 ID 已被使用",
      "chat_settings_page_group_id_update_fail_toast": "更新群 ID 失败",
      "chat_settings_page_group_avatar_update_success_toast": "群头像已更新",
      "chat_settings_page_group_avatar_update_fail_toast": "更新头像失败",
      "chat_settings_page_group_bio_update_success_toast": "简介已更新",
      "chat_settings_page_group_bio_update_fail_toast": "更新简介失败",
      "chat_settings_page_group_cover_photo_update_success_toast": "封面图片已更新",
      "chat_settings_page_group_cover_photo_update_fail_toast": "更新封面图片失败",
      "chat_settings_page_group_edit_name_dialog_title": "编辑群名称",
      "chat_settings_page_group_edit_id_dialog_title": "编辑群 ID",
      "chat_settings_page_group_id_helper": "仅限小写字母、数字和连字符。",
      "chat_settings_page_group_members_load_fail_toast": "加载群成员失败，请重试。",
      "chat_settings_page_group_no_admins_to_demote": "没有可降级的管理员。",
      "chat_settings_page_role_changed_fail_toast": "您在该群组中的角色已变更，您不再拥有执行此操作的权限。",
      "chat_settings_page_promote_not_member_fail_toast": "该用户已不再是本群组成员",
      "chat_settings_page_demote_already_left_toast": "该用户已退出群组，无需更改。",
      "chat_settings_page_transfer_not_member_fail_toast": "无法转让群组——该用户已不再是本群组成员。",
      "chat_settings_page_remove_member_fail_toast": "移除成员失败",
      "chat_settings_page_leave_group_fail_toast": "退出群组失败",
      "group_settings": "群组设置",
      "profile_add_featured_group_title": "添加推荐群组",
      "profile_search_groups_placeholder": "搜索群组...",
      "profile_no_groups_found": "没有找到群组。",
      "profile_view_group_profile": "查看群组简介",
      "profile_remove_from_featured": "取消推荐",
      "profile_remove_featured_group_title": "取消推荐群组？",
      "profile_remove_featured_group_desc": "%1$s 将从你的推荐群组中移除。",
      "profile_no_featured_groups_own": "你还没有添加任何推荐群组。",
      "profile_contacts_search_placeholder": "搜索联系人",
      "profile_contacts_search_clear_aria_label": "清除搜索",
      "profile_contacts_empty_title": "您还没有联系人",
      "profile_contacts_empty_desc": "通过发送或接受请求来添加联系人。",
      "profile_contacts_no_search_results": "未找到与\"%1$s\"相关的联系人。",
      "profile_image_picker_title": "选择图片",
      "profile_image_picker_upload_tab": "上传",
      "profile_image_picker_image_tab": "图片",
      "profile_image_picker_gif_tab": "动图",
      "profile_image_picker_search_image_placeholder": "搜索图片...",
      "profile_image_picker_search_gif_placeholder": "搜索动图...",
      "profile_image_picker_drop_here": "拖入图片，或点击选择文件",
      "profile_image_picker_drop_hint": "支持 JPG、PNG、GIF",
      "profile_image_picker_no_results": "没有找到内容",
      "profile_start_conversation": "发起会话",
      "profile_start_conversation_fail_toast": "无法开始该会话",
      "profile_add_to_group_action": "添加到群组",
      "profile_cancel_request": "取消请求",
      "profile_accept_request": "接受联系人",
      "profile_add_contact": "添加联系人",
      "profile_image_picker_upload_fail_toast": "图片上传失败，请重试。",
      "scraper_source_list_title": "已激活的订阅",
      "feed_type_selector_rss": "RSS",
      "feed_type_selector_email": "电子邮件",
      "scraper_source_list_empty_description": "此群组目前没有激活的订阅。如需添加，请点击“创建订阅”的按钮。",
      "scraper_source_list_limit_exceeded_popup_title": "每个群组最多可添加5个订阅。如果超过5个，请先移除已激活的订阅再添加。",
      "scraper_source_list_rss_copied_toast": "订阅网址已复制",
      "scraper_source_list_unsubscribe_popup_title": "取消 %1$s 订阅?",
      "scraper_source_list_unsubscribe_popup_unsubscribe_btn": "取消订阅",
      "scraper_group_member_perspective_pop_up_title": "此群组已有 %1$s 个RSS订阅",
      "scraper_group_member_perspective_pop_up_description": "只有群主可以添加订阅。来试试创建自己的新群组，再填加你喜欢的订阅吧。",
      "scraper_add_rss_feed_page_title": "创建RSS订阅",
      "scraper_add_rss_feed_page_tip": "提交你的RSS网址，就可在 %1$s 中订阅",
      "scraper_add_rss_feed_page_input_bar_hint": "输入你的RSS网址",
      "scraper_add_rss_feed_page_validation_failed_alert": "Oops！你输入的不是RSS网址",
      "scraper_add_email_feed_page_title": "创建电子邮件订阅",
      "scraper_add_email_feed_page_input_bar_hint": "输入你的电子邮件网址",
      "scraper_add_email_error": "不是电子邮件",
      "scraper_add_email_at_error": "电子邮件里只能有一个（@）字",
      "scraper_add_email_star_error": "只能有一个（*）字",
      "scraper_source_list_rss_copy_failed_toast": "复制失败",
      "scraper_add_feed_clear_input_aria_label": "清除输入",
      "scraper_source_list_action_failed_toast": "出错了",
      "inapp_browser_prompt_title": "在浏览器中打开",
      "inapp_browser_prompt_desc": "为了获得最佳体验，请在设备浏览器中打开此页面。",
      "inapp_browser_prompt_desc_ios": "点击 ⋯ 或分享图标，然后选择\"在 Safari 中打开\"。",
      "inapp_browser_prompt_desc_android": "点击右上角的 ⋮，然后选择\"在 Chrome 中打\"。",
      "inapp_browser_prompt_open_button": "在 Chrome 中打开",
      "inapp_browser_prompt_dismiss_aria_label": "关闭",
      "settings_page_title": "设置",
      "settings_page_about_section": "关于",
      "settings_page_email_row": "邮箱",
      "settings_page_email_not_linked": "未绑定",
      "settings_page_email_link_action": "绑定",
      "settings_page_email_change_action": "更改",
      "settings_page_email_resend_action": "重新发送",
      "settings_page_email_pending_hint": "验证邮件已发送至 %1$s，请查收",
      "settings_page_phone_row": "手机号",
      "settings_page_phone_not_linked": "未绑定",
      "settings_page_twitter_row": "X（Twitter）",
      "settings_page_twitter_connect_action": "绑定",
      "settings_page_version_label": "版本",
      "settings_page_email_modal_title": "绑定邮箱",
      "settings_page_email_modal_desc": "我们将发送一封验证邮件，点击其中的链接后该邮箱将成为你的账号邮箱。",
      "settings_page_email_modal_change_warning": "验证新邮箱后将替换当前账号邮箱。",
      "settings_page_email_modal_placeholder": "请输入邮箱地址",
      "settings_page_email_modal_send_button": "发送验证",
      "settings_page_email_invalid_error": "请输入有效的邮箱地址。",
      "settings_page_email_taken_error": "该邮箱已被其他账号使用。",
      "settings_page_email_send_fail_toast": "验证邮件发送失败",
      "settings_page_twitter_link_success_toast": "X 账号绑定成功",
      "settings_page_twitter_link_fail_toast": "X 账号绑定失败",
      "settings_page_delete_request_success_toast": "已收到删除账号请求",
      "settings_page_delete_request_fail_toast": "删除账号请求发送失败",
      "settings_page_preferences_section": "偏好设置",
      "settings_page_time_well_spent_row": "屏幕时间提醒",
      "settings_page_time_well_spent_desc": "连续使用一段时间后提醒我休息",
      "settings_page_time_well_spent_minutes": "%1$s 分钟",
      "settings_page_phone_link_action": "绑定",
      "settings_page_phone_modal_title": "绑定手机号",
      "settings_page_phone_modal_desc": "我们将向你发送一条含 6 位验证码的短信。",
      "settings_page_phone_modal_placeholder": "请输入手机号",
      "settings_page_phone_modal_send_button": "发送验证码",
      "settings_page_phone_modal_code_desc": "请输入我们发送至以下号码的验证码",
      "settings_page_phone_modal_code_placeholder": "6 位验证码",
      "settings_page_phone_modal_verify_button": "验证",
      "settings_page_phone_invalid_error": "请输入有效的手机号。",
      "settings_page_phone_taken_error": "该手机号已被其他账号使用。",
      "settings_page_phone_code_invalid_error": "请输入 6 位验证码。",
      "settings_page_phone_link_success_toast": "手机号绑定成功",
      "settings_page_phone_link_fail_toast": "手机号绑定失败",
      "time_well_spent_modal_title": "屏幕时间提醒",
      "time_well_spent_modal_body": "你已连续浏览 %1$s 分钟，休息一下吧？",
      "time_well_spent_modal_dismiss_button": "继续浏览",
      "add_contact_page_invite_friend_channel_other": "分享链接到其他APP",
      "add_contact_search_page_no_result_alert_title": "没有找到相关的结果，请检查您的输入是否正确，再次重试",
      "add_contact_search_page_search_bar_hint_phone_and_id": "搜索手机号或用户名",
      "add_featured_group_success": "添加 %1$s 已成功",
      "alert_add_private_group_member_message": "他们将能看到这个群组。此操作无法撤销。",
      "alert_add_private_group_member_title": "将成员加入此私密群组？",
      "alert_comment_remove_gif": "消除GIF动图，并保留文字评论",
      "alert_decline_contact_request_title": "拒绝此联系人请求？",
      "alert_erase_voice_note_title": "删除这段语音？",
      "alert_leave_group": "如果你退出群组，你将不能参与聊天并会丢失所有的历史消息。",
      "alert_logout": "如果你退出登录，你需要使用同一封电子邮件来从新登录。",
      "alert_post_erase_group": "这个内容将会从你和所有群组成员中消除。",
      "alert_post_featured_group": "对于所有群员，这个内容将会突出显示。当新群员加入，这个内容将会送到新群员的收件箱。",
      "alert_post_remove_group": "这个内容将会从你和所有群组成员中移除。群成员将会看到一条通知。",
      "alert_post_set_as_first_group": "当新群员加入，这个内容将会排在收件箱的第一位。\n",
      "alert_post_un_featured_group": "这个内容将不会突出显示，也不会送到新群员的收件箱。",
      "alert_refuse_join_group_request_title": "拒绝此加群请求？",
      "alert_remove_featured_group": "如果你将 %1$s 从关联群组中移除，该群组将不会在群组简介页面显示。",
      "alert_remove_group_member": "如果你移除了群成员，被移除的成员将无法再访问群组。",
      "app_level_prompt_to_promote_offline_activity_description": "SELECT不通过广告盈利，也不希望让用户沉溺于无意义的内容黑洞——我们知道你时间宝贵。",
      "app_level_prompt_to_promote_offline_activity_leave_app_btn": "关闭应用",
      "app_level_prompt_to_promote_offline_activity_snooze_btn": "再看 %1$s 分钟",
      "chat_settings_page_group_cover_photo_remove_title": "删除背景图",
      "chat_settings_page_group_cover_photo_update_title": "更新背景图",
      "chat_settings_page_group_id_already_exits_alert_title": "此群ID已被使用，请试试其他ID",
      "chat_settings_page_group_id_invalid_alert_title": "群ID格式不正确",
      "chat_settings_page_group_id_picker_page_selector_error": "群ID只能包含字母、数字与下划线,且长度应该在3至15位数之间",
      "chat_settings_page_group_invalid_users_alert": "无法选择该用户",
      "chat_settings_page_group_leave_group_alert_title": "确认退出群组？",
      "chat_settings_page_group_nav_title": "群消息设置",
      "chat_settings_page_private_nav_title": "创建群聊",
      "chat_settings_remove_group_admin_nav_title": "移除管理员",
      "connections_count": "联系人",
      "contacts_empty_subtitle": "添加联系人后将在此显示。",
      "contacts_section_contact_requests": "联系人请求",
      "contacts_section_group_requests": "加群请求",
      "conversation_page_nav_title": "对话",
      "choose_conversation": "选择对话",
      "create_image_post_page_text_input_hint": "说说你的想法...",
      "create_image_post_page_title": "图片帖子",
      "create_link_post_page_fetch_button": "显示链接预览",
      "create_link_post_page_link_description_input_hint": "输入链接描述（可不填）",
      "create_link_post_page_link_input_hint": "输入网址或搜索关键词",
      "create_link_post_page_link_input_title": "链接或搜索关键词",
      "create_link_post_page_search_button": "搜索网络",
      "create_link_post_page_search_in_clipboard": "从剪贴板中查找链接",
      "create_message_post_page_nav_title": "新帖子",
      "create_poll_post_page_add_poll_option_title": "添加选项",
      "create_poll_post_page_description_input_title": "写一个投票主题",
      "create_poll_post_page_poll_limit_reached_alert": "只可添加 %1$s 个选项， 请取消一个后再次尝试",
      "create_poll_post_page_poll_option_section_title": "在下面添加选项",
      "create_post_posting_turned_off_toast": "发布功能已关闭",
      "cross_mention_hint": "从",
      "drafts_panel_on_post": "帖子",
      "empty_featured_group": "关联群组是什么？当群主，你可以向群成员推荐其他相关的群组，并将会展示在这里。点击以上的加号键，即可选择群组。",
      "featured_group_create_alert_title": "添加关联群组？",
      "featured_group_input_placeholder": "输入群组名称",
      "featured_group_open_alert_remove_option": "移除关联群组",
      "general_accept_btn": "通过",
      "general_decline_btn": "拒绝",
      "general_minute_plural": "分钟",
      "general_next_btn": "下一步",
      "general_no_result": "无结果",
      "general_ok_btn": "确认",
      "general_or_label": "或",
      "general_search_btn": "搜索",
      "general_sent_btn": "已发送",
      "general_skip_btn": "跳过",
      "general_share_btn": "分享",
      "http_cancel_error": "请求已被取消",
      "http_client_error": "啊，发生了一些未知的错误。",
      "http_connection_error": "出错了，请保证你的设备网络连接稳定。",
      "http_network_error": "出错了，请检查你的网络连接。",
      "http_server_error": "服务器无响应，请稍后再试",
      "http_timeout_error": "网络连接缓慢，请稍后再试",
      "http_unknown_error": "未知错误",
      "image_picker_albums_btn": "手机相册",
      "image_picker_alert_upload_media_size_too_big": "媒体尺寸过大，请重新选择",
      "image_picker_camera_btn": "相机",
      "image_picker_web_search_btn": "搜索网络图片",
      "image_upload_file_size_too_big": "图片过大， 请上传有效的图片",
      "inbox_page_group_request_activity_one_liner": "想要加入 %1$s 群",
      "inbox_page_post_sending_status_bar_failed_text": "内容发送失败，重试？",
      "inbox_page_zero_view_image_1": "https://cloudfront-stg.selectdc1.com/b3dee462-703a-11eb-b546-1ec2622942d4.png",
      "inbox_page_zero_view_image_2": "https://cloudfront-stg.selectdc1.com/1b84d351-7033-11eb-b546-1ec2622942d4.png",
      "inbox_page_zero_view_image_3": "https://cloudfront-stg.selectdc1.com/294025d2-7033-11eb-b546-1ec2622942d4.png",
      "inbox_unsnooze_all_toast": "已暂停的内容已回到收件箱",
      "increment_swipe_bottom_toast": "内容已暂停30分钟",
      "increment_swipe_left_toast": "内容已移到 “历史”",
      "invalid_jwt_token": "失效的Token",
      "invitation_group_invite_selector_title": "群组邀请套餐",
      "join_group_requests_empty": "没有加群请求",
      "landing_page_contact_invitation": "邀请你加入SELECT！",
      "landing_page_group_invitation": "邀请你加入群组！",
      "landing_page_title": "不是所有人",
      "me_about_delete_account_confirm": "删除",
      "me_about_page_nav_title": "关于我们",
      "me_account_settings_page_about_email_us": "SELECT为你服务而不是广告。最小化的存储个人信息是为了你的权益。查看，删除或者修改你的个人信息，请发邮件",
      "me_account_settings_page_about_title": "关于我们",
      "me_account_settings_page_log_out_btn": "退出登录",
      "me_account_settings_page_time_well_spent_prompt_title": "待机状态提醒",
      "me_edit_profile_page_display_name_input_hint": "输入显示名称",
      "me_edit_profile_page_id_input_hint": "输入你的 Username",
      "me_push_notification_settings_page_nav_title": "消息提醒设置",
      "me_push_notification_settings_page_open_system_desc": "打开手机信息系统",
      "me_push_notification_settings_page_open_system_warning_desc": "信息在你手机系统关闭了",
      "me_push_notification_settings_page_option_always": "总是",
      "me_push_notification_settings_page_option_everytime": "即时提醒",
      "me_push_notification_settings_page_option_everytime_desc": "立刻说道所有的信息",
      "me_push_notification_settings_page_option_high_level_desc": "仅限于你特意关注的联系人和内容",
      "me_push_notification_settings_page_option_never": "不提醒",
      "me_push_notification_settings_page_option_never_desc": "从不收到信息",
      "me_push_notification_settings_page_option_once_per_hour": "每小时一次",
      "me_push_notification_settings_page_option_once_per_hour_desc": "仅限于一小时一次",
      "me_push_notification_settings_page_option_twice_per_day": "只在早上10点 & 晚上8点提醒",
      "me_push_notification_settings_page_option_twice_per_day_desc": "仅限于每天两次",
      "mfs_friend_selector_page_search_contact_input_hint": "搜索名字",
      "mfs_friend_selector_page_suggestion_list_title": "要不要也发给",
      "missing_field": "请填写所有必填项",
      "no_permission_for_this_action": "没有权限执行此操作",
      "onboarding_address_book_permission_priming_btn_not_now": "不，我暂时不想这么做",
      "onboarding_address_book_permission_priming_btn_yes": "好，打开通讯录权限",
      "onboarding_address_book_permission_priming_description": "SELECT需要获取你的联系人权限才能帮你找到你的好友。我们保证所有的信息都会受到保护，并且不会被用作其他用途。",
      "onboarding_address_book_permission_priming_nav_title": "添加联系人",
      "onboarding_address_book_permission_priming_title": "找到你的好友们",
      "onboarding_notification_settings_priming_description": "仅限于你特意关注的联系人和内容",
      "onboarding_notification_settings_priming_option_btn_high_signal_subtitle": "(仅限于联系人和我参与过的内容)",
      "onboarding_notification_settings_priming_option_btn_high_signal_title": "个人",
      "onboarding_notification_settings_priming_option_btn_never": "不提醒",
      "onboarding_notification_settings_priming_option_btn_once_per_hour": "每小时提醒",
      "onboarding_notification_settings_priming_option_btn_twice_per_day": "每天早10点和晚8点提醒",
      "onboarding_notification_settings_priming_title": "享受更少的提醒",
      "people_page_suggestion_hint_description_afternoon": "找找你此刻最想分享的人",
      "people_page_suggestion_hint_title_afternoon": "%1$s，下午好",
      "people_page_suggestion_hint_title_evening": "%1$s，晚上好",
      "people_page_suggestion_hint_title_morning": "%1$s，早上好",
      "post_detail_load_newer_comments_button": "加载更多评论",
      "relationship_not_pending": "联系人请求已失效",
      "remove_contact_fail_toast": "删除联系人失败",
      "remove_contact_success_toast": "联系人已删除",
      "remove_featured_group_success": "移除 %1$s 已成功",
      "select_inbox_group_request_text": "想要加入群组",
      "sent_empty": "没有已发出的请求",
      "share_content_page_nav_title": "分享内容",
      "share_content_url_copy_to_clipboard_toast_alert": "内容链接已复制到剪贴板",
      "sign_up_add_name_and_photo_page_name_input_description": "这将是你的 SELECT 联系人看到的名字",
      "sign_up_add_name_and_photo_page_name_input_hint": "你的名字",
      "sign_up_add_name_and_photo_page_nav_title": "设置名字和头像",
      "sign_up_create_email_page_error_email_existed": "邮件地址已被使用",
      "sign_up_create_select_id_page_error_id_existed": "抱歉，此ID已被使用",
      "sign_up_create_select_id_page_input_description_why_select_id": "设置你独一无二的用户名，让朋友能够搜到你",
      "sign_up_create_select_id_page_input_hint": "你的用户名",
      "sign_up_create_select_id_page_nav_title": "创建你的用户名",
      "sign_up_enter_gender_page_nav_title": "你的性别",
      "sign_up_enter_gender_page_options_description": "此选项可以随时在用户简介页面进行更改",
      "sign_up_enter_phone_number_page_error_invalid_phone_number": "请检查手机号输入是否正确",
      "sign_up_enter_phone_number_page_input_description_link_terms": "服务条件",
      "sign_up_enter_phone_number_page_input_error": "SELECT重视你的隐私，继续之前请在确认框里打勾",
      "sign_up_invitation_expired": "邀请已过期，请联系邀请你的人跟进",
      "sign_up_invitation_under_review": "邀请在审核中，请联系邀请你的人跟进",
      "sign_up_invitation_was_reported": "邀请已被举报，请联系邀请你的人跟进",
      "sign_up_invite_gate_checking_title": "正在检查邀请",
      "sign_up_invite_gate_checking_body": "先查找链接，再显示其他内容。",
      "sign_up_invite_gate_ask_title": "你有邀请链接吗？",
      "sign_up_invite_gate_ask_yes": "有，我有一个",
      "sign_up_invite_gate_ask_yes_caption": "我现在去打开",
      "sign_up_invite_gate_ask_no": "还没有",
      "sign_up_invite_gate_ask_no_caption": "我没有链接",
      "sign_up_invite_gate_find_title": "找到你的邀请",
      "sign_up_invite_gate_find_body": "点开邀请链接",
      "sign_up_invite_gate_find_body_detail": "它会打开这个应用，我们会先检查链接，再显示其他内容。",
      "sign_up_invite_gate_find_email": "打开邮件或短信",
      "sign_up_invite_gate_find_email_detail": "在那里找到邀请链接。",
      "sign_up_invite_gate_find_paste": "粘贴链接",
      "sign_up_invite_gate_find_paste_detail": "把它粘贴到下方输入框。",
      "sign_up_invite_gate_find_placeholder": "粘贴你的邀请链接",
      "sign_up_invite_gate_find_invalid": "这看起来不是邀请链接。",
      "sign_up_invite_gate_find_none": "我其实没有链接",
      "sign_up_invite_gate_need_title": "加入需要邀请",
      "sign_up_invite_gate_need_body": "这个社群仅限邀请加入。请让邀请你的人发一个链接。",
      "sign_up_invite_gate_need_member_note": "已经是成员？请用已有账号登录。",
      "sign_up_invite_gate_load_failed_title": "无法加载这个邀请",
      "sign_up_invite_gate_load_failed_body": "我们有这个链接，但没能加载这个社群。请在这里重试。",
      "sign_up_invite_gate_not_carried_title": "我们无法使用这个邀请",
      "sign_up_invite_gate_not_carried_invited": "如果你收到了邀请，请在这台手机上打开邮件，并用系统默认浏览器打开，不要用应用内浏览器。",
      "sign_up_invite_gate_not_carried_uninvited": "如果你没有收到邀请，需要一位成员邀请你。如果已有账号，请登录。",
      "sign_up_invite_gate_expired_title": "邀请已过期",
      "sign_up_invite_gate_expired_body": "请让邀请你的人再发一个新链接。",
      "sign_up_invite_gate_expired_member_note": "已经有账号？请用受邀的那个账号登录。",
      "sign_up_landing_screen_no_invitation_join_waitlist_option": "加入等待名单",
      "sign_up_landing_screen_no_invitation_login_option": "会员登录",
      "sign_up_landing_screen_no_invitation_other_title": "或者",
      "sign_up_landing_screen_no_invitation_title": "欢迎你",
      "sign_up_landing_screen_no_invitation_title_2": "- 你我相遇，足见你的与众不同",
      "sign_up_landing_screen_no_invitation_title_3": "加入你的专属社群，只剩最后一步",
      "sign_up_landing_screen_no_invitation_title_4": "打开你的email邮箱，点击 \"Join\" 键",
      "sign_up_set_pwd_page_input_description_pwd_error": "密码必须是6到16位，且只能包含字母、数字和特殊字符:@#$%^&*",
      "sign_up_too_many_attempt_to_validate_phone_number": "验证码不正确，30秒钟后请重试",
      "swipeable_inbox_tooltip_text_snooze": "双击显示暂停的内容",
      "update_forced_pop_up_title": "请升级到新版本",
      "update_notice_pop_up_dismiss_btn": "3天后再提醒我",
      "update_notice_pop_up_title": "新版本发布了！",
      "update_pop_up_btn": "立即升级",
      "update_profile_picture_dialog_title": "设置群组头像",
      "update_profile_picture_image_source_option_album": "从相册中选择",
      "user_profile_page_accept_request_btn": "通过请求",
      "user_profile_page_toast_group_id_copied": "群 !D 已复制",
      "user_profile_page_toast_group_url_copied": "社区网页链接已复制",
      "user_profile_settings_delete_contact_alert_title": "确定删除联系人吗？",
      "web_image_search_page_image_type_tab_gif": "GIF动图",
      "web_image_search_page_image_type_tab_image": "图片",
      "web_image_search_page_search_bar_hint": "搜索网络图片",
      "auth_email_link_expired_title": "此链接无法使用",
      "auth_email_link_expired_body": "此“启动并加入”链接已过期或已被使用。请输入邮件中的验证码以继续。",
      "auth_email_link_unavailable_title": "无法验证你的邮箱",
      "auth_email_link_unavailable_body": "验证链接没有完成。请检查网络后重试，或输入邮件中的验证码。",
      "auth_email_link_enter_code": "输入验证码",
      "auth_email_link_back": "返回登录",
      "product_website_brand_wordmark": "SELECT",
      "product_website_skip_to_content": "跳到内容",
      "product_website_nav_communities": "社区",
      "product_website_cta_start_community": "创建一个社区",
      "product_website_cta_browse_communities": "浏览社区",
      "product_website_hero_title": "你的人，就在%1$s。",
      "product_website_hero_title_accent": "这里",
      "product_website_hero_sub": "在 SELECT，你的群聊长大成家——为真实的伙伴准备的真实社区，远离信息流。",
      "product_website_hero_mock_aria": "三台手机展示 SELECT 上的社区",
      "product_website_build_kicker": "看一个社区被建成",
      "product_website_build_title": "一句话，得到一个完整的家。",
      "product_website_build_chip_no_templates": "无需模板",
      "product_website_build_chip_no_wizard": "无需设置向导",
      "product_website_build_chip_60_seconds": "约 60 秒",
      "product_website_build_you_type": "你输入",
      "product_website_build_select_builds": "SELECT 构建",
      "product_website_build_caption": "示例输出——仅作演示",
      "product_website_build_aria": "示意图——一句话提示生成一个品牌社区",
      "product_website_build_preset_1_prompt": "一个属于好奇心灵的知识交流社区",
      "product_website_build_preset_1_name": "马尼拉夜跑团",
      "product_website_build_preset_1_tagline": "夜幕下奔跑这座城市",
      "product_website_build_preset_2_prompt": "一个帮助大家睡得更好的社区",
      "product_website_build_preset_2_name": "读完俱乐部",
      "product_website_build_preset_2_tagline": "一次一本，真的读完",
      "product_website_build_preset_3_prompt": "一个不只聊电影的影视俱乐部",
      "product_website_build_preset_3_name": "焊锡与正弦",
      "product_website_build_preset_3_tagline": "老合成器，新生命",
      "product_website_build_preset_4_prompt": "一个关注 SpaceX 每次发射的粉丝社区",
      "product_website_build_preset_4_name": "工作室信号",
      "product_website_build_preset_4_tagline": "我们设计团队的私密空间",
      "product_website_spine_kicker": "你能得到什么",
      "product_website_spine_title": "一个真正像“地方”的地方。",
      "product_website_spine_sub": "不是让你陷进去的信息流，而是你可以走进、离开、再回来的社区。",
      "product_website_spine_station_1_title": "对话不散架",
      "product_website_spine_station_1_body": "回复始终挂在它回应的内容下，一个月前的对话依然能从头读到尾。",
      "product_website_spine_station_2_title": "你可以只说给一个人听",
      "product_website_spine_station_2_body": "私密回复就落在对话里，只有当事人可见。",
      "product_website_spine_station_3_title": "它带着你的名字去到每个平台",
      "product_website_spine_station_3_body": "同一个品牌社区横跨 Web、iOS 和 Android——永远不会被压平进别人的时间线。",
      "product_website_spine_thread_author": "Dee L.",
      "product_website_spine_thread_when": "5 周前",
      "product_website_spine_thread_post": "修好了持续音机架——三台振荡器，和一位耐心的邻居。",
      "product_website_spine_thread_reply": "今天刷到这个，一字不落地读完了。",
      "product_website_spine_private_label": "私密回复 · 只有 %1$s 能看到",
      "product_website_spine_private_to": "Maya",
      "product_website_spine_private_text": "周五把那幅海港作品带来吧。那是你最好的作品，你却一直藏着。",
      "product_website_spine_chip_1": "Switchback",
      "product_website_spine_chip_2": "Ronin",
      "product_website_spine_chip_3": "Analog Drift",
      "product_website_communities_kicker": "此刻开放",
      "product_website_communities_title": "社区已经热聊起来了。",
      "product_website_communities_browse_all": "浏览全部",
      "product_website_common_members": "%1$s 位成员",
      "product_website_community_card_aria": "%1$s——SELECT 上的社区",
      "product_website_seo_title": "SELECT——你的人，就在这里",
      "product_website_seo_description": "在 SELECT，你的群聊长大成家——为真实的伙伴准备的真实社区，远离信息流。免费开始，约一分钟建成，永无广告。",
      "product_website_go_to_app": "打开 SELECT",
      "product_website_store_app_store": "App Store",
      "product_website_store_google_play": "Google Play",
      "product_website_get_app_kicker": "随身携带",
      "product_website_get_app_title": "你的社区，装进口袋。",
      "product_website_get_app_sub": "同一个品牌社区横跨 Web、iOS 和 Android——免费，无广告。",
      "product_website_store_download_on": "下载于",
      "product_website_store_get_it_on": "下载于",
      "product_website_cta_title": "用一句话描述你的社区。",
      "product_website_cta_sub": "免费开始，约一分钟建成，永无广告。",
      "product_website_footer_terms": "服务条款",
      "product_website_footer_legal_line": "© %1$s SELECT，保留所有权利。"
    }
  },
  "keys": [
    "general_conversations",
    "general_privacy",
    "general_report",
    "general_terms",
    "general_loading",
    "general_contacts",
    "general_featured_groups",
    "general_edit",
    "general_discard_btn",
    "general_save_btn",
    "general_ok",
    "general_submit_btn",
    "general_cancel_btn",
    "general_bio",
    "general_join_with_google",
    "general_processing",
    "general_uploading",
    "general_upload",
    "general_confirm",
    "general_remove",
    "general_delete",
    "general_update",
    "general_continue",
    "general_female_gender",
    "general_male_gender",
    "general_prefer_not_to_say_gender",
    "general_birthday",
    "general_done",
    "general_home",
    "general_profile",
    "general_user_profile",
    "general_account",
    "general_legal",
    "general_logout",
    "general_back",
    "general_private_conversation",
    "general_inbox",
    "general_delete_account",
    "general_send_post",
    "general_add",
    "general_insert",
    "general_all_btn",
    "general_curated_btn",
    "general_none_btn",
    "general_sending_post",
    "general_cancel_sending_post",
    "general_sending_comment",
    "general_cancel_sending_comment",
    "general_erase",
    "general_retry",
    "general_confirmation_modal_sr_label",
    "general_search_placeholder",
    "get_app",
    "auth_modal_powered_by",
    "auth_modal_close_aria_label",
    "auth_modal_desc",
    "auth_modal_download_app",
    "auth_modal_continue_app",
    "auth_modal_continue_web",
    "auth_modal_inapp_title_android",
    "auth_modal_inapp_title_ios",
    "auth_modal_inapp_desc_android",
    "auth_modal_inapp_desc_ios",
    "auth_modal_inapp_step_1",
    "auth_modal_inapp_step_1_highlight",
    "auth_modal_inapp_step_2",
    "auth_modal_inapp_step_2_highlight_android",
    "auth_modal_inapp_step_2_highlight_ios",
    "auth_modal_inapp_copy_link",
    "auth_modal_inapp_copy_link_success_toast",
    "auth_modal_inapp_copy_link_fail_toast",
    "auth_modal_inapp_continue",
    "login_heading",
    "login_google_title",
    "login_btn",
    "login_phone_invalid",
    "login_phone_placeholder",
    "login_separator",
    "login_otp_heading",
    "login_otp_btn",
    "login_otp_resend_label",
    "login_otp_sent",
    "login_otp_not_received_label",
    "login_otp_resend_after",
    "login_phone_no_not_registered_toast",
    "lp_login_email_code_label",
    "lp_login_email_code_placeholder",
    "lp_about",
    "email_hint_collapsed_ms",
    "email_hint_collapsed_yahoo",
    "email_hint_collapsed_gmail",
    "email_hint_collapsed_zoho",
    "email_hint_collapsed_apple",
    "email_hint_collapsed_other",
    "email_hint_ms_title",
    "email_hint_ms_body",
    "email_hint_yahoo_title",
    "email_hint_yahoo_body",
    "email_hint_gmail_title",
    "email_hint_gmail_body",
    "email_hint_zoho_title",
    "email_hint_zoho_body",
    "email_hint_apple_title",
    "email_hint_apple_body",
    "email_hint_other_title",
    "email_hint_other_body",
    "connection_lost_title",
    "connection_lost_description",
    "connection_lost_reassurance",
    "connection_lost_reconnect_btn",
    "post_detail_embed_link",
    "post_detail_embed_link_copied",
    "post_detail_comment_delete_sure_1",
    "post_detail_comment_delete_sure_2",
    "post_detail_comment_media_restore_fail_toast",
    "post_detail_one_liner_receive_private_image_post",
    "post_detail_one_liner_receive_and_send_group_image_post",
    "post_detail_meta_description_type_image_post",
    "post_detail_one_liner_send_private_image_post_singular",
    "post_detail_one_liner_send_private_image_post_plural",
    "post_detail_one_liner_receive_private_link_post",
    "post_detail_one_liner_receive_and_send_group_link_post",
    "post_detail_meta_description_type_link_post",
    "post_detail_one_liner_send_private_link_post_singular",
    "post_detail_one_liner_send_private_link_post_plural",
    "post_detail_one_liner_receive_private_poll_post",
    "post_detail_one_liner_receive_and_send_group_poll_post",
    "post_detail_meta_description_type_poll_post",
    "post_detail_one_liner_send_private_link_poll_singular",
    "post_detail_one_liner_send_private_link_poll_plural",
    "post_detail_one_liner_receive_private_text_message_post",
    "post_detail_one_liner_receive_and_send_group_text_message_post",
    "post_detail_one_liner_send_private_text_message_post_singular",
    "post_detail_one_liner_send_private_text_message_post_plural",
    "post_detail_one_liner_receive_private_voice_message_post",
    "post_detail_one_liner_receive_and_send_group_voice_message_post",
    "post_detail_one_liner_send_private_voice_message_post_singular",
    "post_detail_one_liner_send_private_voice_message_post_plural",
    "post_detail_one_liner_receive_private_gif_message_post",
    "post_detail_one_liner_receive_and_send_group_gif_message_post",
    "post_detail_one_liner_send_private_gif_message_post_singular",
    "post_detail_one_liner_send_private_gif_message_post_plural",
    "post_detail_one_liner_send_thread_post",
    "select-threader",
    "post_detail_reaction_sending_toast",
    "post_detail_reaction_sending_and_adding_friend_toast",
    "post_detail_section_relationship_not_accepted",
    "post_detail_reaction_sent_toast",
    "post_detail_reaction_fail_sender_is_not_contact_description",
    "post_detail_load_more_button",
    "post_detail_new_activity_button",
    "post_delete_sure_1",
    "post_delete_sure_2",
    "post_detail_comment_screenshot_event",
    "post_detail_post_screenshot_event",
    "post_detail_post_and_comment_screenshot_event",
    "post_detail_instant_gif_cross_mention_not_supported",
    "post_detail_quick_gif_fail_toast",
    "post_detail_quick_gif_generating",
    "post_detail_remove_link_preview_title",
    "post_detail_remove_link_preview_description",
    "post_detail_remove_media_title",
    "post_detail_remove_media_description",
    "post_detail_quote_jump_not_found",
    "cross_mention_title",
    "cross_mention_exposure_off_toast",
    "cross_mention_over_limit_toast",
    "cross_mention_limit_hint",
    "reply_comment_placeholder_text",
    "reply_comment_placeholder_gif",
    "reply_comment_placeholder_voice",
    "reply_comment_placeholder_image",
    "reply_comment_placeholder_media",
    "post_uploading_status_remaining",
    "post_uploading_status_done",
    "post_detail_content_unavailable",
    "post_detail_comment_blocked_content_unavailable_fail_toast",
    "post_detail_deletion_no_permission_fail_toast",
    "post_actions_menu_aria_label",
    "lp_heading",
    "lp_recent_popular_community_highlights",
    "lp_recent_popular_community_highlights_description",
    "lp_recent_popular",
    "lp_google_title",
    "lp_join_community",
    "lp_invited",
    "lp_embed_code_copied",
    "lp_footer_text",
    "lp_join_now",
    "lp_join_email",
    "lp_community_mail",
    "lp_invite_user",
    "lp_check_join_email",
    "lp_community_join_int",
    "lp_login_email_sent_toast",
    "lp_group_invitation",
    "lp_signup_need_community",
    "lp_signing_in",
    "lp_click_if_not_redirected",
    "lp_login_signup",
    "lp_not_found",
    "lp_applications_closed",
    "lp_link_expired",
    "lp_invitation_description",
    "lp_community_meta_description",
    "lp_login_signup_email_continue",
    "lp_login_signup_privacy",
    "lp_login_email_placeholder",
    "lp_login_signup_header",
    "lp_login_signup_or",
    "lp_login_signup_fallback_title",
    "lp_login_signup_email_check_inbox",
    "lp_login_signup_login_with",
    "lp_login_signup_continue_with",
    "lp_login_signup_verification_code",
    "lp_login_signup_verification_link",
    "lp_login_phone_verification_title",
    "lp_login_phone_verification_description",
    "lp_login_phone_placeholder",
    "lp_login_phone_send_code",
    "lp_login_phone_code_placeholder",
    "lp_login_phone_verify_code",
    "lp_login_phone_verification_sent",
    "lp_login_phone_verification_error",
    "lp_login_phone_code_invalid",
    "lp_login_phone_verification_sent_to",
    "lp_login_phone_china_info",
    "lp_login_birthday_title",
    "lp_login_birthday_description",
    "lp_login_birthday_required",
    "lp_login_birthday_age_restriction",
    "lp_login_birthday_privacy_note",
    "lp_preview_banner_text",
    "lp_guest_view_banner_text",
    "lp_guest_view_banner_link",
    "lp_login_otp_error_invalid_code",
    "lp_login_otp_error_too_many_attempts",
    "lp_login_otp_backoff_notice",
    "lp_login_otp_error_rate_limited",
    "lp_login_otp_error_generic",
    "lp_login_otp_resend_success_toast",
    "lp_login_birthday_update_fail_toast",
    "lp_login_birthday_update_fail_toast",
    "message_post_creation_panel_title",
    "message_post_creation_panel_one_liner",
    "message_post_creation_panel_add_message_hint",
    "message_post_creation_panel_send_post_hint",
    "message_post_creation_panel_attention_prompt_description",
    "post_detail_comment_discard_title",
    "post_detail_comment_discard_description",
    "post_detail_comment_resend_aria_label",
    "post_detail_comment_discard_aria_label",
    "post_detail_comment_quote_nav_aria_label",
    "post_detail_remove_media_aria_label",
    "post_detail_one_liner_receive_message_post",
    "post_detail_one_liner_send_message_post_singular",
    "post_detail_one_liner_send_message_post_plural",
    "post_detail_one_liner_receive_and_send_group_message_post",
    "post_detail_meta_description_type_message_post",
    "post_detail_one_liner_receive_and_send_group_thread_post",
    "chat_page_group_member_addition_rights",
    "chat_page_non_member_join_prompt_toast",
    "chat_settings_page_group_member_addition_rights_description",
    "chat_settings_page_group_share_to_public_alert_message",
    "chat_settings_page_group_show_history_alert_message",
    "chat_settings_page_group_identity_warning_title",
    "chat_settings_page_group_identity_warning_desc",
    "chat_settings_page_group_identity_warning_confirm",
    "error_general_alert_message",
    "general_error_title",
    "general_permission_required_title",
    "general_permission_required_photo_library",
    "general_permission_required_microphone",
    "general_unknown_user",
    "general_unknown_group",
    "me_accept_contact_fail_toast",
    "me_add_contact_fail_toast",
    "me_bio_update_fail_toast",
    "me_bio_update_success_toast",
    "me_decline_contact_fail_toast",
    "me_detail_update_fail_toast",
    "me_detail_update_success_toast",
    "me_profile_fetch_fail_toast",
    "me_relationship_failed_toast",
    "me_edit_profile_page_username_helper",
    "me_edit_profile_page_display_name_helper",
    "post_creation_error",
    "post_creation_successful",
    "post_deletion_error",
    "post_deletion_successful",
    "scraper_add_rss_feed_page_input_bar_error",
    "chat_page_nav_subtitle_network_unavailable",
    "chat_page_nav_subtitle_connecting",
    "chat_page_nav_subtitle_connected",
    "chat_page_nav_subtitle_connect_failed",
    "chat_page_text_more_option_erase_from_receiver",
    "chat_page_text_more_option_erase_from_all_receivers",
    "chat_page_text_more_option_erase_from_group",
    "chat_page_text_more_option_erase_from_conversation",
    "chat_page_text_more_option_removed_from_conversation",
    "chat_page_text_more_option_removed_from_group",
    "chat_page_text_more_option_set_as_first_post_group",
    "chat_page_text_more_option_featured_post_group",
    "chat_page_text_more_option_un_featured_post_group",
    "chat_page_text_more_option_erase_from_group_alert_message",
    "chat_page_text_more_option_removed_from_group_alert_message",
    "chat_page_text_more_option_removed_from_conversation_alert_message",
    "chat_page_text_more_option_featured_post_group_alert_message",
    "chat_page_text_more_option_un_featured_post_group_alert_message",
    "chat_page_text_more_option_set_as_first_post_group_alert_message",
    "chat_page_text_more_option_hide_alert_message",
    "comment_creation_error",
    "chat_page_group_featured_posts_load_fail_toast",
    "chat_page_group_featured_posts_remove_fail_toast",
    "chat_page_group_featured_posts_pin_fail_toast",
    "chat_page_group_featured_posts_feature_fail_toast",
    "featured_posts_page_empty_state",
    "featured_posts_page_actions_dialog_title",
    "featured_posts_page_remove_dialog_title",
    "featured_posts_page_remove_dialog_desc",
    "chat_page_text_more_option_copy_message",
    "chat_page_media_post_preview_default_text_image_singular",
    "chat_page_media_post_preview_default_text_image_plural",
    "chat_page_media_post_preview_default_text_video_singular",
    "chat_page_media_post_preview_default_text_video_plural",
    "chat_page_media_post_preview_default_text_files_plural",
    "chat_page_link_post_preview_default_text",
    "chat_page_poll_post_preview_default_text",
    "chat_page_input_bar_voice_toast_title_hint",
    "chat_page_input_bar_voice_toast_title_recording",
    "chat_page_input_bar_guggy_toast_title_generating",
    "chat_page_input_bar_guggy_toast_title_failed_generate_gif",
    "chat_page_input_bar_voice_and_guggy_toast_description_slide_up",
    "chat_page_input_bar_voice_and_guggy_cancel_toast_title",
    "chat_page_input_bar_voice_and_guggy_cancel_toast_description",
    "chat_page_event_post_disable_group",
    "chat_page_event_featured_by_user",
    "chat_page_event_featured_in_group",
    "chat_page_event_featured_in_group_no_mention",
    "chat_page_event_featured_group",
    "chat_page_event_join_private_conversation_general",
    "chat_page_event_join_group_general",
    "chat_page_event_add_group_admin",
    "chat_page_event_remove_group_admin",
    "chat_page_event_add_group_admin_for_new_admin",
    "chat_page_event_remove_group_admin_for_new_admin",
    "chat_page_event_add_group_admin_for_owner",
    "chat_page_event_remove_group_admin_for_owner",
    "chat_page_event_add_group_member_for_invitee",
    "chat_page_event_add_group_member_for_invitee_friends_only",
    "chat_page_event_add_group_member_for_invitee_single_friend_only",
    "chat_page_event_add_group_member_for_invitee_single",
    "chat_page_event_add_group_member_for_invitee_single_with_others",
    "chat_page_event_add_group_member_for_inviter",
    "chat_page_event_add_group_member_for_inviter_single",
    "chat_page_event_add_group_member_for_owner_only",
    "chat_page_event_add_group_member_for_no_inviter",
    "chat_page_event_add_group_member_for_no_inviter_single",
    "chat_page_event_add_group_member_for_not_inviter_or_invitee",
    "chat_page_event_add_group_member_for_not_inviter_or_invitee_single",
    "chat_page_event_remove_group_member_for_action_taker",
    "chat_page_event_remove_group_member_for_action_taker_single",
    "chat_page_event_remove_group_member_for_action_receiver",
    "chat_page_event_remove_group_member_for_group_member",
    "chat_page_event_remove_group_member_for_group_member_single",
    "chat_page_event_update_group_name_for_action_taker",
    "chat_page_event_update_group_name_for_action_receiver",
    "chat_page_event_update_group_description_for_action_taker",
    "chat_page_event_update_group_description_for_action_receiver",
    "chat_page_event_update_group_background_for_action_taker",
    "chat_page_event_update_group_background_for_action_receiver",
    "chat_page_event_update_group_id_for_action_taker",
    "chat_page_event_update_group_id_for_action_receiver",
    "chat_page_event_update_group_avatar_for_action_taker",
    "chat_page_event_update_group_avatar_for_action_receiver",
    "chat_page_event_update_group_owner_for_action_taker",
    "chat_page_event_update_group_owner_for_action_receiver",
    "chat_page_event_update_group_owner_for_action_passive",
    "chat_page_event_update_group_default_deeplink_for_action_taker",
    "chat_page_event_update_group_default_deeplink_for_action_receiver",
    "chat_page_event_update_group_show_history",
    "chat_page_event_update_group_share_to_public",
    "chat_page_event_screenshot_notice",
    "chat_page_event_new_contact_greeting",
    "chat_page_event_not_a_contact",
    "chat_page_event_content_erased_post_sender",
    "chat_page_event_content_erased_message_sender",
    "chat_page_event_content_erased_comment_sender",
    "chat_page_event_content_erased_post_owner",
    "chat_page_event_content_erased_message_owner",
    "chat_page_event_content_erased_comment_owner",
    "chat_page_event_content_erased_post_member",
    "chat_page_event_content_erased_message_member",
    "chat_page_event_content_erased_comment_member",
    "chat_page_event_new_member_invitation",
    "chat_page_event_new_member_invitation_single",
    "chat_page_event_user_is_banned",
    "chat_page_event_user_is_unbanned",
    "chat_page_event_user_is_appointed_admin",
    "chat_page_event_admin_is_discharged",
    "chat_page_group_featured_post_creator_title",
    "chat_page_group_featured_post_empty_notice",
    "chat_page_group_greeting_creator_title",
    "chat_page_group_greeting_creator_empty_notice",
    "chat_page_group_greeting_creator_prompt_description",
    "chat_page_group_greeting_disable_prompt_disable_btn",
    "chat_page_group_greeting_disable_prompt_erase_btn",
    "chat_page_group_greeting_warning_popup_content",
    "chat_page_group_greeting_warning_popup_warning",
    "chat_page_group_greeting_warning_popup_title",
    "chat_page_group_greeting_label",
    "chat_page_keep_group_history_warning_popup_post_title",
    "chat_page_keep_group_history_warning_popup_post_content",
    "chat_page_keep_group_history_warning_popup_comment_title",
    "chat_page_keep_group_history_warning_popup_comment_content",
    "chat_page_keep_group_history_warning_popup_warning",
    "chat_page_group_publishing_rules",
    "chat_page_group_publishing_rules_desc",
    "chat_page_group_publishing_rules_enable",
    "chat_page_group_publishing_rules_messages",
    "chat_page_group_limited_publishing_rules_messages_pop_up_description",
    "chat_page_group_show_history_rules",
    "chat_page_group_show_history_rules_desc",
    "chat_page_group_show_history_rules_on_toast",
    "chat_page_group_show_history_rules_enable",
    "chat_page_group_show_history_rules_disabled",
    "chat_page_group_share_to_public_rules",
    "chat_page_group_share_to_public_rules_desc",
    "chat_page_group_share_to_public_rules_on_toast",
    "chat_page_group_share_to_public_rules_enable",
    "chat_page_group_share_to_public_rules_disabled",
    "chat_page_group_cross_exposure_rules",
    "chat_page_group_cross_exposure_rules_desc",
    "chat_page_group_cross_exposure_rules_enable",
    "chat_page_group_cross_exposure_rules_disabled",
    "chat_page_group_adding_members_rules",
    "chat_page_group_adding_members_rules_desc",
    "chat_page_group_adding_members_rules_enable",
    "chat_page_group_permissions_section",
    "chat_page_group_admin_management",
    "chat_page_group_group_management",
    "chat_page_group_admin_management_owner_lable",
    "chat_page_group_admin_management_admin_lable",
    "chat_page_group_admin_management_add_admin_confirmation_title",
    "chat_page_group_admin_management_remove_admin_confirmation_title",
    "chat_page_group_admin_management_cta",
    "chat_page_group_limited_publishing_rules_pop_up_description",
    "chat_page_group_featured_post_creator_empty_tooltip",
    "chat_page_group_greeting_creator_empty_tooltip",
    "chat_page_group_feature_unavailable",
    "chat_page_message_input_bar_hint",
    "chat_page_group_ban_management_cta",
    "chat_page_group_ban_management",
    "chat_page_group_ban_management_ban_user_confirmation_title",
    "chat_page_group_ban_management_ban_user_ban_btn",
    "chat_page_group_ban_management_unban_user_confirmation_title",
    "chat_page_group_ban_management_ban_user_unban_btn",
    "chat_page_group_ban_management_page_cell_description",
    "chat_page_unread_messages",
    "chat_page_new_comments",
    "chat_page_load_previous_comments",
    "chat_page_comment_copy",
    "chat_page_posting_disabled_fail_toast",
    "chat_page_posting_disabled_draft_reason",
    "content_type_unsupported_preview",
    "people_page_chat_list_cell_preview_content_type_link",
    "please_wait_for_uploads",
    "people_page_chat_list_cell_preview_content_type_image",
    "people_page_chat_list_cell_preview_content_type_poll",
    "people_page_chat_list_cell_preview_content_type_gif",
    "people_page_chat_list_cell_preview_content_type_voice",
    "people_page_chat_list_cell_preview_content_type_thread",
    "people_page_filter_result_title_noresult",
    "post_detail_comment_page_nav_title",
    "post_detail_comment_page_request_to_join_to_comment_hint",
    "post_detail_comment_page_more_options_erase_from_all_receivers",
    "post_detail_comment_page_more_options_erase_comment",
    "post_detail_comment_page_more_options_report",
    "post_detail_comment_page_more_options_hide",
    "post_detail_comment_page_more_options_copy",
    "post_detail_comment_page_more_options_reply",
    "post_detail_comment_page_more_options_download",
    "post_detail_comment_page_more_options_change_random_gif",
    "post_detail_comment_page_more_options_change_search_gif",
    "post_detail_comment_page_more_options_erase_comment_alert_message",
    "post_detail_comment_page_more_options_remove_comment_alert_message",
    "post_detail_comment_page_more_options_hide_alert_message",
    "post_detail_comment_page_mute_group_notification_banner",
    "post_detail_comment_page_settings_options_mute_group_notification_toggle",
    "post_detail_comment_page_settings_options_leave_group_discussion_btn",
    "post_detail_comment_page_settings_options_leave_group_discussion_altert_title",
    "post_detail_comment_page_settings_options_leave_group_discussion_altert_leave_btn",
    "post_detail_comment_page_settings_options_leave_group_discussion_altert_stay_btn",
    "post_detail_comment_page_comment_empty_group_discussion",
    "post_detail_comment_page_comment_empty_private_conversation",
    "post_detail_comment_page_comment_empty_private_comment_contacts",
    "post_detail_comment_page_comment_empty_private_comment_non_contacts",
    "post_detail_comment_page_comment_empty_private_comment_pending",
    "post_detail_comment_page_comment_empty_one_to_many_private_comment",
    "post_detail_comment_page_comment_input_bar_hint_group_discussion",
    "post_detail_comment_page_comment_input_bar_hint_private_comment_to_all",
    "post_detail_comment_page_comment_input_bar_hint_private_comment_to_user",
    "post_detail_comment_page_comment_status_sending",
    "post_detail_comment_page_comment_status_fail_to_send",
    "post_detail_comment_page_comment_text_pull_to_post_detail",
    "post_detail_comment_page_comment_text_release_to_post_detail",
    "post_detail_poll_post_seo_description_above_five_comments",
    "post_detail_poll_post_seo_description_for_fewer_comments",
    "post_detail_default_seo_description_above_five_comments",
    "post_detail_default_seo_description_for_fewer_comments",
    "inbox_tab_select",
    "inbox_tab_new",
    "inbox_tab_history",
    "inbox_action_reaction_toast",
    "inbox_action_snooze_toast",
    "inbox_action_unsnooze_toast",
    "inbox_action_cancel_toast",
    "inbox_action_card_friend_request_title",
    "inbox_action_contact_request_badge",
    "inbox_page_zero_view_heading_1",
    "inbox_page_zero_view_body_text_top_1",
    "inbox_page_zero_view_body_text_bottom_1",
    "inbox_page_zero_view_heading_2",
    "inbox_page_zero_view_body_text_top_2",
    "inbox_page_zero_view_body_text_bottom_2",
    "inbox_page_zero_view_heading_3",
    "inbox_page_zero_view_body_text_top_3",
    "inbox_page_zero_view_body_text_bottom_3",
    "inbox_recall_snoozed_tooltip",
    "post_detail_download_process_send_request_pop_up_send_button",
    "post_detail_download_process_downloading_toast",
    "post_detail_download_process_downloading_toast_progress",
    "post_detail_download_process_downloaded_successfully_toast",
    "post_detail_download_process_download_failed_toast",
    "post_detail_download_process_download_cancelled_toast",
    "post_detail_event_user_requested_download",
    "post_detail_event_owner_allowed_download",
    "post_detail_event_user_downloaded_successfully_single",
    "post_detail_event_user_downloaded_image_comment_successfully_single",
    "post_detail_event_user_downloaded_video_successfully_single",
    "post_detail_event_user_downloaded_video_comment_successfully_single",
    "post_detail_event_user_downloaded_video_successfully",
    "post_detail_event_user_downloaded_video_comment_successfully",
    "post_detail_event_user_downloaded_files_successfully",
    "post_detail_event_user_downloaded_files_comment_successfully",
    "post_detail_event_user_downloaded_successfully",
    "post_detail_event_user_downloaded_image_comment_successfully",
    "change_vote",
    "post_detail_event_user_vote_event",
    "post_detail_event_user_change_vote_event",
    "post_detail_event_owner_featured_post",
    "post_detail_proactively_allow_download_pop_up_description",
    "post_detail_proactively_allow_download_pop_up_allow_btn",
    "post_detail_download_already_enabled_pop_up_description",
    "post_seen_all",
    "post_no_feed",
    "post_creation_successful",
    "post_creation_error",
    "post_deletion_successful",
    "post_deletion_error",
    "profile_filter_btn_default",
    "profile_filter_popup_gender_selector_btn_all",
    "profile_filter_popup_gender_selector_btn_female",
    "profile_filter_popup_gender_selector_btn_male",
    "profile_filter_popup_age_selector_text_all_age",
    "profile_filter_popup_age_selector_text_age_range",
    "profile_bio_not_set",
    "profile_cover_photo",
    "group_profile_no_group_available",
    "group_profile_copy_link",
    "group_profile_copy_link_success_toast",
    "group_profile_copy_link_fail_toast",
    "user_profile_no_group_available",
    "profile_seen_all_contacts",
    "profile_no_contacts",
    "profile_gender_not_set",
    "profile_delete_account_hint",
    "me_edit_profile_page_nav_title",
    "me_edit_profile_page_update_profile_picture_title",
    "me_edit_profile_page_display_name_title",
    "me_edit_profile_page_gender_title",
    "me_edit_profile_page_about_me_placeholder",
    "me_edit_profile_page_about_me_title",
    "me_edit_profile_page_id_title",
    "me_edit_profile_page_binded_account_title",
    "me_edit_profile_page_birthdate_title",
    "me_edit_profile_page_email_title",
    "me_edit_profile_page_email_not_available",
    "me_edit_profile_page_gender_options_female",
    "me_edit_profile_page_gender_options_male",
    "me_edit_profile_page_private_title",
    "me_edit_profile_page_username_invalid_id",
    "me_edit_profile_page_username_not_available",
    "me_edit_set_your_bio_title",
    "me_profile_fetch_fail_toast",
    "me_relationship_failed_toast",
    "me_bio_update_fail_toast",
    "me_bio_update_success_toast",
    "me_detail_update_success_toast",
    "me_detail_update_fail_toast",
    "universal_search_search_bar_hint_people",
    "universal_search_search_bar_hint_groups",
    "universal_search_search_bar_hint_content",
    "universal_search_result_contact_title",
    "universal_search_result_more_result_title",
    "universal_search_result_more_result_search_for",
    "universal_search_section_other_groups_title",
    "universal_search_result_groups_title",
    "universal_search_result_more_result_search_for_no_result_alert",
    "universal_search_empty_current_group",
    "universal_search_result_more_result_search_for_no_network",
    "universal_search_result_messages_title",
    "universal_search_result_posts_title",
    "universal_search_result_comments_title",
    "universal_search_type_selector_people",
    "universal_search_search_bar_hint_all_types",
    "universal_search_type_selector_all",
    "universal_search_type_selector_content",
    "universal_search_type_selector_groups",
    "universal_search_result_user_id_match",
    "universal_search_result_group_id_match",
    "group_forbidden_toast",
    "group_profile_page_nav_title",
    "group_profile_members",
    "group_profile_friends",
    "group_profile_members_count",
    "group_profile_friends_count",
    "group_profile_join",
    "group_profile_request_join",
    "group_profile_friends_sent",
    "group_profile_community_title",
    "group_profile_deliver_inbox_title",
    "group_profile_deliver_inbox_desc",
    "group_profile_deliver_inbox_desc_all",
    "group_profile_deliver_inbox_desc_select",
    "group_profile_deliver_inbox_desc_none",
    "group_profile_deliver_option_all",
    "group_profile_deliver_option_curated",
    "group_profile_deliver_option_none",
    "group_profile_start_conversation",
    "group_profile_members_and_contacts",
    "user_profile_page_toast_user_id_copied",
    "group_join_request_sent",
    "group_join_request_pending",
    "group_join_request_to_join",
    "group_join_request_approved",
    "group_join_request_declined",
    "group_join_request_wants_to_join",
    "group_join_request_empty",
    "group_join_requests_title",
    "group_join_request_accepted_description",
    "group_join_request_accepted_toast",
    "group_joining_confirmation",
    "group_permission_updated",
    "remove_contact",
    "remove_contact_sure_1",
    "remove_contact_sure_2",
    "remove",
    "pending_requests_title",
    "sent_requests_title",
    "add_contact_title",
    "contact_request_wants_to_add_subtitle",
    "contacts_view_tab_requests",
    "contacts_view_empty",
    "me_add_contact_rate_limit_toast",
    "me_add_contact_fail_toast",
    "me_accept_contact_fail_toast",
    "me_decline_contact_fail_toast",
    "erase_post",
    "erase_comment",
    "private_conversation_title",
    "private_conversation_footer",
    "private_conversation_no_posts",
    "private_conversation_box_singular",
    "private_conversation_sidebar_singular",
    "private_conversation_box_plural",
    "private_conversation_sidebar_plural",
    "invitation_qr_title",
    "invitation_store_title",
    "not_found_error_title",
    "not_found_error_desc",
    "not_found_error_go_home",
    "not_found_error_go_back",
    "not_found_no_public_landing_page_title",
    "not_found_no_public_landing_page_desc",
    "not_found_no_access_title",
    "not_found_no_access_desc",
    "not_found_cta_back_to_inbox",
    "not_found_cta_go_home",
    "cancel",
    "post_builder_tab_post_title",
    "post_builder_tab_blog_title",
    "post_builder_tab_poll_title",
    "post_builder_formatting_tooltip_align_left",
    "post_builder_formatting_tooltip_align_center",
    "post_builder_formatting_tooltip_align_right",
    "post_builder_formatting_tooltip_undo",
    "post_builder_formatting_tooltip_redo",
    "post_builder_formatting_tooltip_heading_options",
    "post_builder_formatting_tooltip_paragraph",
    "post_builder_formatting_tooltip_heading_one",
    "post_builder_formatting_tooltip_heading_two",
    "post_builder_formatting_tooltip_heading_three",
    "post_builder_formatting_tooltip_bold",
    "post_builder_formatting_tooltip_italic",
    "post_builder_formatting_tooltip_strikethrough",
    "post_builder_formatting_tooltip_list_bullet",
    "post_builder_formatting_tooltip_list_ordered",
    "post_builder_formatting_tooltip_blockquote",
    "post_builder_formatting_tooltip_code",
    "post_builder_formatting_tooltip_codeblock",
    "post_builder_formatting_tooltip_more_options",
    "post_builder_tooltip_insert_image",
    "post_builder_tooltip_insert_video",
    "post_builder_tooltip_insert_audio",
    "post_builder_tooltip_search_gif_or_image",
    "post_builder_media_search_modal_title",
    "post_builder_media_search_tab_gif_title",
    "post_builder_media_search_tab_image_title",
    "post_builder_media_search_input_gif_placeholder",
    "post_builder_media_search_input_image_placeholder",
    "post_builder_tooltip_link_add",
    "post_builder_tooltip_link_edit",
    "post_builder_tooltip_link_visit",
    "post_builder_tooltip_link_unset",
    "post_builder_link_input_label",
    "post_builder_link_text_input_label",
    "post_builder_link_input_invalid",
    "post_builder_link_insert_modal_title",
    "post_builder_link_update_modal_title",
    "post_builder_tooltip_link_remove_preview",
    "post_builder_link_loading_metadata_placeholder",
    "post_builder_poll_question_input_placeholder",
    "post_builder_poll_add_text_option_input_label",
    "post_builder_poll_add_text_option_input_placeholder",
    "post_builder_poll_add_text_option_input_command",
    "cookie_banner_title",
    "cookie_banner_description",
    "cookie_accept_all",
    "cookie_essential_only",
    "cookie_manage_preferences",
    "cookie_save_preferences",
    "cookie_preferences_title",
    "cookie_save_preferences",
    "cookie_usage_title",
    "cookie_usage_description",
    "cookie_necessary_title",
    "cookie_necessary_description",
    "cookie_analytics_title",
    "cookie_analytics_description",
    "cookie_preferences_link",
    "cookie_privacy_policy",
    "general_cookies",
    "drafts_panel_title",
    "drafts_panel_tab_failed",
    "drafts_panel_tab_unfinished",
    "drafts_panel_empty_state",
    "drafts_panel_failed_empty",
    "drafts_panel_unfinished_empty",
    "drafts_panel_type_comment",
    "drafts_panel_type_poll",
    "drafts_panel_embed_generic",
    "drafts_panel_media_label",
    "drafts_panel_poll_choice",
    "drafts_panel_poll_choices",
    "drafts_panel_empty_draft_preview",
    "draft_missing_attachment",
    "drafts_panel_refresh_aria_label",
    "drafts_panel_close_aria_label",
    "drafts_panel_erase_post_aria_label",
    "drafts_panel_unknown_group",
    "drafts_panel_discard_sure_1",
    "drafts_panel_discard_sure_2",
    "drafts_panel_resend_all",
    "drafts_panel_resend_all_toast",
    "group_creation_title",
    "group_creation_name_placeholder",
    "group_creation_avatar_upload_label",
    "group_creation_selected_count",
    "group_creation_empty_selection_hint",
    "group_creation_search_placeholder",
    "group_creation_create_button",
    "group_creation_cancel_button",
    "group_creation_min_members_hint",
    "group_creation_avatar_uploading_hint",
    "group_creation_empty_contacts_title",
    "group_creation_empty_contacts_cta",
    "group_creation_error_generic",
    "group_creation_avatar_upload_failed",
    "group_creation_success_toast",
    "group_creation_start_conversation_button",
    "group_creation_start_conversation_fail_toast",
    "sidebar_create_group_tooltip",
    "chat_settings_page_group_promote_admin_title",
    "chat_settings_page_group_promote_admin_desc",
    "chat_settings_page_group_demote_admin_title",
    "chat_settings_page_group_demote_admin_desc",
    "chat_settings_page_group_appoint_owner_btn",
    "chat_settings_page_group_appoint_owner_desc",
    "chat_settings_page_group_promote_alert_title",
    "chat_settings_page_group_promote_alert_desc",
    "chat_settings_page_group_demote_alert_title",
    "chat_settings_page_group_demote_alert_desc",
    "chat_settings_page_group_update_failed_toast",
    "chat_settings_page_group_remove_member_alert_title",
    "chat_settings_page_group_promote_member_confirm_label",
    "chat_settings_page_group_demote_member_confirm_label",
    "chat_settings_page_group_transfer_owner_confirm_label",
    "chat_settings_add_group_member_error",
    "chat_settings_page_group_leave_group_btn",
    "chat_settings_page_group_leave_group_alert_message",
    "chat_settings_page_group_leave_group_alert_confirm_btn",
    "chat_settings_add_group_member_nav_title",
    "chat_settings_page_group_remove_member_alert_message",
    "chat_settings_page_group_members_empty",
    "chat_settings_add_group_member_no_contacts",
    "chat_settings_add_group_member_confirm_btn",
    "chat_settings_page_group_owner_transfer_first_title",
    "chat_settings_page_group_owner_transfer_first_desc",
    "chat_settings_page_group_go_to_management_btn",
    "chat_settings_page_group_cover_photo_title",
    "chat_settings_page_featured_posts_btn",
    "chat_settings_page_group_name_update_success_toast",
    "chat_settings_page_group_name_update_fail_toast",
    "chat_settings_page_group_id_update_success_toast",
    "chat_settings_page_group_id_taken_toast",
    "chat_settings_page_group_id_update_fail_toast",
    "chat_settings_page_group_avatar_update_success_toast",
    "chat_settings_page_group_avatar_update_fail_toast",
    "chat_settings_page_group_bio_update_success_toast",
    "chat_settings_page_group_bio_update_fail_toast",
    "chat_settings_page_group_cover_photo_update_success_toast",
    "chat_settings_page_group_cover_photo_update_fail_toast",
    "chat_settings_page_group_edit_name_dialog_title",
    "chat_settings_page_group_edit_id_dialog_title",
    "chat_settings_page_group_id_helper",
    "chat_settings_page_group_members_load_fail_toast",
    "chat_settings_page_group_no_admins_to_demote",
    "chat_settings_page_role_changed_fail_toast",
    "chat_settings_page_promote_not_member_fail_toast",
    "chat_settings_page_demote_already_left_toast",
    "chat_settings_page_transfer_not_member_fail_toast",
    "chat_settings_page_remove_member_fail_toast",
    "chat_settings_page_leave_group_fail_toast",
    "group_settings",
    "profile_add_featured_group_title",
    "profile_search_groups_placeholder",
    "profile_no_groups_found",
    "profile_view_group_profile",
    "profile_remove_from_featured",
    "profile_remove_featured_group_title",
    "profile_remove_featured_group_desc",
    "profile_no_featured_groups_own",
    "profile_contacts_search_placeholder",
    "profile_contacts_search_clear_aria_label",
    "profile_contacts_empty_title",
    "profile_contacts_empty_desc",
    "profile_contacts_no_search_results",
    "profile_image_picker_title",
    "profile_image_picker_upload_tab",
    "profile_image_picker_image_tab",
    "profile_image_picker_gif_tab",
    "profile_image_picker_search_image_placeholder",
    "profile_image_picker_search_gif_placeholder",
    "profile_image_picker_drop_here",
    "profile_image_picker_drop_hint",
    "profile_image_picker_no_results",
    "profile_start_conversation",
    "profile_start_conversation_fail_toast",
    "profile_add_to_group_action",
    "profile_cancel_request",
    "profile_accept_request",
    "profile_add_contact",
    "profile_image_picker_upload_fail_toast",
    "scraper_source_list_title",
    "feed_type_selector_rss",
    "feed_type_selector_email",
    "scraper_source_list_empty_description",
    "scraper_source_list_limit_exceeded_popup_title",
    "scraper_source_list_rss_copied_toast",
    "scraper_source_list_unsubscribe_popup_title",
    "scraper_source_list_unsubscribe_popup_unsubscribe_btn",
    "scraper_group_member_perspective_pop_up_title",
    "scraper_group_member_perspective_pop_up_description",
    "scraper_add_rss_feed_page_title",
    "scraper_add_rss_feed_page_tip",
    "scraper_add_rss_feed_page_input_bar_hint",
    "scraper_add_rss_feed_page_validation_failed_alert",
    "scraper_add_email_feed_page_title",
    "scraper_add_email_feed_page_input_bar_hint",
    "scraper_add_email_error",
    "scraper_add_email_at_error",
    "scraper_add_email_star_error",
    "scraper_source_list_rss_copy_failed_toast",
    "scraper_add_feed_clear_input_aria_label",
    "scraper_source_list_action_failed_toast",
    "inapp_browser_prompt_title",
    "inapp_browser_prompt_desc",
    "inapp_browser_prompt_desc_ios",
    "inapp_browser_prompt_desc_android",
    "inapp_browser_prompt_open_button",
    "inapp_browser_prompt_dismiss_aria_label",
    "settings_page_title",
    "settings_page_about_section",
    "settings_page_email_row",
    "settings_page_email_not_linked",
    "settings_page_email_link_action",
    "settings_page_email_change_action",
    "settings_page_email_resend_action",
    "settings_page_email_pending_hint",
    "settings_page_phone_row",
    "settings_page_phone_not_linked",
    "settings_page_twitter_row",
    "settings_page_twitter_connect_action",
    "settings_page_version_label",
    "settings_page_email_modal_title",
    "settings_page_email_modal_desc",
    "settings_page_email_modal_change_warning",
    "settings_page_email_modal_placeholder",
    "settings_page_email_modal_send_button",
    "settings_page_email_invalid_error",
    "settings_page_email_taken_error",
    "settings_page_email_send_fail_toast",
    "settings_page_twitter_link_success_toast",
    "settings_page_twitter_link_fail_toast",
    "settings_page_delete_request_success_toast",
    "settings_page_delete_request_fail_toast",
    "settings_page_preferences_section",
    "settings_page_time_well_spent_row",
    "settings_page_time_well_spent_desc",
    "settings_page_time_well_spent_minutes",
    "settings_page_phone_link_action",
    "settings_page_phone_modal_title",
    "settings_page_phone_modal_desc",
    "settings_page_phone_modal_placeholder",
    "settings_page_phone_modal_send_button",
    "settings_page_phone_modal_code_desc",
    "settings_page_phone_modal_code_placeholder",
    "settings_page_phone_modal_verify_button",
    "settings_page_phone_invalid_error",
    "settings_page_phone_taken_error",
    "settings_page_phone_code_invalid_error",
    "settings_page_phone_link_success_toast",
    "settings_page_phone_link_fail_toast",
    "time_well_spent_modal_title",
    "time_well_spent_modal_body",
    "time_well_spent_modal_dismiss_button",
    "add_contact_page_invite_friend_channel_other",
    "add_contact_search_page_no_result_alert_title",
    "add_contact_search_page_search_bar_hint_phone_and_id",
    "add_featured_group_success",
    "alert_add_private_group_member_message",
    "alert_add_private_group_member_title",
    "alert_comment_remove_gif",
    "alert_decline_contact_request_title",
    "alert_erase_voice_note_title",
    "alert_leave_group",
    "alert_logout",
    "alert_post_erase_group",
    "alert_post_featured_group",
    "alert_post_remove_group",
    "alert_post_set_as_first_group",
    "alert_post_un_featured_group",
    "alert_refuse_join_group_request_title",
    "alert_remove_featured_group",
    "alert_remove_group_member",
    "app_level_prompt_to_promote_offline_activity_description",
    "app_level_prompt_to_promote_offline_activity_leave_app_btn",
    "app_level_prompt_to_promote_offline_activity_snooze_btn",
    "chat_settings_page_group_cover_photo_remove_title",
    "chat_settings_page_group_cover_photo_update_title",
    "chat_settings_page_group_id_already_exits_alert_title",
    "chat_settings_page_group_id_invalid_alert_title",
    "chat_settings_page_group_id_picker_page_selector_error",
    "chat_settings_page_group_invalid_users_alert",
    "chat_settings_page_group_leave_group_alert_title",
    "chat_settings_page_group_nav_title",
    "chat_settings_page_private_nav_title",
    "chat_settings_remove_group_admin_nav_title",
    "connections_count",
    "contacts_empty_subtitle",
    "contacts_section_contact_requests",
    "contacts_section_group_requests",
    "conversation_page_nav_title",
    "choose_conversation",
    "create_image_post_page_text_input_hint",
    "create_image_post_page_title",
    "create_link_post_page_fetch_button",
    "create_link_post_page_link_description_input_hint",
    "create_link_post_page_link_input_hint",
    "create_link_post_page_link_input_title",
    "create_link_post_page_search_button",
    "create_link_post_page_search_in_clipboard",
    "create_message_post_page_nav_title",
    "create_poll_post_page_add_poll_option_title",
    "create_poll_post_page_description_input_title",
    "create_poll_post_page_poll_limit_reached_alert",
    "create_poll_post_page_poll_option_section_title",
    "create_post_posting_turned_off_toast",
    "cross_mention_hint",
    "drafts_panel_on_post",
    "empty_featured_group",
    "featured_group_create_alert_title",
    "featured_group_input_placeholder",
    "featured_group_open_alert_remove_option",
    "general_accept_btn",
    "general_decline_btn",
    "general_minute_plural",
    "general_next_btn",
    "general_no_result",
    "general_ok_btn",
    "general_or_label",
    "general_search_btn",
    "general_sent_btn",
    "general_skip_btn",
    "general_share_btn",
    "http_cancel_error",
    "http_client_error",
    "http_connection_error",
    "http_network_error",
    "http_server_error",
    "http_timeout_error",
    "http_unknown_error",
    "image_picker_albums_btn",
    "image_picker_alert_upload_media_size_too_big",
    "image_picker_camera_btn",
    "image_picker_web_search_btn",
    "image_upload_file_size_too_big",
    "inbox_page_group_request_activity_one_liner",
    "inbox_page_post_sending_status_bar_failed_text",
    "inbox_page_zero_view_image_1",
    "inbox_page_zero_view_image_2",
    "inbox_page_zero_view_image_3",
    "inbox_unsnooze_all_toast",
    "increment_swipe_bottom_toast",
    "increment_swipe_left_toast",
    "invalid_jwt_token",
    "invitation_group_invite_selector_title",
    "join_group_requests_empty",
    "landing_page_contact_invitation",
    "landing_page_group_invitation",
    "landing_page_title",
    "me_about_delete_account_confirm",
    "me_about_page_nav_title",
    "me_account_settings_page_about_email_us",
    "me_account_settings_page_about_title",
    "me_account_settings_page_log_out_btn",
    "me_account_settings_page_time_well_spent_prompt_title",
    "me_edit_profile_page_display_name_input_hint",
    "me_edit_profile_page_id_input_hint",
    "me_push_notification_settings_page_nav_title",
    "me_push_notification_settings_page_open_system_desc",
    "me_push_notification_settings_page_open_system_warning_desc",
    "me_push_notification_settings_page_option_always",
    "me_push_notification_settings_page_option_everytime",
    "me_push_notification_settings_page_option_everytime_desc",
    "me_push_notification_settings_page_option_high_level_desc",
    "me_push_notification_settings_page_option_never",
    "me_push_notification_settings_page_option_never_desc",
    "me_push_notification_settings_page_option_once_per_hour",
    "me_push_notification_settings_page_option_once_per_hour_desc",
    "me_push_notification_settings_page_option_twice_per_day",
    "me_push_notification_settings_page_option_twice_per_day_desc",
    "mfs_friend_selector_page_search_contact_input_hint",
    "mfs_friend_selector_page_suggestion_list_title",
    "missing_field",
    "no_permission_for_this_action",
    "onboarding_address_book_permission_priming_btn_not_now",
    "onboarding_address_book_permission_priming_btn_yes",
    "onboarding_address_book_permission_priming_description",
    "onboarding_address_book_permission_priming_nav_title",
    "onboarding_address_book_permission_priming_title",
    "onboarding_notification_settings_priming_description",
    "onboarding_notification_settings_priming_option_btn_high_signal_subtitle",
    "onboarding_notification_settings_priming_option_btn_high_signal_title",
    "onboarding_notification_settings_priming_option_btn_never",
    "onboarding_notification_settings_priming_option_btn_once_per_hour",
    "onboarding_notification_settings_priming_option_btn_twice_per_day",
    "onboarding_notification_settings_priming_title",
    "people_page_suggestion_hint_description_afternoon",
    "people_page_suggestion_hint_title_afternoon",
    "people_page_suggestion_hint_title_evening",
    "people_page_suggestion_hint_title_morning",
    "post_detail_load_newer_comments_button",
    "relationship_not_pending",
    "remove_contact_fail_toast",
    "remove_contact_success_toast",
    "remove_featured_group_success",
    "select_inbox_group_request_text",
    "sent_empty",
    "share_content_page_nav_title",
    "share_content_url_copy_to_clipboard_toast_alert",
    "sign_up_add_name_and_photo_page_name_input_description",
    "sign_up_add_name_and_photo_page_name_input_hint",
    "sign_up_add_name_and_photo_page_nav_title",
    "sign_up_create_email_page_error_email_existed",
    "sign_up_create_select_id_page_error_id_existed",
    "sign_up_create_select_id_page_input_description_why_select_id",
    "sign_up_create_select_id_page_input_hint",
    "sign_up_create_select_id_page_nav_title",
    "sign_up_enter_gender_page_nav_title",
    "sign_up_enter_gender_page_options_description",
    "sign_up_enter_phone_number_page_error_invalid_phone_number",
    "sign_up_enter_phone_number_page_input_description_link_terms",
    "sign_up_enter_phone_number_page_input_error",
    "sign_up_invitation_expired",
    "sign_up_invitation_under_review",
    "sign_up_invitation_was_reported",
    "sign_up_invite_gate_checking_title",
    "sign_up_invite_gate_checking_body",
    "sign_up_invite_gate_ask_title",
    "sign_up_invite_gate_ask_yes",
    "sign_up_invite_gate_ask_yes_caption",
    "sign_up_invite_gate_ask_no",
    "sign_up_invite_gate_ask_no_caption",
    "sign_up_invite_gate_find_title",
    "sign_up_invite_gate_find_body",
    "sign_up_invite_gate_find_body_detail",
    "sign_up_invite_gate_find_email",
    "sign_up_invite_gate_find_email_detail",
    "sign_up_invite_gate_find_paste",
    "sign_up_invite_gate_find_paste_detail",
    "sign_up_invite_gate_find_placeholder",
    "sign_up_invite_gate_find_invalid",
    "sign_up_invite_gate_find_none",
    "sign_up_invite_gate_need_title",
    "sign_up_invite_gate_need_body",
    "sign_up_invite_gate_need_member_note",
    "sign_up_invite_gate_load_failed_title",
    "sign_up_invite_gate_load_failed_body",
    "sign_up_invite_gate_not_carried_title",
    "sign_up_invite_gate_not_carried_invited",
    "sign_up_invite_gate_not_carried_uninvited",
    "sign_up_invite_gate_expired_title",
    "sign_up_invite_gate_expired_body",
    "sign_up_invite_gate_expired_member_note",
    "sign_up_landing_screen_no_invitation_join_waitlist_option",
    "sign_up_landing_screen_no_invitation_login_option",
    "sign_up_landing_screen_no_invitation_other_title",
    "sign_up_landing_screen_no_invitation_title",
    "sign_up_landing_screen_no_invitation_title_2",
    "sign_up_landing_screen_no_invitation_title_3",
    "sign_up_landing_screen_no_invitation_title_4",
    "sign_up_set_pwd_page_input_description_pwd_error",
    "sign_up_too_many_attempt_to_validate_phone_number",
    "swipeable_inbox_tooltip_text_snooze",
    "update_forced_pop_up_title",
    "update_notice_pop_up_dismiss_btn",
    "update_notice_pop_up_title",
    "update_pop_up_btn",
    "update_profile_picture_dialog_title",
    "update_profile_picture_image_source_option_album",
    "user_profile_page_accept_request_btn",
    "user_profile_page_toast_group_id_copied",
    "user_profile_page_toast_group_url_copied",
    "user_profile_settings_delete_contact_alert_title",
    "web_image_search_page_image_type_tab_gif",
    "web_image_search_page_image_type_tab_image",
    "web_image_search_page_search_bar_hint",
    "auth_email_link_expired_title",
    "auth_email_link_expired_body",
    "auth_email_link_unavailable_title",
    "auth_email_link_unavailable_body",
    "auth_email_link_enter_code",
    "auth_email_link_back",
    "product_website_brand_wordmark",
    "product_website_skip_to_content",
    "product_website_nav_communities",
    "product_website_cta_start_community",
    "product_website_cta_browse_communities",
    "product_website_hero_title",
    "product_website_hero_title_accent",
    "product_website_hero_sub",
    "product_website_hero_mock_aria",
    "product_website_build_kicker",
    "product_website_build_title",
    "product_website_build_chip_no_templates",
    "product_website_build_chip_no_wizard",
    "product_website_build_chip_60_seconds",
    "product_website_build_you_type",
    "product_website_build_select_builds",
    "product_website_build_caption",
    "product_website_build_aria",
    "product_website_build_preset_1_prompt",
    "product_website_build_preset_1_name",
    "product_website_build_preset_1_tagline",
    "product_website_build_preset_2_prompt",
    "product_website_build_preset_2_name",
    "product_website_build_preset_2_tagline",
    "product_website_build_preset_3_prompt",
    "product_website_build_preset_3_name",
    "product_website_build_preset_3_tagline",
    "product_website_build_preset_4_prompt",
    "product_website_build_preset_4_name",
    "product_website_build_preset_4_tagline",
    "product_website_spine_kicker",
    "product_website_spine_title",
    "product_website_spine_sub",
    "product_website_spine_station_1_title",
    "product_website_spine_station_1_body",
    "product_website_spine_station_2_title",
    "product_website_spine_station_2_body",
    "product_website_spine_station_3_title",
    "product_website_spine_station_3_body",
    "product_website_spine_thread_author",
    "product_website_spine_thread_when",
    "product_website_spine_thread_post",
    "product_website_spine_thread_reply",
    "product_website_spine_private_label",
    "product_website_spine_private_to",
    "product_website_spine_private_text",
    "product_website_spine_chip_1",
    "product_website_spine_chip_2",
    "product_website_spine_chip_3",
    "product_website_communities_kicker",
    "product_website_communities_title",
    "product_website_communities_browse_all",
    "product_website_common_members",
    "product_website_community_card_aria",
    "product_website_seo_title",
    "product_website_seo_description",
    "product_website_go_to_app",
    "product_website_store_app_store",
    "product_website_store_google_play",
    "product_website_get_app_kicker",
    "product_website_get_app_title",
    "product_website_get_app_sub",
    "product_website_store_download_on",
    "product_website_store_get_it_on",
    "product_website_cta_title",
    "product_website_cta_sub",
    "product_website_footer_terms",
    "product_website_footer_legal_line"
  ]
}